(function webpackUniversalModuleDefinition(root, factory) {
  if (typeof exports === 'object' && typeof module === 'object') module.exports = factory(require("react"));else if (typeof define === 'function' && define.amd) define("ReactDropdownTreeSelect", ["react"], factory);else if (typeof exports === 'object') exports["ReactDropdownTreeSelect"] = factory(require("react"));else root["ReactDropdownTreeSelect"] = factory(root["React"]);
})(this, function (__WEBPACK_EXTERNAL_MODULE_react__) {
  return (
    /******/
    function (modules) {
      // webpackBootstrap

      /******/
      // The module cache

      /******/
      var installedModules = {};
      /******/

      /******/
      // The require function

      /******/

      function __webpack_require__(moduleId) {
        /******/

        /******/
        // Check if module is in cache

        /******/
        if (installedModules[moduleId]) {
          /******/
          return installedModules[moduleId].exports;
          /******/
        }
        /******/
        // Create a new module (and put it into the cache)

        /******/


        var module = installedModules[moduleId] = {
          /******/
          i: moduleId,

          /******/
          l: false,

          /******/
          exports: {}
          /******/

        };
        /******/

        /******/
        // Execute the module function

        /******/

        modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/

        /******/
        // Flag the module as loaded

        /******/

        module.l = true;
        /******/

        /******/
        // Return the exports of the module

        /******/

        return module.exports;
        /******/
      }
      /******/

      /******/

      /******/
      // expose the modules object (__webpack_modules__)

      /******/


      __webpack_require__.m = modules;
      /******/

      /******/
      // expose the module cache

      /******/

      __webpack_require__.c = installedModules;
      /******/

      /******/
      // define getter function for harmony exports

      /******/

      __webpack_require__.d = function (exports, name, getter) {
        /******/
        if (!__webpack_require__.o(exports, name)) {
          /******/
          Object.defineProperty(exports, name, {
            enumerable: true,
            get: getter
          });
          /******/
        }
        /******/

      };
      /******/

      /******/
      // define __esModule on exports

      /******/


      __webpack_require__.r = function (exports) {
        /******/
        if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
          /******/
          Object.defineProperty(exports, Symbol.toStringTag, {
            value: 'Module'
          });
          /******/
        }
        /******/


        Object.defineProperty(exports, '__esModule', {
          value: true
        });
        /******/
      };
      /******/

      /******/
      // create a fake namespace object

      /******/
      // mode & 1: value is a module id, require it

      /******/
      // mode & 2: merge all properties of value into the ns

      /******/
      // mode & 4: return value when already ns object

      /******/
      // mode & 8|1: behave like require

      /******/


      __webpack_require__.t = function (value, mode) {
        /******/
        if (mode & 1) value = __webpack_require__(value);
        /******/

        if (mode & 8) return value;
        /******/

        if (mode & 4 && typeof value === 'object' && value && value.__esModule) return value;
        /******/

        var ns = Object.create(null);
        /******/

        __webpack_require__.r(ns);
        /******/


        Object.defineProperty(ns, 'default', {
          enumerable: true,
          value: value
        });
        /******/

        if (mode & 2 && typeof value != 'string') for (var key in value) {
          __webpack_require__.d(ns, key, function (key) {
            return value[key];
          }.bind(null, key));
        }
        /******/

        return ns;
        /******/
      };
      /******/

      /******/
      // getDefaultExport function for compatibility with non-harmony modules

      /******/


      __webpack_require__.n = function (module) {
        /******/
        var getter = module && module.__esModule ?
        /******/
        function getDefault() {
          return module['default'];
        } :
        /******/
        function getModuleExports() {
          return module;
        };
        /******/

        __webpack_require__.d(getter, 'a', getter);
        /******/


        return getter;
        /******/
      };
      /******/

      /******/
      // Object.prototype.hasOwnProperty.call

      /******/


      __webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
      };
      /******/

      /******/
      // __webpack_public_path__

      /******/


      __webpack_require__.p = "";
      /******/

      /******/

      /******/
      // Load entry module and return exports

      /******/

      return __webpack_require__(__webpack_require__.s = "./src/index.js");
      /******/
    }(
    /************************************************************************/

    /******/
    {
      /***/
      "./node_modules/array.partial/index.js":
      /*!*********************************************!*\
        !*** ./node_modules/array.partial/index.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesArrayPartialIndexJs(module, exports, __webpack_require__) {
        "use strict";

        module.exports = function (arr, func) {
          var some = arr.filter(func);
          return some.length !== 0 && some.length !== arr.length;
        };
        /***/

      },

      /***/
      "./node_modules/classnames/bind.js":
      /*!*****************************************!*\
        !*** ./node_modules/classnames/bind.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesClassnamesBindJs(module, exports, __webpack_require__) {
        var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;
        /*!
        Copyright (c) 2017 Jed Watson.
        Licensed under the MIT License (MIT), see
        http://jedwatson.github.io/classnames
        */

        /* global define */


        (function () {
          'use strict';

          var hasOwn = {}.hasOwnProperty;

          function classNames() {
            var classes = [];

            for (var i = 0; i < arguments.length; i++) {
              var arg = arguments[i];
              if (!arg) continue;
              var argType = typeof arg;

              if (argType === 'string' || argType === 'number') {
                classes.push(this && this[arg] || arg);
              } else if (Array.isArray(arg)) {
                classes.push(classNames.apply(this, arg));
              } else if (argType === 'object') {
                for (var key in arg) {
                  if (hasOwn.call(arg, key) && arg[key]) {
                    classes.push(this && this[key] || key);
                  }
                }
              }
            }

            return classes.join(' ');
          }

          if (true && module.exports) {
            classNames.default = classNames;
            module.exports = classNames;
          } else if (true) {
            // register as 'classnames', consistent with npm package name
            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
              return classNames;
            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
          } else {}
        })();
        /***/

      },

      /***/
      "./node_modules/fbjs/lib/EventListener.js":
      /*!************************************************!*\
        !*** ./node_modules/fbjs/lib/EventListener.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibEventListenerJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * @typechecks
         */

        var emptyFunction = __webpack_require__(
        /*! ./emptyFunction */
        "./node_modules/fbjs/lib/emptyFunction.js");
        /**
         * Upstream version of event listener. Does not take into account specific
         * nature of platform.
         */


        var EventListener = {
          /**
           * Listen to DOM events during the bubble phase.
           *
           * @param {DOMEventTarget} target DOM element to register listener on.
           * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
           * @param {function} callback Callback function.
           * @return {object} Object with a `remove` method.
           */
          listen: function listen(target, eventType, callback) {
            if (target.addEventListener) {
              target.addEventListener(eventType, callback, false);
              return {
                remove: function remove() {
                  target.removeEventListener(eventType, callback, false);
                }
              };
            } else if (target.attachEvent) {
              target.attachEvent('on' + eventType, callback);
              return {
                remove: function remove() {
                  target.detachEvent('on' + eventType, callback);
                }
              };
            }
          },

          /**
           * Listen to DOM events during the capture phase.
           *
           * @param {DOMEventTarget} target DOM element to register listener on.
           * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
           * @param {function} callback Callback function.
           * @return {object} Object with a `remove` method.
           */
          capture: function capture(target, eventType, callback) {
            if (target.addEventListener) {
              target.addEventListener(eventType, callback, true);
              return {
                remove: function remove() {
                  target.removeEventListener(eventType, callback, true);
                }
              };
            } else {
              if (false) {}

              return {
                remove: emptyFunction
              };
            }
          },
          registerDefault: function registerDefault() {}
        };
        module.exports = EventListener;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/ExecutionEnvironment.js":
      /*!*******************************************************!*\
        !*** ./node_modules/fbjs/lib/ExecutionEnvironment.js ***!
        \*******************************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibExecutionEnvironmentJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */

        var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
        /**
         * Simple, lightweight module assisting with the detection and context of
         * Worker. Helps avoid circular dependencies and allows code to reason about
         * whether or not they are in a Worker, even if they never include the main
         * `ReactWorker` dependency.
         */

        var ExecutionEnvironment = {
          canUseDOM: canUseDOM,
          canUseWorkers: typeof Worker !== 'undefined',
          canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
          canUseViewport: canUseDOM && !!window.screen,
          isInWorker: !canUseDOM // For now, this is true - might change in the future.

        };
        module.exports = ExecutionEnvironment;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/containsNode.js":
      /*!***********************************************!*\
        !*** ./node_modules/fbjs/lib/containsNode.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibContainsNodeJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * 
         */

        var isTextNode = __webpack_require__(
        /*! ./isTextNode */
        "./node_modules/fbjs/lib/isTextNode.js");
        /*eslint-disable no-bitwise */

        /**
         * Checks if a given DOM node contains or is another DOM node.
         */


        function containsNode(outerNode, innerNode) {
          if (!outerNode || !innerNode) {
            return false;
          } else if (outerNode === innerNode) {
            return true;
          } else if (isTextNode(outerNode)) {
            return false;
          } else if (isTextNode(innerNode)) {
            return containsNode(outerNode, innerNode.parentNode);
          } else if ('contains' in outerNode) {
            return outerNode.contains(innerNode);
          } else if (outerNode.compareDocumentPosition) {
            return !!(outerNode.compareDocumentPosition(innerNode) & 16);
          } else {
            return false;
          }
        }

        module.exports = containsNode;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/emptyFunction.js":
      /*!************************************************!*\
        !*** ./node_modules/fbjs/lib/emptyFunction.js ***!
        \************************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibEmptyFunctionJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * 
         */

        function makeEmptyFunction(arg) {
          return function () {
            return arg;
          };
        }
        /**
         * This function accepts and discards inputs; it has no side effects. This is
         * primarily useful idiomatically for overridable function endpoints which
         * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
         */


        var emptyFunction = function emptyFunction() {};

        emptyFunction.thatReturns = makeEmptyFunction;
        emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
        emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
        emptyFunction.thatReturnsNull = makeEmptyFunction(null);

        emptyFunction.thatReturnsThis = function () {
          return this;
        };

        emptyFunction.thatReturnsArgument = function (arg) {
          return arg;
        };

        module.exports = emptyFunction;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/emptyObject.js":
      /*!**********************************************!*\
        !*** ./node_modules/fbjs/lib/emptyObject.js ***!
        \**********************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibEmptyObjectJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */

        var emptyObject = {};

        if (false) {}

        module.exports = emptyObject;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/focusNode.js":
      /*!********************************************!*\
        !*** ./node_modules/fbjs/lib/focusNode.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibFocusNodeJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */

        /**
         * @param {DOMElement} node input/textarea to focus
         */

        function focusNode(node) {
          // IE8 can throw "Can't move focus to the control because it is invisible,
          // not enabled, or of a type that does not accept the focus." for all kinds of
          // reasons that are too expensive and fragile to test.
          try {
            node.focus();
          } catch (e) {}
        }

        module.exports = focusNode;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/getActiveElement.js":
      /*!***************************************************!*\
        !*** ./node_modules/fbjs/lib/getActiveElement.js ***!
        \***************************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibGetActiveElementJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * @typechecks
         */

        /* eslint-disable fb-www/typeof-undefined */

        /**
         * Same as document.activeElement but wraps in a try-catch block. In IE it is
         * not safe to call document.activeElement if there is nothing focused.
         *
         * The activeElement will be null only if the document or document body is not
         * yet defined.
         *
         * @param {?DOMDocument} doc Defaults to current document.
         * @return {?DOMElement}
         */

        function getActiveElement(doc)
        /*?DOMElement*/
        {
          doc = doc || (typeof document !== 'undefined' ? document : undefined);

          if (typeof doc === 'undefined') {
            return null;
          }

          try {
            return doc.activeElement || doc.body;
          } catch (e) {
            return doc.body;
          }
        }

        module.exports = getActiveElement;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/invariant.js":
      /*!********************************************!*\
        !*** ./node_modules/fbjs/lib/invariant.js ***!
        \********************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibInvariantJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         */

        /**
         * Use invariant() to assert state which your program assumes to be true.
         *
         * Provide sprintf-style format (only %s is supported) and arguments
         * to provide information about what broke and what you were
         * expecting.
         *
         * The invariant message will be stripped in production, but the invariant
         * will remain to ensure logic does not differ in production.
         */

        var validateFormat = function validateFormat(format) {};

        if (false) {}

        function invariant(condition, format, a, b, c, d, e, f) {
          validateFormat(format);

          if (!condition) {
            var error;

            if (format === undefined) {
              error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
            } else {
              var args = [a, b, c, d, e, f];
              var argIndex = 0;
              error = new Error(format.replace(/%s/g, function () {
                return args[argIndex++];
              }));
              error.name = 'Invariant Violation';
            }

            error.framesToPop = 1; // we don't care about invariant's own frame

            throw error;
          }
        }

        module.exports = invariant;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/isNode.js":
      /*!*****************************************!*\
        !*** ./node_modules/fbjs/lib/isNode.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibIsNodeJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * @typechecks
         */

        /**
         * @param {*} object The object to check.
         * @return {boolean} Whether or not the object is a DOM node.
         */

        function isNode(object) {
          var doc = object ? object.ownerDocument || object : document;
          var defaultView = doc.defaultView || window;
          return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
        }

        module.exports = isNode;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/isTextNode.js":
      /*!*********************************************!*\
        !*** ./node_modules/fbjs/lib/isTextNode.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibIsTextNodeJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * @typechecks
         */

        var isNode = __webpack_require__(
        /*! ./isNode */
        "./node_modules/fbjs/lib/isNode.js");
        /**
         * @param {*} object The object to check.
         * @return {boolean} Whether or not the object is a DOM text node.
         */


        function isTextNode(object) {
          return isNode(object) && object.nodeType == 3;
        }

        module.exports = isTextNode;
        /***/
      },

      /***/
      "./node_modules/fbjs/lib/shallowEqual.js":
      /*!***********************************************!*\
        !*** ./node_modules/fbjs/lib/shallowEqual.js ***!
        \***********************************************/

      /*! no static exports found */

      /***/
      function node_modulesFbjsLibShallowEqualJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         *
         * @typechecks
         * 
         */

        /*eslint-disable no-self-compare */

        var hasOwnProperty = Object.prototype.hasOwnProperty;
        /**
         * inlined Object.is polyfill to avoid requiring consumers ship their own
         * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
         */

        function is(x, y) {
          // SameValue algorithm
          if (x === y) {
            // Steps 1-5, 7-10
            // Steps 6.b-6.e: +0 != -0
            // Added the nonzero y check to make Flow happy, but it is redundant
            return x !== 0 || y !== 0 || 1 / x === 1 / y;
          } else {
            // Step 6.a: NaN == NaN
            return x !== x && y !== y;
          }
        }
        /**
         * Performs equality by iterating through keys on an object and returning false
         * when any key has values which are not strictly equal between the arguments.
         * Returns true when the values of all keys are strictly equal.
         */


        function shallowEqual(objA, objB) {
          if (is(objA, objB)) {
            return true;
          }

          if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
            return false;
          }

          var keysA = Object.keys(objA);
          var keysB = Object.keys(objB);

          if (keysA.length !== keysB.length) {
            return false;
          } // Test for A's keys different from B.


          for (var i = 0; i < keysA.length; i++) {
            if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
              return false;
            }
          }

          return true;
        }

        module.exports = shallowEqual;
        /***/
      },

      /***/
      "./node_modules/memoize-one/dist/memoize-one.esm.js":
      /*!**********************************************************!*\
        !*** ./node_modules/memoize-one/dist/memoize-one.esm.js ***!
        \**********************************************************/

      /*! exports provided: default */

      /***/
      function node_modulesMemoizeOneDistMemoizeOneEsmJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var simpleIsEqual = function simpleIsEqual(a, b) {
          return a === b;
        };

        function index(resultFn) {
          var isEqual = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : simpleIsEqual;
          var lastThis = void 0;
          var lastArgs = [];
          var lastResult = void 0;
          var calledOnce = false;

          var isNewArgEqualToLast = function isNewArgEqualToLast(newArg, index) {
            return isEqual(newArg, lastArgs[index]);
          };

          var result = function result() {
            for (var _len = arguments.length, newArgs = Array(_len), _key = 0; _key < _len; _key++) {
              newArgs[_key] = arguments[_key];
            }

            if (calledOnce && lastThis === this && newArgs.length === lastArgs.length && newArgs.every(isNewArgEqualToLast)) {
              return lastResult;
            }

            calledOnce = true;
            lastThis = this;
            lastArgs = newArgs;
            lastResult = resultFn.apply(this, newArgs);
            return lastResult;
          };

          return result;
        }
        /* harmony default export */


        __webpack_exports__["default"] = index;
        /***/
      },

      /***/
      "./node_modules/object-assign/index.js":
      /*!*********************************************!*\
        !*** ./node_modules/object-assign/index.js ***!
        \*********************************************/

      /*! no static exports found */

      /***/
      function node_modulesObjectAssignIndexJs(module, exports, __webpack_require__) {
        "use strict";
        /*
        object-assign
        (c) Sindre Sorhus
        @license MIT
        */

        /* eslint-disable no-unused-vars */

        var getOwnPropertySymbols = Object.getOwnPropertySymbols;
        var hasOwnProperty = Object.prototype.hasOwnProperty;
        var propIsEnumerable = Object.prototype.propertyIsEnumerable;

        function toObject(val) {
          if (val === null || val === undefined) {
            throw new TypeError('Object.assign cannot be called with null or undefined');
          }

          return Object(val);
        }

        function shouldUseNative() {
          try {
            if (!Object.assign) {
              return false;
            } // Detect buggy property enumeration order in older V8 versions.
            // https://bugs.chromium.org/p/v8/issues/detail?id=4118


            var test1 = new String('abc'); // eslint-disable-line no-new-wrappers

            test1[5] = 'de';

            if (Object.getOwnPropertyNames(test1)[0] === '5') {
              return false;
            } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


            var test2 = {};

            for (var i = 0; i < 10; i++) {
              test2['_' + String.fromCharCode(i)] = i;
            }

            var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
              return test2[n];
            });

            if (order2.join('') !== '0123456789') {
              return false;
            } // https://bugs.chromium.org/p/v8/issues/detail?id=3056


            var test3 = {};
            'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
              test3[letter] = letter;
            });

            if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
              return false;
            }

            return true;
          } catch (err) {
            // We don't expect any of the above to throw, but better to be safe.
            return false;
          }
        }

        module.exports = shouldUseNative() ? Object.assign : function (target, source) {
          var from;
          var to = toObject(target);
          var symbols;

          for (var s = 1; s < arguments.length; s++) {
            from = Object(arguments[s]);

            for (var key in from) {
              if (hasOwnProperty.call(from, key)) {
                to[key] = from[key];
              }
            }

            if (getOwnPropertySymbols) {
              symbols = getOwnPropertySymbols(from);

              for (var i = 0; i < symbols.length; i++) {
                if (propIsEnumerable.call(from, symbols[i])) {
                  to[symbols[i]] = from[symbols[i]];
                }
              }
            }
          }

          return to;
        };
        /***/
      },

      /***/
      "./node_modules/prop-types/factoryWithThrowingShims.js":
      /*!*************************************************************!*\
        !*** ./node_modules/prop-types/factoryWithThrowingShims.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesPropTypesFactoryWithThrowingShimsJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        var ReactPropTypesSecret = __webpack_require__(
        /*! ./lib/ReactPropTypesSecret */
        "./node_modules/prop-types/lib/ReactPropTypesSecret.js");

        function emptyFunction() {}

        function emptyFunctionWithReset() {}

        emptyFunctionWithReset.resetWarningCache = emptyFunction;

        module.exports = function () {
          function shim(props, propName, componentName, location, propFullName, secret) {
            if (secret === ReactPropTypesSecret) {
              // It is still safe when called from React.
              return;
            }

            var err = new Error('Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
            err.name = 'Invariant Violation';
            throw err;
          }

          ;
          shim.isRequired = shim;

          function getShim() {
            return shim;
          }

          ; // Important!
          // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

          var ReactPropTypes = {
            array: shim,
            bool: shim,
            func: shim,
            number: shim,
            object: shim,
            string: shim,
            symbol: shim,
            any: shim,
            arrayOf: getShim,
            element: shim,
            elementType: shim,
            instanceOf: getShim,
            node: shim,
            objectOf: getShim,
            oneOf: getShim,
            oneOfType: getShim,
            shape: getShim,
            exact: getShim,
            checkPropTypes: emptyFunctionWithReset,
            resetWarningCache: emptyFunction
          };
          ReactPropTypes.PropTypes = ReactPropTypes;
          return ReactPropTypes;
        };
        /***/

      },

      /***/
      "./node_modules/prop-types/index.js":
      /*!******************************************!*\
        !*** ./node_modules/prop-types/index.js ***!
        \******************************************/

      /*! no static exports found */

      /***/
      function node_modulesPropTypesIndexJs(module, exports, __webpack_require__) {
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */
        if (false) {
          var throwOnDirectAccess, ReactIs;
        } else {
          // By explicitly using `prop-types` you are opting into new production behavior.
          // http://fb.me/prop-types-in-prod
          module.exports = __webpack_require__(
          /*! ./factoryWithThrowingShims */
          "./node_modules/prop-types/factoryWithThrowingShims.js")();
        }
        /***/

      },

      /***/
      "./node_modules/prop-types/lib/ReactPropTypesSecret.js":
      /*!*************************************************************!*\
        !*** ./node_modules/prop-types/lib/ReactPropTypesSecret.js ***!
        \*************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesPropTypesLibReactPropTypesSecretJs(module, exports, __webpack_require__) {
        "use strict";
        /**
         * Copyright (c) 2013-present, Facebook, Inc.
         *
         * This source code is licensed under the MIT license found in the
         * LICENSE file in the root directory of this source tree.
         */

        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        module.exports = ReactPropTypesSecret;
        /***/
      },

      /***/
      "./node_modules/react-dom/cjs/react-dom.production.min.js":
      /*!****************************************************************!*\
        !*** ./node_modules/react-dom/cjs/react-dom.production.min.js ***!
        \****************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactDomCjsReactDomProductionMinJs(module, exports, __webpack_require__) {
        "use strict";
        /*
         React v16.0.0
         react-dom.production.min.js
        
         Copyright (c) 2013-present, Facebook, Inc.
        
         This source code is licensed under the MIT license found in the
         LICENSE file in the root directory of this source tree.
         Modernizr 3.0.0pre (Custom Build) | MIT
        */

        var aa = __webpack_require__(
        /*! react */
        "react");

        __webpack_require__(
        /*! fbjs/lib/invariant */
        "./node_modules/fbjs/lib/invariant.js");

        var l = __webpack_require__(
        /*! fbjs/lib/ExecutionEnvironment */
        "./node_modules/fbjs/lib/ExecutionEnvironment.js"),
            n = __webpack_require__(
        /*! object-assign */
        "./node_modules/object-assign/index.js"),
            ba = __webpack_require__(
        /*! fbjs/lib/EventListener */
        "./node_modules/fbjs/lib/EventListener.js"),
            ca = __webpack_require__(
        /*! fbjs/lib/emptyFunction */
        "./node_modules/fbjs/lib/emptyFunction.js"),
            da = __webpack_require__(
        /*! fbjs/lib/emptyObject */
        "./node_modules/fbjs/lib/emptyObject.js"),
            ea = __webpack_require__(
        /*! fbjs/lib/shallowEqual */
        "./node_modules/fbjs/lib/shallowEqual.js"),
            fa = __webpack_require__(
        /*! fbjs/lib/containsNode */
        "./node_modules/fbjs/lib/containsNode.js"),
            ha = __webpack_require__(
        /*! fbjs/lib/focusNode */
        "./node_modules/fbjs/lib/focusNode.js"),
            ia = __webpack_require__(
        /*! fbjs/lib/getActiveElement */
        "./node_modules/fbjs/lib/getActiveElement.js");

        function w(a) {
          for (var b = arguments.length - 1, c = "Minified React error #" + a + "; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d" + a, d = 0; d < b; d++) {
            c += "\x26args[]\x3d" + encodeURIComponent(arguments[d + 1]);
          }

          b = Error(c + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");
          b.name = "Invariant Violation";
          b.framesToPop = 1;
          throw b;
        }

        aa ? void 0 : w("227");

        function ja(a) {
          switch (a) {
            case "svg":
              return "http://www.w3.org/2000/svg";

            case "math":
              return "http://www.w3.org/1998/Math/MathML";

            default:
              return "http://www.w3.org/1999/xhtml";
          }
        }

        var ka = {
          Namespaces: {
            html: "http://www.w3.org/1999/xhtml",
            mathml: "http://www.w3.org/1998/Math/MathML",
            svg: "http://www.w3.org/2000/svg"
          },
          getIntrinsicNamespace: ja,
          getChildNamespace: function getChildNamespace(a, b) {
            return null == a || "http://www.w3.org/1999/xhtml" === a ? ja(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
          }
        },
            la = null,
            oa = {};

        function pa() {
          if (la) for (var a in oa) {
            var b = oa[a],
                c = la.indexOf(a);
            -1 < c ? void 0 : w("96", a);

            if (!qa.plugins[c]) {
              b.extractEvents ? void 0 : w("97", a);
              qa.plugins[c] = b;
              c = b.eventTypes;

              for (var d in c) {
                var e = void 0;
                var f = c[d],
                    g = b,
                    h = d;
                qa.eventNameDispatchConfigs.hasOwnProperty(h) ? w("99", h) : void 0;
                qa.eventNameDispatchConfigs[h] = f;
                var k = f.phasedRegistrationNames;

                if (k) {
                  for (e in k) {
                    k.hasOwnProperty(e) && ra(k[e], g, h);
                  }

                  e = !0;
                } else f.registrationName ? (ra(f.registrationName, g, h), e = !0) : e = !1;

                e ? void 0 : w("98", d, a);
              }
            }
          }
        }

        function ra(a, b, c) {
          qa.registrationNameModules[a] ? w("100", a) : void 0;
          qa.registrationNameModules[a] = b;
          qa.registrationNameDependencies[a] = b.eventTypes[c].dependencies;
        }

        var qa = {
          plugins: [],
          eventNameDispatchConfigs: {},
          registrationNameModules: {},
          registrationNameDependencies: {},
          possibleRegistrationNames: null,
          injectEventPluginOrder: function injectEventPluginOrder(a) {
            la ? w("101") : void 0;
            la = Array.prototype.slice.call(a);
            pa();
          },
          injectEventPluginsByName: function injectEventPluginsByName(a) {
            var b = !1,
                c;

            for (c in a) {
              if (a.hasOwnProperty(c)) {
                var d = a[c];
                oa.hasOwnProperty(c) && oa[c] === d || (oa[c] ? w("102", c) : void 0, oa[c] = d, b = !0);
              }
            }

            b && pa();
          }
        },
            sa = qa,
            ta = {
          children: !0,
          dangerouslySetInnerHTML: !0,
          autoFocus: !0,
          defaultValue: !0,
          defaultChecked: !0,
          innerHTML: !0,
          suppressContentEditableWarning: !0,
          style: !0
        };

        function ua(a, b) {
          return (a & b) === b;
        }

        var wa = {
          MUST_USE_PROPERTY: 1,
          HAS_BOOLEAN_VALUE: 4,
          HAS_NUMERIC_VALUE: 8,
          HAS_POSITIVE_NUMERIC_VALUE: 24,
          HAS_OVERLOADED_BOOLEAN_VALUE: 32,
          HAS_STRING_BOOLEAN_VALUE: 64,
          injectDOMPropertyConfig: function injectDOMPropertyConfig(a) {
            var b = wa,
                c = a.Properties || {},
                d = a.DOMAttributeNamespaces || {},
                e = a.DOMAttributeNames || {};
            a = a.DOMMutationMethods || {};

            for (var f in c) {
              xa.properties.hasOwnProperty(f) ? w("48", f) : void 0;
              var g = f.toLowerCase(),
                  h = c[f];
              g = {
                attributeName: g,
                attributeNamespace: null,
                propertyName: f,
                mutationMethod: null,
                mustUseProperty: ua(h, b.MUST_USE_PROPERTY),
                hasBooleanValue: ua(h, b.HAS_BOOLEAN_VALUE),
                hasNumericValue: ua(h, b.HAS_NUMERIC_VALUE),
                hasPositiveNumericValue: ua(h, b.HAS_POSITIVE_NUMERIC_VALUE),
                hasOverloadedBooleanValue: ua(h, b.HAS_OVERLOADED_BOOLEAN_VALUE),
                hasStringBooleanValue: ua(h, b.HAS_STRING_BOOLEAN_VALUE)
              };
              1 >= g.hasBooleanValue + g.hasNumericValue + g.hasOverloadedBooleanValue ? void 0 : w("50", f);
              e.hasOwnProperty(f) && (g.attributeName = e[f]);
              d.hasOwnProperty(f) && (g.attributeNamespace = d[f]);
              a.hasOwnProperty(f) && (g.mutationMethod = a[f]);
              xa.properties[f] = g;
            }
          }
        },
            xa = {
          ID_ATTRIBUTE_NAME: "data-reactid",
          ROOT_ATTRIBUTE_NAME: "data-reactroot",
          ATTRIBUTE_NAME_START_CHAR: ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",
          ATTRIBUTE_NAME_CHAR: ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
          properties: {},
          shouldSetAttribute: function shouldSetAttribute(a, b) {
            if (xa.isReservedProp(a) || !("o" !== a[0] && "O" !== a[0] || "n" !== a[1] && "N" !== a[1])) return !1;
            if (null === b) return !0;

            switch (typeof b) {
              case "boolean":
                return xa.shouldAttributeAcceptBooleanValue(a);

              case "undefined":
              case "number":
              case "string":
              case "object":
                return !0;

              default:
                return !1;
            }
          },
          getPropertyInfo: function getPropertyInfo(a) {
            return xa.properties.hasOwnProperty(a) ? xa.properties[a] : null;
          },
          shouldAttributeAcceptBooleanValue: function shouldAttributeAcceptBooleanValue(a) {
            if (xa.isReservedProp(a)) return !0;
            var b = xa.getPropertyInfo(a);
            if (b) return b.hasBooleanValue || b.hasStringBooleanValue || b.hasOverloadedBooleanValue;
            a = a.toLowerCase().slice(0, 5);
            return "data-" === a || "aria-" === a;
          },
          isReservedProp: function isReservedProp(a) {
            return ta.hasOwnProperty(a);
          },
          injection: wa
        },
            A = xa,
            E = {
          IndeterminateComponent: 0,
          FunctionalComponent: 1,
          ClassComponent: 2,
          HostRoot: 3,
          HostPortal: 4,
          HostComponent: 5,
          HostText: 6,
          CoroutineComponent: 7,
          CoroutineHandlerPhase: 8,
          YieldComponent: 9,
          Fragment: 10
        },
            F = {
          ELEMENT_NODE: 1,
          TEXT_NODE: 3,
          COMMENT_NODE: 8,
          DOCUMENT_NODE: 9,
          DOCUMENT_FRAGMENT_NODE: 11
        },
            ya = E.HostComponent,
            za = E.HostText,
            Aa = F.ELEMENT_NODE,
            Ba = F.COMMENT_NODE,
            Ea = A.ID_ATTRIBUTE_NAME,
            Fa = {
          hasCachedChildNodes: 1
        },
            Ga = Math.random().toString(36).slice(2),
            Ha = "__reactInternalInstance$" + Ga,
            Ia = "__reactEventHandlers$" + Ga;

        function La(a) {
          for (var b; b = a._renderedComponent;) {
            a = b;
          }

          return a;
        }

        function Ma(a, b) {
          a = La(a);
          a._hostNode = b;
          b[Ha] = a;
        }

        function Na(a, b) {
          if (!(a._flags & Fa.hasCachedChildNodes)) {
            var c = a._renderedChildren;
            b = b.firstChild;
            var d;

            a: for (d in c) {
              if (c.hasOwnProperty(d)) {
                var e = c[d],
                    f = La(e)._domID;

                if (0 !== f) {
                  for (; null !== b; b = b.nextSibling) {
                    var g = b,
                        h = f;

                    if (g.nodeType === Aa && g.getAttribute(Ea) === "" + h || g.nodeType === Ba && g.nodeValue === " react-text: " + h + " " || g.nodeType === Ba && g.nodeValue === " react-empty: " + h + " ") {
                      Ma(e, b);
                      continue a;
                    }
                  }

                  w("32", f);
                }
              }
            }

            a._flags |= Fa.hasCachedChildNodes;
          }
        }

        function Oa(a) {
          if (a[Ha]) return a[Ha];

          for (var b = []; !a[Ha];) {
            if (b.push(a), a.parentNode) a = a.parentNode;else return null;
          }

          var c = a[Ha];
          if (c.tag === ya || c.tag === za) return c;

          for (; a && (c = a[Ha]); a = b.pop()) {
            var d = c;
            b.length && Na(c, a);
          }

          return d;
        }

        var G = {
          getClosestInstanceFromNode: Oa,
          getInstanceFromNode: function getInstanceFromNode(a) {
            var b = a[Ha];
            if (b) return b.tag === ya || b.tag === za ? b : b._hostNode === a ? b : null;
            b = Oa(a);
            return null != b && b._hostNode === a ? b : null;
          },
          getNodeFromInstance: function getNodeFromInstance(a) {
            if (a.tag === ya || a.tag === za) return a.stateNode;
            void 0 === a._hostNode ? w("33") : void 0;
            if (a._hostNode) return a._hostNode;

            for (var b = []; !a._hostNode;) {
              b.push(a), a._hostParent ? void 0 : w("34"), a = a._hostParent;
            }

            for (; b.length; a = b.pop()) {
              Na(a, a._hostNode);
            }

            return a._hostNode;
          },
          precacheChildNodes: Na,
          precacheNode: Ma,
          uncacheNode: function uncacheNode(a) {
            var b = a._hostNode;
            b && (delete b[Ha], a._hostNode = null);
          },
          precacheFiberNode: function precacheFiberNode(a, b) {
            b[Ha] = a;
          },
          getFiberCurrentPropsFromNode: function getFiberCurrentPropsFromNode(a) {
            return a[Ia] || null;
          },
          updateFiberProps: function updateFiberProps(a, b) {
            a[Ia] = b;
          }
        },
            Pa = {
          remove: function remove(a) {
            a._reactInternalFiber = void 0;
          },
          get: function get(a) {
            return a._reactInternalFiber;
          },
          has: function has(a) {
            return void 0 !== a._reactInternalFiber;
          },
          set: function set(a, b) {
            a._reactInternalFiber = b;
          }
        },
            Qa = {
          ReactCurrentOwner: aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner
        };

        function Ra(a) {
          if ("function" === typeof a.getName) return a.getName();

          if ("number" === typeof a.tag) {
            a = a.type;
            if ("string" === typeof a) return a;
            if ("function" === typeof a) return a.displayName || a.name;
          }

          return null;
        }

        var J = {
          NoEffect: 0,
          PerformedWork: 1,
          Placement: 2,
          Update: 4,
          PlacementAndUpdate: 6,
          Deletion: 8,
          ContentReset: 16,
          Callback: 32,
          Err: 64,
          Ref: 128
        },
            Sa = E.HostComponent,
            Ta = E.HostRoot,
            Ua = E.HostPortal,
            Va = E.HostText,
            Wa = J.NoEffect,
            Xa = J.Placement;

        function Za(a) {
          var b = a;
          if (a.alternate) for (; b["return"];) {
            b = b["return"];
          } else {
            if ((b.effectTag & Xa) !== Wa) return 1;

            for (; b["return"];) {
              if (b = b["return"], (b.effectTag & Xa) !== Wa) return 1;
            }
          }
          return b.tag === Ta ? 2 : 3;
        }

        function $a(a) {
          2 !== Za(a) ? w("188") : void 0;
        }

        function ab(a) {
          var b = a.alternate;
          if (!b) return b = Za(a), 3 === b ? w("188") : void 0, 1 === b ? null : a;

          for (var c = a, d = b;;) {
            var e = c["return"],
                f = e ? e.alternate : null;
            if (!e || !f) break;

            if (e.child === f.child) {
              for (var g = e.child; g;) {
                if (g === c) return $a(e), a;
                if (g === d) return $a(e), b;
                g = g.sibling;
              }

              w("188");
            }

            if (c["return"] !== d["return"]) c = e, d = f;else {
              g = !1;

              for (var h = e.child; h;) {
                if (h === c) {
                  g = !0;
                  c = e;
                  d = f;
                  break;
                }

                if (h === d) {
                  g = !0;
                  d = e;
                  c = f;
                  break;
                }

                h = h.sibling;
              }

              if (!g) {
                for (h = f.child; h;) {
                  if (h === c) {
                    g = !0;
                    c = f;
                    d = e;
                    break;
                  }

                  if (h === d) {
                    g = !0;
                    d = f;
                    c = e;
                    break;
                  }

                  h = h.sibling;
                }

                g ? void 0 : w("189");
              }
            }
            c.alternate !== d ? w("190") : void 0;
          }

          c.tag !== Ta ? w("188") : void 0;
          return c.stateNode.current === c ? a : b;
        }

        var bb = {
          isFiberMounted: function isFiberMounted(a) {
            return 2 === Za(a);
          },
          isMounted: function isMounted(a) {
            return (a = Pa.get(a)) ? 2 === Za(a) : !1;
          },
          findCurrentFiberUsingSlowPath: ab,
          findCurrentHostFiber: function findCurrentHostFiber(a) {
            a = ab(a);
            if (!a) return null;

            for (var b = a;;) {
              if (b.tag === Sa || b.tag === Va) return b;
              if (b.child) b.child["return"] = b, b = b.child;else {
                if (b === a) break;

                for (; !b.sibling;) {
                  if (!b["return"] || b["return"] === a) return null;
                  b = b["return"];
                }

                b.sibling["return"] = b["return"];
                b = b.sibling;
              }
            }

            return null;
          },
          findCurrentHostFiberWithNoPortals: function findCurrentHostFiberWithNoPortals(a) {
            a = ab(a);
            if (!a) return null;

            for (var b = a;;) {
              if (b.tag === Sa || b.tag === Va) return b;
              if (b.child && b.tag !== Ua) b.child["return"] = b, b = b.child;else {
                if (b === a) break;

                for (; !b.sibling;) {
                  if (!b["return"] || b["return"] === a) return null;
                  b = b["return"];
                }

                b.sibling["return"] = b["return"];
                b = b.sibling;
              }
            }

            return null;
          }
        },
            K = {
          _caughtError: null,
          _hasCaughtError: !1,
          _rethrowError: null,
          _hasRethrowError: !1,
          injection: {
            injectErrorUtils: function injectErrorUtils(a) {
              "function" !== typeof a.invokeGuardedCallback ? w("197") : void 0;
              cb = a.invokeGuardedCallback;
            }
          },
          invokeGuardedCallback: function invokeGuardedCallback(a, b, c, d, e, f, g, h, k) {
            cb.apply(K, arguments);
          },
          invokeGuardedCallbackAndCatchFirstError: function invokeGuardedCallbackAndCatchFirstError(a, b, c, d, e, f, g, h, k) {
            K.invokeGuardedCallback.apply(this, arguments);

            if (K.hasCaughtError()) {
              var p = K.clearCaughtError();
              K._hasRethrowError || (K._hasRethrowError = !0, K._rethrowError = p);
            }
          },
          rethrowCaughtError: function rethrowCaughtError() {
            return db.apply(K, arguments);
          },
          hasCaughtError: function hasCaughtError() {
            return K._hasCaughtError;
          },
          clearCaughtError: function clearCaughtError() {
            if (K._hasCaughtError) {
              var a = K._caughtError;
              K._caughtError = null;
              K._hasCaughtError = !1;
              return a;
            }

            w("198");
          }
        };

        function cb(a, b, c, d, e, f, g, h, k) {
          K._hasCaughtError = !1;
          K._caughtError = null;
          var p = Array.prototype.slice.call(arguments, 3);

          try {
            b.apply(c, p);
          } catch (x) {
            K._caughtError = x, K._hasCaughtError = !0;
          }
        }

        function db() {
          if (K._hasRethrowError) {
            var a = K._rethrowError;
            K._rethrowError = null;
            K._hasRethrowError = !1;
            throw a;
          }
        }

        var eb = K,
            fb;

        function gb(a, b, c, d) {
          b = a.type || "unknown-event";
          a.currentTarget = hb.getNodeFromInstance(d);
          eb.invokeGuardedCallbackAndCatchFirstError(b, c, void 0, a);
          a.currentTarget = null;
        }

        var hb = {
          isEndish: function isEndish(a) {
            return "topMouseUp" === a || "topTouchEnd" === a || "topTouchCancel" === a;
          },
          isMoveish: function isMoveish(a) {
            return "topMouseMove" === a || "topTouchMove" === a;
          },
          isStartish: function isStartish(a) {
            return "topMouseDown" === a || "topTouchStart" === a;
          },
          executeDirectDispatch: function executeDirectDispatch(a) {
            var b = a._dispatchListeners,
                c = a._dispatchInstances;
            Array.isArray(b) ? w("103") : void 0;
            a.currentTarget = b ? hb.getNodeFromInstance(c) : null;
            b = b ? b(a) : null;
            a.currentTarget = null;
            a._dispatchListeners = null;
            a._dispatchInstances = null;
            return b;
          },
          executeDispatchesInOrder: function executeDispatchesInOrder(a, b) {
            var c = a._dispatchListeners,
                d = a._dispatchInstances;
            if (Array.isArray(c)) for (var e = 0; e < c.length && !a.isPropagationStopped(); e++) {
              gb(a, b, c[e], d[e]);
            } else c && gb(a, b, c, d);
            a._dispatchListeners = null;
            a._dispatchInstances = null;
          },
          executeDispatchesInOrderStopAtTrue: function executeDispatchesInOrderStopAtTrue(a) {
            a: {
              var b = a._dispatchListeners;
              var c = a._dispatchInstances;
              if (Array.isArray(b)) for (var d = 0; d < b.length && !a.isPropagationStopped(); d++) {
                if (b[d](a, c[d])) {
                  b = c[d];
                  break a;
                }
              } else if (b && b(a, c)) {
                b = c;
                break a;
              }
              b = null;
            }

            a._dispatchInstances = null;
            a._dispatchListeners = null;
            return b;
          },
          hasDispatches: function hasDispatches(a) {
            return !!a._dispatchListeners;
          },
          getFiberCurrentPropsFromNode: function getFiberCurrentPropsFromNode(a) {
            return fb.getFiberCurrentPropsFromNode(a);
          },
          getInstanceFromNode: function getInstanceFromNode(a) {
            return fb.getInstanceFromNode(a);
          },
          getNodeFromInstance: function getNodeFromInstance(a) {
            return fb.getNodeFromInstance(a);
          },
          injection: {
            injectComponentTree: function injectComponentTree(a) {
              fb = a;
            }
          }
        },
            ib = hb,
            jb = null,
            kb = null,
            lb = null;

        function mb(a) {
          if (a = ib.getInstanceFromNode(a)) if ("number" === typeof a.tag) {
            jb && "function" === typeof jb.restoreControlledState ? void 0 : w("194");
            var b = ib.getFiberCurrentPropsFromNode(a.stateNode);
            jb.restoreControlledState(a.stateNode, a.type, b);
          } else "function" !== typeof a.restoreControlledState ? w("195") : void 0, a.restoreControlledState();
        }

        var nb = {
          injection: {
            injectFiberControlledHostComponent: function injectFiberControlledHostComponent(a) {
              jb = a;
            }
          },
          enqueueStateRestore: function enqueueStateRestore(a) {
            kb ? lb ? lb.push(a) : lb = [a] : kb = a;
          },
          restoreStateIfNeeded: function restoreStateIfNeeded() {
            if (kb) {
              var a = kb,
                  b = lb;
              lb = kb = null;
              mb(a);
              if (b) for (a = 0; a < b.length; a++) {
                mb(b[a]);
              }
            }
          }
        };

        function ob(a, b, c, d, e, f) {
          return a(b, c, d, e, f);
        }

        function pb(a, b) {
          return a(b);
        }

        function qb(a, b) {
          return pb(a, b);
        }

        var rb = !1,
            sb = {
          batchedUpdates: function batchedUpdates(a, b) {
            if (rb) return ob(qb, a, b);
            rb = !0;

            try {
              return ob(qb, a, b);
            } finally {
              rb = !1, nb.restoreStateIfNeeded();
            }
          },
          injection: {
            injectStackBatchedUpdates: function injectStackBatchedUpdates(a) {
              ob = a;
            },
            injectFiberBatchedUpdates: function injectFiberBatchedUpdates(a) {
              pb = a;
            }
          }
        },
            tb = F.TEXT_NODE;

        function ub(a) {
          a = a.target || a.srcElement || window;
          a.correspondingUseElement && (a = a.correspondingUseElement);
          return a.nodeType === tb ? a.parentNode : a;
        }

        var vb = E.HostRoot,
            wb = [];

        function xb(a) {
          var b = a.targetInst;

          do {
            if (!b) {
              a.ancestors.push(b);
              break;
            }

            var c = b;

            if ("number" === typeof c.tag) {
              for (; c["return"];) {
                c = c["return"];
              }

              c = c.tag !== vb ? null : c.stateNode.containerInfo;
            } else {
              for (; c._hostParent;) {
                c = c._hostParent;
              }

              c = G.getNodeFromInstance(c).parentNode;
            }

            if (!c) break;
            a.ancestors.push(b);
            b = G.getClosestInstanceFromNode(c);
          } while (b);

          for (c = 0; c < a.ancestors.length; c++) {
            b = a.ancestors[c], yb._handleTopLevel(a.topLevelType, b, a.nativeEvent, ub(a.nativeEvent));
          }
        }

        var yb = {
          _enabled: !0,
          _handleTopLevel: null,
          setHandleTopLevel: function setHandleTopLevel(a) {
            yb._handleTopLevel = a;
          },
          setEnabled: function setEnabled(a) {
            yb._enabled = !!a;
          },
          isEnabled: function isEnabled() {
            return yb._enabled;
          },
          trapBubbledEvent: function trapBubbledEvent(a, b, c) {
            return c ? ba.listen(c, b, yb.dispatchEvent.bind(null, a)) : null;
          },
          trapCapturedEvent: function trapCapturedEvent(a, b, c) {
            return c ? ba.capture(c, b, yb.dispatchEvent.bind(null, a)) : null;
          },
          dispatchEvent: function dispatchEvent(a, b) {
            if (yb._enabled) {
              var c = ub(b);
              c = G.getClosestInstanceFromNode(c);
              null === c || "number" !== typeof c.tag || bb.isFiberMounted(c) || (c = null);

              if (wb.length) {
                var d = wb.pop();
                d.topLevelType = a;
                d.nativeEvent = b;
                d.targetInst = c;
                a = d;
              } else a = {
                topLevelType: a,
                nativeEvent: b,
                targetInst: c,
                ancestors: []
              };

              try {
                sb.batchedUpdates(xb, a);
              } finally {
                a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > wb.length && wb.push(a);
              }
            }
          }
        },
            L = yb;

        function Cb(a, b) {
          null == b ? w("30") : void 0;
          if (null == a) return b;

          if (Array.isArray(a)) {
            if (Array.isArray(b)) return a.push.apply(a, b), a;
            a.push(b);
            return a;
          }

          return Array.isArray(b) ? [a].concat(b) : [a, b];
        }

        function Db(a, b, c) {
          Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
        }

        var Eb = null;

        function Fb(a, b) {
          a && (ib.executeDispatchesInOrder(a, b), a.isPersistent() || a.constructor.release(a));
        }

        function Gb(a) {
          return Fb(a, !0);
        }

        function Hb(a) {
          return Fb(a, !1);
        }

        function Ib(a, b, c) {
          switch (a) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
              return !(!c.disabled || "button" !== b && "input" !== b && "select" !== b && "textarea" !== b);

            default:
              return !1;
          }
        }

        var Jb = {
          injection: {
            injectEventPluginOrder: sa.injectEventPluginOrder,
            injectEventPluginsByName: sa.injectEventPluginsByName
          },
          getListener: function getListener(a, b) {
            if ("number" === typeof a.tag) {
              var c = a.stateNode;
              if (!c) return null;
              var d = ib.getFiberCurrentPropsFromNode(c);
              if (!d) return null;
              c = d[b];
              if (Ib(b, a.type, d)) return null;
            } else {
              d = a._currentElement;
              if ("string" === typeof d || "number" === typeof d || !a._rootNodeID) return null;
              a = d.props;
              c = a[b];
              if (Ib(b, d.type, a)) return null;
            }

            c && "function" !== typeof c ? w("231", b, typeof c) : void 0;
            return c;
          },
          extractEvents: function extractEvents(a, b, c, d) {
            for (var e, f = sa.plugins, g = 0; g < f.length; g++) {
              var h = f[g];
              h && (h = h.extractEvents(a, b, c, d)) && (e = Cb(e, h));
            }

            return e;
          },
          enqueueEvents: function enqueueEvents(a) {
            a && (Eb = Cb(Eb, a));
          },
          processEventQueue: function processEventQueue(a) {
            var b = Eb;
            Eb = null;
            a ? Db(b, Gb) : Db(b, Hb);
            Eb ? w("95") : void 0;
            eb.rethrowCaughtError();
          }
        },
            Kb;
        l.canUseDOM && (Kb = document.implementation && document.implementation.hasFeature && !0 !== document.implementation.hasFeature("", ""));

        function Lb(a, b) {
          if (!l.canUseDOM || b && !("addEventListener" in document)) return !1;
          b = "on" + a;
          var c = b in document;
          c || (c = document.createElement("div"), c.setAttribute(b, "return;"), c = "function" === typeof c[b]);
          !c && Kb && "wheel" === a && (c = document.implementation.hasFeature("Events.wheel", "3.0"));
          return c;
        }

        function Mb(a, b) {
          var c = {};
          c[a.toLowerCase()] = b.toLowerCase();
          c["Webkit" + a] = "webkit" + b;
          c["Moz" + a] = "moz" + b;
          c["ms" + a] = "MS" + b;
          c["O" + a] = "o" + b.toLowerCase();
          return c;
        }

        var Nb = {
          animationend: Mb("Animation", "AnimationEnd"),
          animationiteration: Mb("Animation", "AnimationIteration"),
          animationstart: Mb("Animation", "AnimationStart"),
          transitionend: Mb("Transition", "TransitionEnd")
        },
            Ob = {},
            Pb = {};
        l.canUseDOM && (Pb = document.createElement("div").style, "AnimationEvent" in window || (delete Nb.animationend.animation, delete Nb.animationiteration.animation, delete Nb.animationstart.animation), "TransitionEvent" in window || delete Nb.transitionend.transition);

        function Qb(a) {
          if (Ob[a]) return Ob[a];
          if (!Nb[a]) return a;
          var b = Nb[a],
              c;

          for (c in b) {
            if (b.hasOwnProperty(c) && c in Pb) return Ob[a] = b[c];
          }

          return "";
        }

        var Rb = {
          topAbort: "abort",
          topAnimationEnd: Qb("animationend") || "animationend",
          topAnimationIteration: Qb("animationiteration") || "animationiteration",
          topAnimationStart: Qb("animationstart") || "animationstart",
          topBlur: "blur",
          topCancel: "cancel",
          topCanPlay: "canplay",
          topCanPlayThrough: "canplaythrough",
          topChange: "change",
          topClick: "click",
          topClose: "close",
          topCompositionEnd: "compositionend",
          topCompositionStart: "compositionstart",
          topCompositionUpdate: "compositionupdate",
          topContextMenu: "contextmenu",
          topCopy: "copy",
          topCut: "cut",
          topDoubleClick: "dblclick",
          topDrag: "drag",
          topDragEnd: "dragend",
          topDragEnter: "dragenter",
          topDragExit: "dragexit",
          topDragLeave: "dragleave",
          topDragOver: "dragover",
          topDragStart: "dragstart",
          topDrop: "drop",
          topDurationChange: "durationchange",
          topEmptied: "emptied",
          topEncrypted: "encrypted",
          topEnded: "ended",
          topError: "error",
          topFocus: "focus",
          topInput: "input",
          topKeyDown: "keydown",
          topKeyPress: "keypress",
          topKeyUp: "keyup",
          topLoadedData: "loadeddata",
          topLoad: "load",
          topLoadedMetadata: "loadedmetadata",
          topLoadStart: "loadstart",
          topMouseDown: "mousedown",
          topMouseMove: "mousemove",
          topMouseOut: "mouseout",
          topMouseOver: "mouseover",
          topMouseUp: "mouseup",
          topPaste: "paste",
          topPause: "pause",
          topPlay: "play",
          topPlaying: "playing",
          topProgress: "progress",
          topRateChange: "ratechange",
          topScroll: "scroll",
          topSeeked: "seeked",
          topSeeking: "seeking",
          topSelectionChange: "selectionchange",
          topStalled: "stalled",
          topSuspend: "suspend",
          topTextInput: "textInput",
          topTimeUpdate: "timeupdate",
          topToggle: "toggle",
          topTouchCancel: "touchcancel",
          topTouchEnd: "touchend",
          topTouchMove: "touchmove",
          topTouchStart: "touchstart",
          topTransitionEnd: Qb("transitionend") || "transitionend",
          topVolumeChange: "volumechange",
          topWaiting: "waiting",
          topWheel: "wheel"
        },
            Sb = {},
            Tb = 0,
            Ub = "_reactListenersID" + ("" + Math.random()).slice(2);

        function Vb(a) {
          Object.prototype.hasOwnProperty.call(a, Ub) || (a[Ub] = Tb++, Sb[a[Ub]] = {});
          return Sb[a[Ub]];
        }

        var M = n({}, {
          handleTopLevel: function handleTopLevel(a, b, c, d) {
            a = Jb.extractEvents(a, b, c, d);
            Jb.enqueueEvents(a);
            Jb.processEventQueue(!1);
          }
        }, {
          setEnabled: function setEnabled(a) {
            L && L.setEnabled(a);
          },
          isEnabled: function isEnabled() {
            return !(!L || !L.isEnabled());
          },
          listenTo: function listenTo(a, b) {
            var c = Vb(b);
            a = sa.registrationNameDependencies[a];

            for (var d = 0; d < a.length; d++) {
              var e = a[d];
              c.hasOwnProperty(e) && c[e] || ("topWheel" === e ? Lb("wheel") ? L.trapBubbledEvent("topWheel", "wheel", b) : Lb("mousewheel") ? L.trapBubbledEvent("topWheel", "mousewheel", b) : L.trapBubbledEvent("topWheel", "DOMMouseScroll", b) : "topScroll" === e ? L.trapCapturedEvent("topScroll", "scroll", b) : "topFocus" === e || "topBlur" === e ? (L.trapCapturedEvent("topFocus", "focus", b), L.trapCapturedEvent("topBlur", "blur", b), c.topBlur = !0, c.topFocus = !0) : "topCancel" === e ? (Lb("cancel", !0) && L.trapCapturedEvent("topCancel", "cancel", b), c.topCancel = !0) : "topClose" === e ? (Lb("close", !0) && L.trapCapturedEvent("topClose", "close", b), c.topClose = !0) : Rb.hasOwnProperty(e) && L.trapBubbledEvent(e, Rb[e], b), c[e] = !0);
            }
          },
          isListeningToAllDependencies: function isListeningToAllDependencies(a, b) {
            b = Vb(b);
            a = sa.registrationNameDependencies[a];

            for (var c = 0; c < a.length; c++) {
              var d = a[c];
              if (!b.hasOwnProperty(d) || !b[d]) return !1;
            }

            return !0;
          },
          trapBubbledEvent: function trapBubbledEvent(a, b, c) {
            return L.trapBubbledEvent(a, b, c);
          },
          trapCapturedEvent: function trapCapturedEvent(a, b, c) {
            return L.trapCapturedEvent(a, b, c);
          }
        }),
            Wb = {
          animationIterationCount: !0,
          borderImageOutset: !0,
          borderImageSlice: !0,
          borderImageWidth: !0,
          boxFlex: !0,
          boxFlexGroup: !0,
          boxOrdinalGroup: !0,
          columnCount: !0,
          columns: !0,
          flex: !0,
          flexGrow: !0,
          flexPositive: !0,
          flexShrink: !0,
          flexNegative: !0,
          flexOrder: !0,
          gridRow: !0,
          gridRowEnd: !0,
          gridRowSpan: !0,
          gridRowStart: !0,
          gridColumn: !0,
          gridColumnEnd: !0,
          gridColumnSpan: !0,
          gridColumnStart: !0,
          fontWeight: !0,
          lineClamp: !0,
          lineHeight: !0,
          opacity: !0,
          order: !0,
          orphans: !0,
          tabSize: !0,
          widows: !0,
          zIndex: !0,
          zoom: !0,
          fillOpacity: !0,
          floodOpacity: !0,
          stopOpacity: !0,
          strokeDasharray: !0,
          strokeDashoffset: !0,
          strokeMiterlimit: !0,
          strokeOpacity: !0,
          strokeWidth: !0
        },
            Xb = ["Webkit", "ms", "Moz", "O"];
        Object.keys(Wb).forEach(function (a) {
          Xb.forEach(function (b) {
            b = b + a.charAt(0).toUpperCase() + a.substring(1);
            Wb[b] = Wb[a];
          });
        });
        var Yb = {
          isUnitlessNumber: Wb,
          shorthandPropertyExpansions: {
            background: {
              backgroundAttachment: !0,
              backgroundColor: !0,
              backgroundImage: !0,
              backgroundPositionX: !0,
              backgroundPositionY: !0,
              backgroundRepeat: !0
            },
            backgroundPosition: {
              backgroundPositionX: !0,
              backgroundPositionY: !0
            },
            border: {
              borderWidth: !0,
              borderStyle: !0,
              borderColor: !0
            },
            borderBottom: {
              borderBottomWidth: !0,
              borderBottomStyle: !0,
              borderBottomColor: !0
            },
            borderLeft: {
              borderLeftWidth: !0,
              borderLeftStyle: !0,
              borderLeftColor: !0
            },
            borderRight: {
              borderRightWidth: !0,
              borderRightStyle: !0,
              borderRightColor: !0
            },
            borderTop: {
              borderTopWidth: !0,
              borderTopStyle: !0,
              borderTopColor: !0
            },
            font: {
              fontStyle: !0,
              fontVariant: !0,
              fontWeight: !0,
              fontSize: !0,
              lineHeight: !0,
              fontFamily: !0
            },
            outline: {
              outlineWidth: !0,
              outlineStyle: !0,
              outlineColor: !0
            }
          }
        },
            Zb = Yb.isUnitlessNumber,
            $b = !1;

        if (l.canUseDOM) {
          var ac = document.createElement("div").style;

          try {
            ac.font = "";
          } catch (a) {
            $b = !0;
          }
        }

        var bc = {
          createDangerousStringForStyles: function createDangerousStringForStyles() {},
          setValueForStyles: function setValueForStyles(a, b) {
            a = a.style;

            for (var c in b) {
              if (b.hasOwnProperty(c)) {
                var d = 0 === c.indexOf("--");
                var e = c;
                var f = b[c];
                e = null == f || "boolean" === typeof f || "" === f ? "" : d || "number" !== typeof f || 0 === f || Zb.hasOwnProperty(e) && Zb[e] ? ("" + f).trim() : f + "px";
                "float" === c && (c = "cssFloat");
                if (d) a.setProperty(c, e);else if (e) a[c] = e;else if (d = $b && Yb.shorthandPropertyExpansions[c]) for (var g in d) {
                  a[g] = "";
                } else a[c] = "";
              }
            }
          }
        },
            cc = new RegExp("^[" + A.ATTRIBUTE_NAME_START_CHAR + "][" + A.ATTRIBUTE_NAME_CHAR + "]*$"),
            dc = {},
            ec = {};

        function fc(a) {
          if (ec.hasOwnProperty(a)) return !0;
          if (dc.hasOwnProperty(a)) return !1;
          if (cc.test(a)) return ec[a] = !0;
          dc[a] = !0;
          return !1;
        }

        var gc = {
          setAttributeForID: function setAttributeForID(a, b) {
            a.setAttribute(A.ID_ATTRIBUTE_NAME, b);
          },
          setAttributeForRoot: function setAttributeForRoot(a) {
            a.setAttribute(A.ROOT_ATTRIBUTE_NAME, "");
          },
          getValueForProperty: function getValueForProperty() {},
          getValueForAttribute: function getValueForAttribute() {},
          setValueForProperty: function setValueForProperty(a, b, c) {
            var d = A.getPropertyInfo(b);

            if (d && A.shouldSetAttribute(b, c)) {
              var e = d.mutationMethod;
              e ? e(a, c) : null == c || d.hasBooleanValue && !c || d.hasNumericValue && isNaN(c) || d.hasPositiveNumericValue && 1 > c || d.hasOverloadedBooleanValue && !1 === c ? gc.deleteValueForProperty(a, b) : d.mustUseProperty ? a[d.propertyName] = c : (b = d.attributeName, (e = d.attributeNamespace) ? a.setAttributeNS(e, b, "" + c) : d.hasBooleanValue || d.hasOverloadedBooleanValue && !0 === c ? a.setAttribute(b, "") : a.setAttribute(b, "" + c));
            } else gc.setValueForAttribute(a, b, A.shouldSetAttribute(b, c) ? c : null);
          },
          setValueForAttribute: function setValueForAttribute(a, b, c) {
            fc(b) && (null == c ? a.removeAttribute(b) : a.setAttribute(b, "" + c));
          },
          deleteValueForAttribute: function deleteValueForAttribute(a, b) {
            a.removeAttribute(b);
          },
          deleteValueForProperty: function deleteValueForProperty(a, b) {
            var c = A.getPropertyInfo(b);
            c ? (b = c.mutationMethod) ? b(a, void 0) : c.mustUseProperty ? a[c.propertyName] = c.hasBooleanValue ? !1 : "" : a.removeAttribute(c.attributeName) : a.removeAttribute(b);
          }
        },
            hc = gc,
            ic = Qa.ReactDebugCurrentFrame;

        function jc() {
          return null;
        }

        var kc = {
          current: null,
          phase: null,
          resetCurrentFiber: function resetCurrentFiber() {
            ic.getCurrentStack = null;
            kc.current = null;
            kc.phase = null;
          },
          setCurrentFiber: function setCurrentFiber(a, b) {
            ic.getCurrentStack = jc;
            kc.current = a;
            kc.phase = b;
          },
          getCurrentFiberOwnerName: function getCurrentFiberOwnerName() {
            return null;
          },
          getCurrentFiberStackAddendum: jc
        },
            lc = kc,
            mc = {
          getHostProps: function getHostProps(a, b) {
            var c = b.value,
                d = b.checked;
            return n({
              type: void 0,
              step: void 0,
              min: void 0,
              max: void 0
            }, b, {
              defaultChecked: void 0,
              defaultValue: void 0,
              value: null != c ? c : a._wrapperState.initialValue,
              checked: null != d ? d : a._wrapperState.initialChecked
            });
          },
          initWrapperState: function initWrapperState(a, b) {
            var c = b.defaultValue;
            a._wrapperState = {
              initialChecked: null != b.checked ? b.checked : b.defaultChecked,
              initialValue: null != b.value ? b.value : c,
              controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
            };
          },
          updateWrapper: function updateWrapper(a, b) {
            var c = b.checked;
            null != c && hc.setValueForProperty(a, "checked", c || !1);
            c = b.value;
            if (null != c) {
              if (0 === c && "" === a.value) a.value = "0";else if ("number" === b.type) {
                if (b = parseFloat(a.value) || 0, c != b || c == b && a.value != c) a.value = "" + c;
              } else a.value !== "" + c && (a.value = "" + c);
            } else null == b.value && null != b.defaultValue && a.defaultValue !== "" + b.defaultValue && (a.defaultValue = "" + b.defaultValue), null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
          },
          postMountWrapper: function postMountWrapper(a, b) {
            switch (b.type) {
              case "submit":
              case "reset":
                break;

              case "color":
              case "date":
              case "datetime":
              case "datetime-local":
              case "month":
              case "time":
              case "week":
                a.value = "";
                a.value = a.defaultValue;
                break;

              default:
                a.value = a.value;
            }

            b = a.name;
            "" !== b && (a.name = "");
            a.defaultChecked = !a.defaultChecked;
            a.defaultChecked = !a.defaultChecked;
            "" !== b && (a.name = b);
          },
          restoreControlledState: function restoreControlledState(a, b) {
            mc.updateWrapper(a, b);
            var c = b.name;

            if ("radio" === b.type && null != c) {
              for (b = a; b.parentNode;) {
                b = b.parentNode;
              }

              c = b.querySelectorAll("input[name\x3d" + JSON.stringify("" + c) + '][type\x3d"radio"]');

              for (b = 0; b < c.length; b++) {
                var d = c[b];

                if (d !== a && d.form === a.form) {
                  var e = G.getFiberCurrentPropsFromNode(d);
                  e ? void 0 : w("90");
                  mc.updateWrapper(d, e);
                }
              }
            }
          }
        },
            qc = mc;

        function rc(a) {
          var b = "";
          aa.Children.forEach(a, function (a) {
            null == a || "string" !== typeof a && "number" !== typeof a || (b += a);
          });
          return b;
        }

        var sc = {
          validateProps: function validateProps() {},
          postMountWrapper: function postMountWrapper(a, b) {
            null != b.value && a.setAttribute("value", b.value);
          },
          getHostProps: function getHostProps(a, b) {
            a = n({
              children: void 0
            }, b);
            if (b = rc(b.children)) a.children = b;
            return a;
          }
        };

        function tc(a, b, c) {
          a = a.options;

          if (b) {
            b = {};

            for (var d = 0; d < c.length; d++) {
              b["$" + c[d]] = !0;
            }

            for (c = 0; c < a.length; c++) {
              d = b.hasOwnProperty("$" + a[c].value), a[c].selected !== d && (a[c].selected = d);
            }
          } else {
            c = "" + c;
            b = null;

            for (d = 0; d < a.length; d++) {
              if (a[d].value === c) {
                a[d].selected = !0;
                return;
              }

              null !== b || a[d].disabled || (b = a[d]);
            }

            null !== b && (b.selected = !0);
          }
        }

        var uc = {
          getHostProps: function getHostProps(a, b) {
            return n({}, b, {
              value: void 0
            });
          },
          initWrapperState: function initWrapperState(a, b) {
            var c = b.value;
            a._wrapperState = {
              initialValue: null != c ? c : b.defaultValue,
              wasMultiple: !!b.multiple
            };
          },
          postMountWrapper: function postMountWrapper(a, b) {
            a.multiple = !!b.multiple;
            var c = b.value;
            null != c ? tc(a, !!b.multiple, c) : null != b.defaultValue && tc(a, !!b.multiple, b.defaultValue);
          },
          postUpdateWrapper: function postUpdateWrapper(a, b) {
            a._wrapperState.initialValue = void 0;
            var c = a._wrapperState.wasMultiple;
            a._wrapperState.wasMultiple = !!b.multiple;
            var d = b.value;
            null != d ? tc(a, !!b.multiple, d) : c !== !!b.multiple && (null != b.defaultValue ? tc(a, !!b.multiple, b.defaultValue) : tc(a, !!b.multiple, b.multiple ? [] : ""));
          },
          restoreControlledState: function restoreControlledState(a, b) {
            var c = b.value;
            null != c && tc(a, !!b.multiple, c);
          }
        },
            vc = {
          getHostProps: function getHostProps(a, b) {
            null != b.dangerouslySetInnerHTML ? w("91") : void 0;
            return n({}, b, {
              value: void 0,
              defaultValue: void 0,
              children: "" + a._wrapperState.initialValue
            });
          },
          initWrapperState: function initWrapperState(a, b) {
            var c = b.value,
                d = c;
            null == c && (c = b.defaultValue, b = b.children, null != b && (null != c ? w("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : w("93"), b = b[0]), c = "" + b), null == c && (c = ""), d = c);
            a._wrapperState = {
              initialValue: "" + d
            };
          },
          updateWrapper: function updateWrapper(a, b) {
            var c = b.value;
            null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && (a.defaultValue = c));
            null != b.defaultValue && (a.defaultValue = b.defaultValue);
          },
          postMountWrapper: function postMountWrapper(a) {
            var b = a.textContent;
            b === a._wrapperState.initialValue && (a.value = b);
          },
          restoreControlledState: function restoreControlledState(a, b) {
            vc.updateWrapper(a, b);
          }
        },
            wc = vc,
            xc = n({
          menuitem: !0
        }, {
          area: !0,
          base: !0,
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          keygen: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0
        });

        function yc(a, b) {
          b && (xc[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? w("137", a, "") : void 0), null != b.dangerouslySetInnerHTML && (null != b.children ? w("60") : void 0, "object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML ? void 0 : w("61")), null != b.style && "object" !== typeof b.style ? w("62", "") : void 0);
        }

        function zc(a) {
          var b = a.type;
          return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
        }

        function Ac(a) {
          var b = zc(a) ? "checked" : "value",
              c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
              d = "" + a[b];
          if (!a.hasOwnProperty(b) && "function" === typeof c.get && "function" === typeof c.set) return Object.defineProperty(a, b, {
            enumerable: c.enumerable,
            configurable: !0,
            get: function get() {
              return c.get.call(this);
            },
            set: function set(a) {
              d = "" + a;
              c.set.call(this, a);
            }
          }), {
            getValue: function getValue() {
              return d;
            },
            setValue: function setValue(a) {
              d = "" + a;
            },
            stopTracking: function stopTracking() {
              a._valueTracker = null;
              delete a[b];
            }
          };
        }

        var Bc = {
          _getTrackerFromNode: function _getTrackerFromNode(a) {
            return a._valueTracker;
          },
          track: function track(a) {
            a._valueTracker || (a._valueTracker = Ac(a));
          },
          updateValueIfChanged: function updateValueIfChanged(a) {
            if (!a) return !1;
            var b = a._valueTracker;
            if (!b) return !0;
            var c = b.getValue();
            var d = "";
            a && (d = zc(a) ? a.checked ? "true" : "false" : a.value);
            a = d;
            return a !== c ? (b.setValue(a), !0) : !1;
          },
          stopTracking: function stopTracking(a) {
            (a = a._valueTracker) && a.stopTracking();
          }
        };

        function Cc(a, b) {
          if (-1 === a.indexOf("-")) return "string" === typeof b.is;

          switch (a) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;

            default:
              return !0;
          }
        }

        var Dc = ka.Namespaces,
            Ec,
            Fc = function (a) {
          return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
            MSApp.execUnsafeLocalFunction(function () {
              return a(b, c, d, e);
            });
          } : a;
        }(function (a, b) {
          if (a.namespaceURI !== Dc.svg || "innerHTML" in a) a.innerHTML = b;else for (Ec = Ec || document.createElement("div"), Ec.innerHTML = "\x3csvg\x3e" + b + "\x3c/svg\x3e", b = Ec.firstChild; b.firstChild;) {
            a.appendChild(b.firstChild);
          }
        }),
            Gc = /["'&<>]/,
            Hc = F.TEXT_NODE;

        function Ic(a, b) {
          if (b) {
            var c = a.firstChild;

            if (c && c === a.lastChild && c.nodeType === Hc) {
              c.nodeValue = b;
              return;
            }
          }

          a.textContent = b;
        }

        l.canUseDOM && ("textContent" in document.documentElement || (Ic = function Ic(a, b) {
          if (a.nodeType === Hc) a.nodeValue = b;else {
            if ("boolean" === typeof b || "number" === typeof b) b = "" + b;else {
              b = "" + b;
              var c = Gc.exec(b);

              if (c) {
                var d = "",
                    e,
                    f = 0;

                for (e = c.index; e < b.length; e++) {
                  switch (b.charCodeAt(e)) {
                    case 34:
                      c = "\x26quot;";
                      break;

                    case 38:
                      c = "\x26amp;";
                      break;

                    case 39:
                      c = "\x26#x27;";
                      break;

                    case 60:
                      c = "\x26lt;";
                      break;

                    case 62:
                      c = "\x26gt;";
                      break;

                    default:
                      continue;
                  }

                  f !== e && (d += b.substring(f, e));
                  f = e + 1;
                  d += c;
                }

                b = f !== e ? d + b.substring(f, e) : d;
              }
            }
            Fc(a, b);
          }
        }));
        var Jc = Ic,
            Kc = lc.getCurrentFiberOwnerName,
            Lc = F.DOCUMENT_NODE,
            Mc = F.DOCUMENT_FRAGMENT_NODE,
            Nc = M.listenTo,
            Oc = sa.registrationNameModules,
            Pc = ka.Namespaces.html,
            Qc = ka.getIntrinsicNamespace;

        function Rc(a, b) {
          Nc(b, a.nodeType === Lc || a.nodeType === Mc ? a : a.ownerDocument);
        }

        var Sc = {
          topAbort: "abort",
          topCanPlay: "canplay",
          topCanPlayThrough: "canplaythrough",
          topDurationChange: "durationchange",
          topEmptied: "emptied",
          topEncrypted: "encrypted",
          topEnded: "ended",
          topError: "error",
          topLoadedData: "loadeddata",
          topLoadedMetadata: "loadedmetadata",
          topLoadStart: "loadstart",
          topPause: "pause",
          topPlay: "play",
          topPlaying: "playing",
          topProgress: "progress",
          topRateChange: "ratechange",
          topSeeked: "seeked",
          topSeeking: "seeking",
          topStalled: "stalled",
          topSuspend: "suspend",
          topTimeUpdate: "timeupdate",
          topVolumeChange: "volumechange",
          topWaiting: "waiting"
        },
            N = {
          createElement: function createElement(a, b, c, d) {
            c = c.nodeType === Lc ? c : c.ownerDocument;
            d === Pc && (d = Qc(a));
            d === Pc ? "script" === a ? (a = c.createElement("div"), a.innerHTML = "\x3cscript\x3e\x3c/script\x3e", a = a.removeChild(a.firstChild)) : a = "string" === typeof b.is ? c.createElement(a, {
              is: b.is
            }) : c.createElement(a) : a = c.createElementNS(d, a);
            return a;
          },
          createTextNode: function createTextNode(a, b) {
            return (b.nodeType === Lc ? b : b.ownerDocument).createTextNode(a);
          },
          setInitialProperties: function setInitialProperties(a, b, c, d) {
            var e = Cc(b, c);

            switch (b) {
              case "iframe":
              case "object":
                M.trapBubbledEvent("topLoad", "load", a);
                var f = c;
                break;

              case "video":
              case "audio":
                for (f in Sc) {
                  Sc.hasOwnProperty(f) && M.trapBubbledEvent(f, Sc[f], a);
                }

                f = c;
                break;

              case "source":
                M.trapBubbledEvent("topError", "error", a);
                f = c;
                break;

              case "img":
              case "image":
                M.trapBubbledEvent("topError", "error", a);
                M.trapBubbledEvent("topLoad", "load", a);
                f = c;
                break;

              case "form":
                M.trapBubbledEvent("topReset", "reset", a);
                M.trapBubbledEvent("topSubmit", "submit", a);
                f = c;
                break;

              case "details":
                M.trapBubbledEvent("topToggle", "toggle", a);
                f = c;
                break;

              case "input":
                qc.initWrapperState(a, c);
                f = qc.getHostProps(a, c);
                M.trapBubbledEvent("topInvalid", "invalid", a);
                Rc(d, "onChange");
                break;

              case "option":
                sc.validateProps(a, c);
                f = sc.getHostProps(a, c);
                break;

              case "select":
                uc.initWrapperState(a, c);
                f = uc.getHostProps(a, c);
                M.trapBubbledEvent("topInvalid", "invalid", a);
                Rc(d, "onChange");
                break;

              case "textarea":
                wc.initWrapperState(a, c);
                f = wc.getHostProps(a, c);
                M.trapBubbledEvent("topInvalid", "invalid", a);
                Rc(d, "onChange");
                break;

              default:
                f = c;
            }

            yc(b, f, Kc);
            var g = f,
                h;

            for (h in g) {
              if (g.hasOwnProperty(h)) {
                var k = g[h];
                "style" === h ? bc.setValueForStyles(a, k) : "dangerouslySetInnerHTML" === h ? (k = k ? k.__html : void 0, null != k && Fc(a, k)) : "children" === h ? "string" === typeof k ? Jc(a, k) : "number" === typeof k && Jc(a, "" + k) : "suppressContentEditableWarning" !== h && (Oc.hasOwnProperty(h) ? null != k && Rc(d, h) : e ? hc.setValueForAttribute(a, h, k) : null != k && hc.setValueForProperty(a, h, k));
              }
            }

            switch (b) {
              case "input":
                Bc.track(a);
                qc.postMountWrapper(a, c);
                break;

              case "textarea":
                Bc.track(a);
                wc.postMountWrapper(a, c);
                break;

              case "option":
                sc.postMountWrapper(a, c);
                break;

              case "select":
                uc.postMountWrapper(a, c);
                break;

              default:
                "function" === typeof f.onClick && (a.onclick = ca);
            }
          },
          diffProperties: function diffProperties(a, b, c, d, e) {
            var f = null;

            switch (b) {
              case "input":
                c = qc.getHostProps(a, c);
                d = qc.getHostProps(a, d);
                f = [];
                break;

              case "option":
                c = sc.getHostProps(a, c);
                d = sc.getHostProps(a, d);
                f = [];
                break;

              case "select":
                c = uc.getHostProps(a, c);
                d = uc.getHostProps(a, d);
                f = [];
                break;

              case "textarea":
                c = wc.getHostProps(a, c);
                d = wc.getHostProps(a, d);
                f = [];
                break;

              default:
                "function" !== typeof c.onClick && "function" === typeof d.onClick && (a.onclick = ca);
            }

            yc(b, d, Kc);
            var g, h;
            a = null;

            for (g in c) {
              if (!d.hasOwnProperty(g) && c.hasOwnProperty(g) && null != c[g]) if ("style" === g) for (h in b = c[g], b) {
                b.hasOwnProperty(h) && (a || (a = {}), a[h] = "");
              } else "dangerouslySetInnerHTML" !== g && "children" !== g && "suppressContentEditableWarning" !== g && (Oc.hasOwnProperty(g) ? f || (f = []) : (f = f || []).push(g, null));
            }

            for (g in d) {
              var k = d[g];
              b = null != c ? c[g] : void 0;
              if (d.hasOwnProperty(g) && k !== b && (null != k || null != b)) if ("style" === g) {
                if (b) {
                  for (h in b) {
                    !b.hasOwnProperty(h) || k && k.hasOwnProperty(h) || (a || (a = {}), a[h] = "");
                  }

                  for (h in k) {
                    k.hasOwnProperty(h) && b[h] !== k[h] && (a || (a = {}), a[h] = k[h]);
                  }
                } else a || (f || (f = []), f.push(g, a)), a = k;
              } else "dangerouslySetInnerHTML" === g ? (k = k ? k.__html : void 0, b = b ? b.__html : void 0, null != k && b !== k && (f = f || []).push(g, "" + k)) : "children" === g ? b === k || "string" !== typeof k && "number" !== typeof k || (f = f || []).push(g, "" + k) : "suppressContentEditableWarning" !== g && (Oc.hasOwnProperty(g) ? (null != k && Rc(e, g), f || b === k || (f = [])) : (f = f || []).push(g, k));
            }

            a && (f = f || []).push("style", a);
            return f;
          },
          updateProperties: function updateProperties(a, b, c, d, e) {
            Cc(c, d);
            d = Cc(c, e);

            for (var f = 0; f < b.length; f += 2) {
              var g = b[f],
                  h = b[f + 1];
              "style" === g ? bc.setValueForStyles(a, h) : "dangerouslySetInnerHTML" === g ? Fc(a, h) : "children" === g ? Jc(a, h) : d ? null != h ? hc.setValueForAttribute(a, g, h) : hc.deleteValueForAttribute(a, g) : null != h ? hc.setValueForProperty(a, g, h) : hc.deleteValueForProperty(a, g);
            }

            switch (c) {
              case "input":
                qc.updateWrapper(a, e);
                Bc.updateValueIfChanged(a);
                break;

              case "textarea":
                wc.updateWrapper(a, e);
                break;

              case "select":
                uc.postUpdateWrapper(a, e);
            }
          },
          diffHydratedProperties: function diffHydratedProperties(a, b, c, d, e) {
            switch (b) {
              case "iframe":
              case "object":
                M.trapBubbledEvent("topLoad", "load", a);
                break;

              case "video":
              case "audio":
                for (var f in Sc) {
                  Sc.hasOwnProperty(f) && M.trapBubbledEvent(f, Sc[f], a);
                }

                break;

              case "source":
                M.trapBubbledEvent("topError", "error", a);
                break;

              case "img":
              case "image":
                M.trapBubbledEvent("topError", "error", a);
                M.trapBubbledEvent("topLoad", "load", a);
                break;

              case "form":
                M.trapBubbledEvent("topReset", "reset", a);
                M.trapBubbledEvent("topSubmit", "submit", a);
                break;

              case "details":
                M.trapBubbledEvent("topToggle", "toggle", a);
                break;

              case "input":
                qc.initWrapperState(a, c);
                M.trapBubbledEvent("topInvalid", "invalid", a);
                Rc(e, "onChange");
                break;

              case "option":
                sc.validateProps(a, c);
                break;

              case "select":
                uc.initWrapperState(a, c);
                M.trapBubbledEvent("topInvalid", "invalid", a);
                Rc(e, "onChange");
                break;

              case "textarea":
                wc.initWrapperState(a, c), M.trapBubbledEvent("topInvalid", "invalid", a), Rc(e, "onChange");
            }

            yc(b, c, Kc);
            d = null;

            for (var g in c) {
              c.hasOwnProperty(g) && (f = c[g], "children" === g ? "string" === typeof f ? a.textContent !== f && (d = ["children", f]) : "number" === typeof f && a.textContent !== "" + f && (d = ["children", "" + f]) : Oc.hasOwnProperty(g) && null != f && Rc(e, g));
            }

            switch (b) {
              case "input":
                Bc.track(a);
                qc.postMountWrapper(a, c);
                break;

              case "textarea":
                Bc.track(a);
                wc.postMountWrapper(a, c);
                break;

              case "select":
              case "option":
                break;

              default:
                "function" === typeof c.onClick && (a.onclick = ca);
            }

            return d;
          },
          diffHydratedText: function diffHydratedText(a, b) {
            return a.nodeValue !== b;
          },
          warnForDeletedHydratableElement: function warnForDeletedHydratableElement() {},
          warnForDeletedHydratableText: function warnForDeletedHydratableText() {},
          warnForInsertedHydratedElement: function warnForInsertedHydratedElement() {},
          warnForInsertedHydratedText: function warnForInsertedHydratedText() {},
          restoreControlledState: function restoreControlledState(a, b, c) {
            switch (b) {
              case "input":
                qc.restoreControlledState(a, c);
                break;

              case "textarea":
                wc.restoreControlledState(a, c);
                break;

              case "select":
                uc.restoreControlledState(a, c);
            }
          }
        },
            Tc = void 0;
        if (l.canUseDOM) {
          if ("function" !== typeof requestIdleCallback) {
            var Uc = null,
                Vc = null,
                Wc = !1,
                Xc = !1,
                Yc = 0,
                Zc = 33,
                $c = 33,
                ad = {
              timeRemaining: "object" === typeof performance && "function" === typeof performance.now ? function () {
                return Yc - performance.now();
              } : function () {
                return Yc - Date.now();
              }
            },
                bd = "__reactIdleCallback$" + Math.random().toString(36).slice(2);
            window.addEventListener("message", function (a) {
              a.source === window && a.data === bd && (Wc = !1, a = Vc, Vc = null, null !== a && a(ad));
            }, !1);

            var cd = function cd(a) {
              Xc = !1;
              var b = a - Yc + $c;
              b < $c && Zc < $c ? (8 > b && (b = 8), $c = b < Zc ? Zc : b) : Zc = b;
              Yc = a + $c;
              Wc || (Wc = !0, window.postMessage(bd, "*"));
              b = Uc;
              Uc = null;
              null !== b && b(a);
            };

            Tc = function Tc(a) {
              Vc = a;
              Xc || (Xc = !0, requestAnimationFrame(cd));
              return 0;
            };
          } else Tc = requestIdleCallback;
        } else Tc = function Tc(a) {
          setTimeout(function () {
            a({
              timeRemaining: function timeRemaining() {
                return Infinity;
              }
            });
          });
          return 0;
        };
        var dd = {
          rIC: Tc
        },
            ed = {
          enableAsyncSubtreeAPI: !0
        },
            Q = {
          NoWork: 0,
          SynchronousPriority: 1,
          TaskPriority: 2,
          HighPriority: 3,
          LowPriority: 4,
          OffscreenPriority: 5
        },
            fd = J.Callback,
            gd = Q.NoWork,
            hd = Q.SynchronousPriority,
            id = Q.TaskPriority,
            jd = E.ClassComponent,
            kd = E.HostRoot,
            md = void 0,
            nd = void 0;

        function od(a, b) {
          return a !== id && a !== hd || b !== id && b !== hd ? a === gd && b !== gd ? -255 : a !== gd && b === gd ? 255 : a - b : 0;
        }

        function pd() {
          return {
            first: null,
            last: null,
            hasForceUpdate: !1,
            callbackList: null
          };
        }

        function qd(a, b, c, d) {
          null !== c ? c.next = b : (b.next = a.first, a.first = b);
          null !== d ? b.next = d : a.last = b;
        }

        function rd(a, b) {
          b = b.priorityLevel;
          var c = null;
          if (null !== a.last && 0 >= od(a.last.priorityLevel, b)) c = a.last;else for (a = a.first; null !== a && 0 >= od(a.priorityLevel, b);) {
            c = a, a = a.next;
          }
          return c;
        }

        function sd(a, b) {
          var c = a.alternate,
              d = a.updateQueue;
          null === d && (d = a.updateQueue = pd());
          null !== c ? (a = c.updateQueue, null === a && (a = c.updateQueue = pd())) : a = null;
          md = d;
          nd = a !== d ? a : null;
          var e = md;
          c = nd;
          var f = rd(e, b),
              g = null !== f ? f.next : e.first;
          if (null === c) return qd(e, b, f, g), null;
          d = rd(c, b);
          a = null !== d ? d.next : c.first;
          qd(e, b, f, g);
          if (g === a && null !== g || f === d && null !== f) return null === d && (c.first = b), null === a && (c.last = null), null;
          b = {
            priorityLevel: b.priorityLevel,
            partialState: b.partialState,
            callback: b.callback,
            isReplace: b.isReplace,
            isForced: b.isForced,
            isTopLevelUnmount: b.isTopLevelUnmount,
            next: null
          };
          qd(c, b, d, a);
          return b;
        }

        function td(a, b, c, d) {
          a = a.partialState;
          return "function" === typeof a ? a.call(b, c, d) : a;
        }

        var ud = {
          addUpdate: function addUpdate(a, b, c, d) {
            sd(a, {
              priorityLevel: d,
              partialState: b,
              callback: c,
              isReplace: !1,
              isForced: !1,
              isTopLevelUnmount: !1,
              next: null
            });
          },
          addReplaceUpdate: function addReplaceUpdate(a, b, c, d) {
            sd(a, {
              priorityLevel: d,
              partialState: b,
              callback: c,
              isReplace: !0,
              isForced: !1,
              isTopLevelUnmount: !1,
              next: null
            });
          },
          addForceUpdate: function addForceUpdate(a, b, c) {
            sd(a, {
              priorityLevel: c,
              partialState: null,
              callback: b,
              isReplace: !1,
              isForced: !0,
              isTopLevelUnmount: !1,
              next: null
            });
          },
          getUpdatePriority: function getUpdatePriority(a) {
            var b = a.updateQueue;
            return null === b || a.tag !== jd && a.tag !== kd ? gd : null !== b.first ? b.first.priorityLevel : gd;
          },
          addTopLevelUpdate: function addTopLevelUpdate(a, b, c, d) {
            var e = null === b.element;
            b = {
              priorityLevel: d,
              partialState: b,
              callback: c,
              isReplace: !1,
              isForced: !1,
              isTopLevelUnmount: e,
              next: null
            };
            a = sd(a, b);
            e && (e = md, c = nd, null !== e && null !== b.next && (b.next = null, e.last = b), null !== c && null !== a && null !== a.next && (a.next = null, c.last = b));
          },
          beginUpdateQueue: function beginUpdateQueue(a, b, c, d, e, f, g) {
            null !== a && a.updateQueue === c && (c = b.updateQueue = {
              first: c.first,
              last: c.last,
              callbackList: null,
              hasForceUpdate: !1
            });
            a = c.callbackList;

            for (var h = c.hasForceUpdate, k = !0, p = c.first; null !== p && 0 >= od(p.priorityLevel, g);) {
              c.first = p.next;
              null === c.first && (c.last = null);
              var x;
              if (p.isReplace) e = td(p, d, e, f), k = !0;else if (x = td(p, d, e, f)) e = k ? n({}, e, x) : n(e, x), k = !1;
              p.isForced && (h = !0);
              null === p.callback || p.isTopLevelUnmount && null !== p.next || (a = null !== a ? a : [], a.push(p.callback), b.effectTag |= fd);
              p = p.next;
            }

            c.callbackList = a;
            c.hasForceUpdate = h;
            null !== c.first || null !== a || h || (b.updateQueue = null);
            return e;
          },
          commitCallbacks: function commitCallbacks(a, b, c) {
            a = b.callbackList;
            if (null !== a) for (b.callbackList = null, b = 0; b < a.length; b++) {
              var d = a[b];
              "function" !== typeof d ? w("191", d) : void 0;
              d.call(c);
            }
          }
        },
            vd = [],
            wd = -1,
            xd = {
          createCursor: function createCursor(a) {
            return {
              current: a
            };
          },
          isEmpty: function isEmpty() {
            return -1 === wd;
          },
          pop: function pop(a) {
            0 > wd || (a.current = vd[wd], vd[wd] = null, wd--);
          },
          push: function push(a, b) {
            wd++;
            vd[wd] = a.current;
            a.current = b;
          },
          reset: function reset() {
            for (; -1 < wd;) {
              vd[wd] = null, wd--;
            }
          }
        },
            yd = bb.isFiberMounted,
            zd = E.ClassComponent,
            Ad = E.HostRoot,
            Bd = xd.createCursor,
            Cd = xd.pop,
            Dd = xd.push,
            Ed = Bd(da),
            Fd = Bd(!1),
            Ld = da;

        function Md(a, b, c) {
          a = a.stateNode;
          a.__reactInternalMemoizedUnmaskedChildContext = b;
          a.__reactInternalMemoizedMaskedChildContext = c;
        }

        function Nd(a) {
          return a.tag === zd && null != a.type.childContextTypes;
        }

        function Od(a, b) {
          var c = a.stateNode,
              d = a.type.childContextTypes;
          if ("function" !== typeof c.getChildContext) return b;
          c = c.getChildContext();

          for (var e in c) {
            e in d ? void 0 : w("108", Ra(a) || "Unknown", e);
          }

          return n({}, b, c);
        }

        var R = {
          getUnmaskedContext: function getUnmaskedContext(a) {
            return Nd(a) ? Ld : Ed.current;
          },
          cacheContext: Md,
          getMaskedContext: function getMaskedContext(a, b) {
            var c = a.type.contextTypes;
            if (!c) return da;
            var d = a.stateNode;
            if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
            var e = {},
                f;

            for (f in c) {
              e[f] = b[f];
            }

            d && Md(a, b, e);
            return e;
          },
          hasContextChanged: function hasContextChanged() {
            return Fd.current;
          },
          isContextConsumer: function isContextConsumer(a) {
            return a.tag === zd && null != a.type.contextTypes;
          },
          isContextProvider: Nd,
          popContextProvider: function popContextProvider(a) {
            Nd(a) && (Cd(Fd, a), Cd(Ed, a));
          },
          popTopLevelContextObject: function popTopLevelContextObject(a) {
            Cd(Fd, a);
            Cd(Ed, a);
          },
          pushTopLevelContextObject: function pushTopLevelContextObject(a, b, c) {
            null != Ed.cursor ? w("168") : void 0;
            Dd(Ed, b, a);
            Dd(Fd, c, a);
          },
          processChildContext: Od,
          pushContextProvider: function pushContextProvider(a) {
            if (!Nd(a)) return !1;
            var b = a.stateNode;
            b = b && b.__reactInternalMemoizedMergedChildContext || da;
            Ld = Ed.current;
            Dd(Ed, b, a);
            Dd(Fd, Fd.current, a);
            return !0;
          },
          invalidateContextProvider: function invalidateContextProvider(a, b) {
            var c = a.stateNode;
            c ? void 0 : w("169");

            if (b) {
              var d = Od(a, Ld, !0);
              c.__reactInternalMemoizedMergedChildContext = d;
              Cd(Fd, a);
              Cd(Ed, a);
              Dd(Ed, d, a);
            } else Cd(Fd, a);

            Dd(Fd, b, a);
          },
          resetContext: function resetContext() {
            Ld = da;
            Ed.current = da;
            Fd.current = !1;
          },
          findCurrentUnmaskedContext: function findCurrentUnmaskedContext(a) {
            for (yd(a) && a.tag === zd ? void 0 : w("170"); a.tag !== Ad;) {
              if (Nd(a)) return a.stateNode.__reactInternalMemoizedMergedChildContext;
              (a = a["return"]) ? void 0 : w("171");
            }

            return a.stateNode.context;
          }
        },
            Pd = {
          NoContext: 0,
          AsyncUpdates: 1
        },
            Qd = E.IndeterminateComponent,
            Rd = E.ClassComponent,
            Sd = E.HostRoot,
            Td = E.HostComponent,
            Ud = E.HostText,
            Vd = E.HostPortal,
            Wd = E.CoroutineComponent,
            Xd = E.YieldComponent,
            Yd = E.Fragment,
            Zd = Q.NoWork,
            $d = Pd.NoContext,
            ae = J.NoEffect;

        function be(a, b, c) {
          this.tag = a;
          this.key = b;
          this.stateNode = this.type = null;
          this.sibling = this.child = this["return"] = null;
          this.index = 0;
          this.memoizedState = this.updateQueue = this.memoizedProps = this.pendingProps = this.ref = null;
          this.internalContextTag = c;
          this.effectTag = ae;
          this.lastEffect = this.firstEffect = this.nextEffect = null;
          this.pendingWorkPriority = Zd;
          this.alternate = null;
        }

        function ce(a, b, c) {
          var d = void 0;
          "function" === typeof a ? (d = a.prototype && a.prototype.isReactComponent ? new be(Rd, b, c) : new be(Qd, b, c), d.type = a) : "string" === typeof a ? (d = new be(Td, b, c), d.type = a) : "object" === typeof a && null !== a && "number" === typeof a.tag ? d = a : w("130", null == a ? a : typeof a, "");
          return d;
        }

        var de = {
          createWorkInProgress: function createWorkInProgress(a, b) {
            var c = a.alternate;
            null === c ? (c = new be(a.tag, a.key, a.internalContextTag), c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.effectTag = ae, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
            c.pendingWorkPriority = b;
            c.child = a.child;
            c.memoizedProps = a.memoizedProps;
            c.memoizedState = a.memoizedState;
            c.updateQueue = a.updateQueue;
            c.sibling = a.sibling;
            c.index = a.index;
            c.ref = a.ref;
            return c;
          },
          createHostRootFiber: function createHostRootFiber() {
            return new be(Sd, null, $d);
          },
          createFiberFromElement: function createFiberFromElement(a, b, c) {
            b = ce(a.type, a.key, b, null);
            b.pendingProps = a.props;
            b.pendingWorkPriority = c;
            return b;
          },
          createFiberFromFragment: function createFiberFromFragment(a, b, c) {
            b = new be(Yd, null, b);
            b.pendingProps = a;
            b.pendingWorkPriority = c;
            return b;
          },
          createFiberFromText: function createFiberFromText(a, b, c) {
            b = new be(Ud, null, b);
            b.pendingProps = a;
            b.pendingWorkPriority = c;
            return b;
          },
          createFiberFromElementType: ce,
          createFiberFromHostInstanceForDeletion: function createFiberFromHostInstanceForDeletion() {
            var a = new be(Td, null, $d);
            a.type = "DELETED";
            return a;
          },
          createFiberFromCoroutine: function createFiberFromCoroutine(a, b, c) {
            b = new be(Wd, a.key, b);
            b.type = a.handler;
            b.pendingProps = a;
            b.pendingWorkPriority = c;
            return b;
          },
          createFiberFromYield: function createFiberFromYield(a, b) {
            return new be(Xd, null, b);
          },
          createFiberFromPortal: function createFiberFromPortal(a, b, c) {
            b = new be(Vd, a.key, b);
            b.pendingProps = a.children || [];
            b.pendingWorkPriority = c;
            b.stateNode = {
              containerInfo: a.containerInfo,
              implementation: a.implementation
            };
            return b;
          },
          largerPriority: function largerPriority(a, b) {
            return a !== Zd && (b === Zd || b > a) ? a : b;
          }
        },
            ee = de.createHostRootFiber,
            fe = E.IndeterminateComponent,
            ge = E.FunctionalComponent,
            he = E.ClassComponent,
            ie = E.HostComponent,
            je,
            ke;
        "function" === typeof Symbol && Symbol["for"] ? (je = Symbol["for"]("react.coroutine"), ke = Symbol["for"]("react.yield")) : (je = 60104, ke = 60105);
        var le = {
          createCoroutine: function createCoroutine(a, b, c) {
            var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
            return {
              $$typeof: je,
              key: null == d ? null : "" + d,
              children: a,
              handler: b,
              props: c
            };
          },
          createYield: function createYield(a) {
            return {
              $$typeof: ke,
              value: a
            };
          },
          isCoroutine: function isCoroutine(a) {
            return "object" === typeof a && null !== a && a.$$typeof === je;
          },
          isYield: function isYield(a) {
            return "object" === typeof a && null !== a && a.$$typeof === ke;
          },
          REACT_YIELD_TYPE: ke,
          REACT_COROUTINE_TYPE: je
        },
            me = "function" === typeof Symbol && Symbol["for"] && Symbol["for"]("react.portal") || 60106,
            ne = {
          createPortal: function createPortal(a, b, c) {
            var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
            return {
              $$typeof: me,
              key: null == d ? null : "" + d,
              children: a,
              containerInfo: b,
              implementation: c
            };
          },
          isPortal: function isPortal(a) {
            return "object" === typeof a && null !== a && a.$$typeof === me;
          },
          REACT_PORTAL_TYPE: me
        },
            oe = le.REACT_COROUTINE_TYPE,
            pe = le.REACT_YIELD_TYPE,
            qe = ne.REACT_PORTAL_TYPE,
            re = de.createWorkInProgress,
            se = de.createFiberFromElement,
            te = de.createFiberFromFragment,
            ue = de.createFiberFromText,
            ve = de.createFiberFromCoroutine,
            we = de.createFiberFromYield,
            xe = de.createFiberFromPortal,
            ye = Array.isArray,
            ze = E.FunctionalComponent,
            Ae = E.ClassComponent,
            Be = E.HostText,
            Ce = E.HostPortal,
            De = E.CoroutineComponent,
            Ee = E.YieldComponent,
            Fe = E.Fragment,
            Ge = J.NoEffect,
            He = J.Placement,
            Ie = J.Deletion,
            Je = "function" === typeof Symbol && Symbol.iterator,
            Ke = "function" === typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103;

        function Le(a) {
          if (null === a || "undefined" === typeof a) return null;
          a = Je && a[Je] || a["@@iterator"];
          return "function" === typeof a ? a : null;
        }

        function Me(a, b) {
          var c = b.ref;

          if (null !== c && "function" !== typeof c) {
            if (b._owner) {
              b = b._owner;
              var d = void 0;
              b && ("number" === typeof b.tag ? (b.tag !== Ae ? w("110") : void 0, d = b.stateNode) : d = b.getPublicInstance());
              d ? void 0 : w("147", c);
              var e = "" + c;
              if (null !== a && null !== a.ref && a.ref._stringRef === e) return a.ref;

              a = function a(_a) {
                var b = d.refs === da ? d.refs = {} : d.refs;
                null === _a ? delete b[e] : b[e] = _a;
              };

              a._stringRef = e;
              return a;
            }

            "string" !== typeof c ? w("148") : void 0;
            b._owner ? void 0 : w("149", c);
          }

          return c;
        }

        function Ne(a, b) {
          "textarea" !== a.type && w("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
        }

        function Oe(a, b) {
          function c(c, d) {
            if (b) {
              if (!a) {
                if (null === d.alternate) return;
                d = d.alternate;
              }

              var m = c.lastEffect;
              null !== m ? (m.nextEffect = d, c.lastEffect = d) : c.firstEffect = c.lastEffect = d;
              d.nextEffect = null;
              d.effectTag = Ie;
            }
          }

          function d(a, d) {
            if (!b) return null;

            for (; null !== d;) {
              c(a, d), d = d.sibling;
            }

            return null;
          }

          function e(a, b) {
            for (a = new Map(); null !== b;) {
              null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
            }

            return a;
          }

          function f(b, c) {
            if (a) return b = re(b, c), b.index = 0, b.sibling = null, b;
            b.pendingWorkPriority = c;
            b.effectTag = Ge;
            b.index = 0;
            b.sibling = null;
            return b;
          }

          function g(a, c, d) {
            a.index = d;
            if (!b) return c;
            d = a.alternate;
            if (null !== d) return d = d.index, d < c ? (a.effectTag = He, c) : d;
            a.effectTag = He;
            return c;
          }

          function h(a) {
            b && null === a.alternate && (a.effectTag = He);
            return a;
          }

          function k(a, b, c, d) {
            if (null === b || b.tag !== Be) return c = ue(c, a.internalContextTag, d), c["return"] = a, c;
            b = f(b, d);
            b.pendingProps = c;
            b["return"] = a;
            return b;
          }

          function p(a, b, c, d) {
            if (null === b || b.type !== c.type) return d = se(c, a.internalContextTag, d), d.ref = Me(b, c), d["return"] = a, d;
            d = f(b, d);
            d.ref = Me(b, c);
            d.pendingProps = c.props;
            d["return"] = a;
            return d;
          }

          function x(a, b, c, d) {
            if (null === b || b.tag !== De) return c = ve(c, a.internalContextTag, d), c["return"] = a, c;
            b = f(b, d);
            b.pendingProps = c;
            b["return"] = a;
            return b;
          }

          function S(a, b, c, d) {
            if (null === b || b.tag !== Ee) return b = we(c, a.internalContextTag, d), b.type = c.value, b["return"] = a, b;
            b = f(b, d);
            b.type = c.value;
            b["return"] = a;
            return b;
          }

          function D(a, b, c, d) {
            if (null === b || b.tag !== Ce || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return c = xe(c, a.internalContextTag, d), c["return"] = a, c;
            b = f(b, d);
            b.pendingProps = c.children || [];
            b["return"] = a;
            return b;
          }

          function y(a, b, c, d) {
            if (null === b || b.tag !== Fe) return c = te(c, a.internalContextTag, d), c["return"] = a, c;
            b = f(b, d);
            b.pendingProps = c;
            b["return"] = a;
            return b;
          }

          function B(a, b, c) {
            if ("string" === typeof b || "number" === typeof b) return b = ue("" + b, a.internalContextTag, c), b["return"] = a, b;

            if ("object" === typeof b && null !== b) {
              switch (b.$$typeof) {
                case Ke:
                  return c = se(b, a.internalContextTag, c), c.ref = Me(null, b), c["return"] = a, c;

                case oe:
                  return b = ve(b, a.internalContextTag, c), b["return"] = a, b;

                case pe:
                  return c = we(b, a.internalContextTag, c), c.type = b.value, c["return"] = a, c;

                case qe:
                  return b = xe(b, a.internalContextTag, c), b["return"] = a, b;
              }

              if (ye(b) || Le(b)) return b = te(b, a.internalContextTag, c), b["return"] = a, b;
              Ne(a, b);
            }

            return null;
          }

          function H(a, b, c, d) {
            var e = null !== b ? b.key : null;
            if ("string" === typeof c || "number" === typeof c) return null !== e ? null : k(a, b, "" + c, d);

            if ("object" === typeof c && null !== c) {
              switch (c.$$typeof) {
                case Ke:
                  return c.key === e ? p(a, b, c, d) : null;

                case oe:
                  return c.key === e ? x(a, b, c, d) : null;

                case pe:
                  return null === e ? S(a, b, c, d) : null;

                case qe:
                  return c.key === e ? D(a, b, c, d) : null;
              }

              if (ye(c) || Le(c)) return null !== e ? null : y(a, b, c, d);
              Ne(a, c);
            }

            return null;
          }

          function C(a, b, c, d, e) {
            if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, k(b, a, "" + d, e);

            if ("object" === typeof d && null !== d) {
              switch (d.$$typeof) {
                case Ke:
                  return a = a.get(null === d.key ? c : d.key) || null, p(b, a, d, e);

                case oe:
                  return a = a.get(null === d.key ? c : d.key) || null, x(b, a, d, e);

                case pe:
                  return a = a.get(c) || null, S(b, a, d, e);

                case qe:
                  return a = a.get(null === d.key ? c : d.key) || null, D(b, a, d, e);
              }

              if (ye(d) || Le(d)) return a = a.get(c) || null, y(b, a, d, e);
              Ne(b, d);
            }

            return null;
          }

          function Ca(a, f, h, k) {
            for (var m = null, t = null, q = f, r = f = 0, p = null; null !== q && r < h.length; r++) {
              q.index > r ? (p = q, q = null) : p = q.sibling;
              var v = H(a, q, h[r], k);

              if (null === v) {
                null === q && (q = p);
                break;
              }

              b && q && null === v.alternate && c(a, q);
              f = g(v, f, r);
              null === t ? m = v : t.sibling = v;
              t = v;
              q = p;
            }

            if (r === h.length) return d(a, q), m;

            if (null === q) {
              for (; r < h.length; r++) {
                if (q = B(a, h[r], k)) f = g(q, f, r), null === t ? m = q : t.sibling = q, t = q;
              }

              return m;
            }

            for (q = e(a, q); r < h.length; r++) {
              if (p = C(q, a, r, h[r], k)) {
                if (b && null !== p.alternate) q["delete"](null === p.key ? r : p.key);
                f = g(p, f, r);
                null === t ? m = p : t.sibling = p;
                t = p;
              }
            }

            b && q.forEach(function (b) {
              return c(a, b);
            });
            return m;
          }

          function r(a, f, h, r) {
            var m = Le(h);
            "function" !== typeof m ? w("150") : void 0;
            h = m.call(h);
            null == h ? w("151") : void 0;

            for (var t = m = null, q = f, k = f = 0, p = null, v = h.next(); null !== q && !v.done; k++, v = h.next()) {
              q.index > k ? (p = q, q = null) : p = q.sibling;
              var V = H(a, q, v.value, r);

              if (null === V) {
                q || (q = p);
                break;
              }

              b && q && null === V.alternate && c(a, q);
              f = g(V, f, k);
              null === t ? m = V : t.sibling = V;
              t = V;
              q = p;
            }

            if (v.done) return d(a, q), m;

            if (null === q) {
              for (; !v.done; k++, v = h.next()) {
                v = B(a, v.value, r), null !== v && (f = g(v, f, k), null === t ? m = v : t.sibling = v, t = v);
              }

              return m;
            }

            for (q = e(a, q); !v.done; k++, v = h.next()) {
              if (v = C(q, a, k, v.value, r), null !== v) {
                if (b && null !== v.alternate) q["delete"](null === v.key ? k : v.key);
                f = g(v, f, k);
                null === t ? m = v : t.sibling = v;
                t = v;
              }
            }

            b && q.forEach(function (b) {
              return c(a, b);
            });
            return m;
          }

          return function (a, b, e, g) {
            var m = "object" === typeof e && null !== e;
            if (m) switch (e.$$typeof) {
              case Ke:
                a: {
                  var C = e.key;

                  for (m = b; null !== m;) {
                    if (m.key === C) {
                      if (m.type === e.type) {
                        d(a, m.sibling);
                        b = f(m, g);
                        b.ref = Me(m, e);
                        b.pendingProps = e.props;
                        b["return"] = a;
                        a = b;
                        break a;
                      } else {
                        d(a, m);
                        break;
                      }
                    } else c(a, m);
                    m = m.sibling;
                  }

                  g = se(e, a.internalContextTag, g);
                  g.ref = Me(b, e);
                  g["return"] = a;
                  a = g;
                }

                return h(a);

              case oe:
                a: {
                  for (m = e.key; null !== b;) {
                    if (b.key === m) {
                      if (b.tag === De) {
                        d(a, b.sibling);
                        b = f(b, g);
                        b.pendingProps = e;
                        b["return"] = a;
                        a = b;
                        break a;
                      } else {
                        d(a, b);
                        break;
                      }
                    } else c(a, b);
                    b = b.sibling;
                  }

                  e = ve(e, a.internalContextTag, g);
                  e["return"] = a;
                  a = e;
                }

                return h(a);

              case pe:
                a: {
                  if (null !== b) if (b.tag === Ee) {
                    d(a, b.sibling);
                    b = f(b, g);
                    b.type = e.value;
                    b["return"] = a;
                    a = b;
                    break a;
                  } else d(a, b);
                  b = we(e, a.internalContextTag, g);
                  b.type = e.value;
                  b["return"] = a;
                  a = b;
                }

                return h(a);

              case qe:
                a: {
                  for (m = e.key; null !== b;) {
                    if (b.key === m) {
                      if (b.tag === Ce && b.stateNode.containerInfo === e.containerInfo && b.stateNode.implementation === e.implementation) {
                        d(a, b.sibling);
                        b = f(b, g);
                        b.pendingProps = e.children || [];
                        b["return"] = a;
                        a = b;
                        break a;
                      } else {
                        d(a, b);
                        break;
                      }
                    } else c(a, b);
                    b = b.sibling;
                  }

                  e = xe(e, a.internalContextTag, g);
                  e["return"] = a;
                  a = e;
                }

                return h(a);
            }
            if ("string" === typeof e || "number" === typeof e) return e = "" + e, null !== b && b.tag === Be ? (d(a, b.sibling), b = f(b, g), b.pendingProps = e, b["return"] = a, a = b) : (d(a, b), e = ue(e, a.internalContextTag, g), e["return"] = a, a = e), h(a);
            if (ye(e)) return Ca(a, b, e, g);
            if (Le(e)) return r(a, b, e, g);
            m && Ne(a, e);
            if ("undefined" === typeof e) switch (a.tag) {
              case Ae:
              case ze:
                e = a.type, w("152", e.displayName || e.name || "Component");
            }
            return d(a, b);
          };
        }

        var Pe = Oe(!0, !0),
            Qe = Oe(!1, !0),
            Re = Oe(!1, !1),
            Se = {
          reconcileChildFibers: Pe,
          reconcileChildFibersInPlace: Qe,
          mountChildFibersInPlace: Re,
          cloneChildFibers: function cloneChildFibers(a, b) {
            null !== a && b.child !== a.child ? w("153") : void 0;

            if (null !== b.child) {
              a = b.child;
              var c = re(a, a.pendingWorkPriority);
              c.pendingProps = a.pendingProps;
              b.child = c;

              for (c["return"] = b; null !== a.sibling;) {
                a = a.sibling, c = c.sibling = re(a, a.pendingWorkPriority), c.pendingProps = a.pendingProps, c["return"] = b;
              }

              c.sibling = null;
            }
          }
        },
            Te = J.Update,
            Ue = Pd.AsyncUpdates,
            Ve = R.cacheContext,
            We = R.getMaskedContext,
            Xe = R.getUnmaskedContext,
            Ye = R.isContextConsumer,
            Ze = ud.addUpdate,
            $e = ud.addReplaceUpdate,
            af = ud.addForceUpdate,
            bf = ud.beginUpdateQueue,
            cf = R.hasContextChanged,
            df = bb.isMounted;

        function ef(a, b, c, d) {
          function e(a, b) {
            b.updater = f;
            a.stateNode = b;
            Pa.set(b, a);
          }

          var f = {
            isMounted: df,
            enqueueSetState: function enqueueSetState(c, d, e) {
              c = Pa.get(c);
              var f = b(c, !1);
              Ze(c, d, void 0 === e ? null : e, f);
              a(c, f);
            },
            enqueueReplaceState: function enqueueReplaceState(c, d, e) {
              c = Pa.get(c);
              var f = b(c, !1);
              $e(c, d, void 0 === e ? null : e, f);
              a(c, f);
            },
            enqueueForceUpdate: function enqueueForceUpdate(c, d) {
              c = Pa.get(c);
              var e = b(c, !1);
              af(c, void 0 === d ? null : d, e);
              a(c, e);
            }
          };
          return {
            adoptClassInstance: e,
            constructClassInstance: function constructClassInstance(a, b) {
              var c = a.type,
                  d = Xe(a),
                  f = Ye(a),
                  g = f ? We(a, d) : da;
              b = new c(b, g);
              e(a, b);
              f && Ve(a, d, g);
              return b;
            },
            mountClassInstance: function mountClassInstance(a, b) {
              var c = a.alternate,
                  d = a.stateNode,
                  e = d.state || null,
                  g = a.pendingProps;
              g ? void 0 : w("158");
              var h = Xe(a);
              d.props = g;
              d.state = e;
              d.refs = da;
              d.context = We(a, h);
              ed.enableAsyncSubtreeAPI && null != a.type && null != a.type.prototype && !0 === a.type.prototype.unstable_isAsyncReactComponent && (a.internalContextTag |= Ue);
              "function" === typeof d.componentWillMount && (h = d.state, d.componentWillMount(), h !== d.state && f.enqueueReplaceState(d, d.state, null), h = a.updateQueue, null !== h && (d.state = bf(c, a, h, d, e, g, b)));
              "function" === typeof d.componentDidMount && (a.effectTag |= Te);
            },
            updateClassInstance: function updateClassInstance(a, b, e) {
              var g = b.stateNode;
              g.props = b.memoizedProps;
              g.state = b.memoizedState;
              var h = b.memoizedProps,
                  k = b.pendingProps;
              k || (k = h, null == k ? w("159") : void 0);
              var D = g.context,
                  y = Xe(b);
              y = We(b, y);
              "function" !== typeof g.componentWillReceiveProps || h === k && D === y || (D = g.state, g.componentWillReceiveProps(k, y), g.state !== D && f.enqueueReplaceState(g, g.state, null));
              D = b.memoizedState;
              e = null !== b.updateQueue ? bf(a, b, b.updateQueue, g, D, k, e) : D;
              if (!(h !== k || D !== e || cf() || null !== b.updateQueue && b.updateQueue.hasForceUpdate)) return "function" !== typeof g.componentDidUpdate || h === a.memoizedProps && D === a.memoizedState || (b.effectTag |= Te), !1;
              var B = k;
              if (null === h || null !== b.updateQueue && b.updateQueue.hasForceUpdate) B = !0;else {
                var H = b.stateNode,
                    C = b.type;
                B = "function" === typeof H.shouldComponentUpdate ? H.shouldComponentUpdate(B, e, y) : C.prototype && C.prototype.isPureReactComponent ? !ea(h, B) || !ea(D, e) : !0;
              }
              B ? ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(k, e, y), "function" === typeof g.componentDidUpdate && (b.effectTag |= Te)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && D === a.memoizedState || (b.effectTag |= Te), c(b, k), d(b, e));
              g.props = k;
              g.state = e;
              g.context = y;
              return B;
            }
          };
        }

        var ff = Se.mountChildFibersInPlace,
            gf = Se.reconcileChildFibers,
            hf = Se.reconcileChildFibersInPlace,
            jf = Se.cloneChildFibers,
            kf = ud.beginUpdateQueue,
            lf = R.getMaskedContext,
            mf = R.getUnmaskedContext,
            nf = R.hasContextChanged,
            of = R.pushContextProvider,
            pf = R.pushTopLevelContextObject,
            qf = R.invalidateContextProvider,
            rf = E.IndeterminateComponent,
            sf = E.FunctionalComponent,
            tf = E.ClassComponent,
            uf = E.HostRoot,
            wf = E.HostComponent,
            xf = E.HostText,
            yf = E.HostPortal,
            zf = E.CoroutineComponent,
            Af = E.CoroutineHandlerPhase,
            Bf = E.YieldComponent,
            Cf = E.Fragment,
            Df = Q.NoWork,
            Ef = Q.OffscreenPriority,
            Ff = J.PerformedWork,
            Gf = J.Placement,
            Hf = J.ContentReset,
            If = J.Err,
            Jf = J.Ref,
            Kf = Qa.ReactCurrentOwner;

        function Lf(a, b, c, d, e) {
          function f(a, b, c) {
            g(a, b, c, b.pendingWorkPriority);
          }

          function g(a, b, c, d) {
            b.child = null === a ? ff(b, b.child, c, d) : a.child === b.child ? gf(b, b.child, c, d) : hf(b, b.child, c, d);
          }

          function h(a, b) {
            var c = b.ref;
            null === c || a && a.ref === c || (b.effectTag |= Jf);
          }

          function k(a, b, c, d) {
            h(a, b);
            if (!c) return d && qf(b, !1), x(a, b);
            c = b.stateNode;
            Kf.current = b;
            var e = c.render();
            b.effectTag |= Ff;
            f(a, b, e);
            b.memoizedState = c.state;
            b.memoizedProps = c.props;
            d && qf(b, !0);
            return b.child;
          }

          function p(a) {
            var b = a.stateNode;
            b.pendingContext ? pf(a, b.pendingContext, b.pendingContext !== b.context) : b.context && pf(a, b.context, !1);
            C(a, b.containerInfo);
          }

          function x(a, b) {
            jf(a, b);
            return b.child;
          }

          function S(a, b) {
            switch (b.tag) {
              case uf:
                p(b);
                break;

              case tf:
                of(b);
                break;

              case yf:
                C(b, b.stateNode.containerInfo);
            }

            return null;
          }

          var D = a.shouldSetTextContent,
              y = a.useSyncScheduling,
              B = a.shouldDeprioritizeSubtree,
              H = b.pushHostContext,
              C = b.pushHostContainer,
              Ca = c.enterHydrationState,
              r = c.resetHydrationState,
              m = c.tryToClaimNextHydratableInstance;
          a = ef(d, e, function (a, b) {
            a.memoizedProps = b;
          }, function (a, b) {
            a.memoizedState = b;
          });
          var t = a.adoptClassInstance,
              v = a.constructClassInstance,
              V = a.mountClassInstance,
              ld = a.updateClassInstance;
          return {
            beginWork: function beginWork(a, b, c) {
              if (b.pendingWorkPriority === Df || b.pendingWorkPriority > c) return S(a, b);

              switch (b.tag) {
                case rf:
                  null !== a ? w("155") : void 0;
                  var d = b.type,
                      e = b.pendingProps,
                      g = mf(b);
                  g = lf(b, g);
                  d = d(e, g);
                  b.effectTag |= Ff;
                  "object" === typeof d && null !== d && "function" === typeof d.render ? (b.tag = tf, e = of(b), t(b, d), V(b, c), b = k(a, b, !0, e)) : (b.tag = sf, f(a, b, d), b.memoizedProps = e, b = b.child);
                  return b;

                case sf:
                  a: {
                    e = b.type;
                    c = b.pendingProps;
                    d = b.memoizedProps;
                    if (nf()) null === c && (c = d);else if (null === c || d === c) {
                      b = x(a, b);
                      break a;
                    }
                    d = mf(b);
                    d = lf(b, d);
                    e = e(c, d);
                    b.effectTag |= Ff;
                    f(a, b, e);
                    b.memoizedProps = c;
                    b = b.child;
                  }

                  return b;

                case tf:
                  return e = of(b), d = void 0, null === a ? b.stateNode ? w("153") : (v(b, b.pendingProps), V(b, c), d = !0) : d = ld(a, b, c), k(a, b, d, e);

                case uf:
                  return p(b), d = b.updateQueue, null !== d ? (e = b.memoizedState, d = kf(a, b, d, null, e, null, c), e === d ? (r(), b = x(a, b)) : (e = d.element, null !== a && null !== a.child || !Ca(b) ? (r(), f(a, b, e)) : (b.effectTag |= Gf, b.child = ff(b, b.child, e, c)), b.memoizedState = d, b = b.child)) : (r(), b = x(a, b)), b;

                case wf:
                  H(b);
                  null === a && m(b);
                  e = b.type;
                  var q = b.memoizedProps;
                  d = b.pendingProps;
                  null === d && (d = q, null === d ? w("154") : void 0);
                  g = null !== a ? a.memoizedProps : null;
                  nf() || null !== d && q !== d ? (q = d.children, D(e, d) ? q = null : g && D(e, g) && (b.effectTag |= Hf), h(a, b), c !== Ef && !y && B(e, d) ? (b.pendingWorkPriority = Ef, b = null) : (f(a, b, q), b.memoizedProps = d, b = b.child)) : b = x(a, b);
                  return b;

                case xf:
                  return null === a && m(b), a = b.pendingProps, null === a && (a = b.memoizedProps), b.memoizedProps = a, null;

                case Af:
                  b.tag = zf;

                case zf:
                  c = b.pendingProps;
                  if (nf()) null === c && (c = a && a.memoizedProps, null === c ? w("154") : void 0);else if (null === c || b.memoizedProps === c) c = b.memoizedProps;
                  e = c.children;
                  d = b.pendingWorkPriority;
                  b.stateNode = null === a ? ff(b, b.stateNode, e, d) : a.child === b.child ? gf(b, b.stateNode, e, d) : hf(b, b.stateNode, e, d);
                  b.memoizedProps = c;
                  return b.stateNode;

                case Bf:
                  return null;

                case yf:
                  a: {
                    C(b, b.stateNode.containerInfo);
                    c = b.pendingWorkPriority;
                    e = b.pendingProps;
                    if (nf()) null === e && (e = a && a.memoizedProps, null == e ? w("154") : void 0);else if (null === e || b.memoizedProps === e) {
                      b = x(a, b);
                      break a;
                    }
                    null === a ? b.child = hf(b, b.child, e, c) : f(a, b, e);
                    b.memoizedProps = e;
                    b = b.child;
                  }

                  return b;

                case Cf:
                  a: {
                    c = b.pendingProps;
                    if (nf()) null === c && (c = b.memoizedProps);else if (null === c || b.memoizedProps === c) {
                      b = x(a, b);
                      break a;
                    }
                    f(a, b, c);
                    b.memoizedProps = c;
                    b = b.child;
                  }

                  return b;

                default:
                  w("156");
              }
            },
            beginFailedWork: function beginFailedWork(a, b, c) {
              switch (b.tag) {
                case tf:
                  of(b);
                  break;

                case uf:
                  p(b);
                  break;

                default:
                  w("157");
              }

              b.effectTag |= If;
              null === a ? b.child = null : b.child !== a.child && (b.child = a.child);
              if (b.pendingWorkPriority === Df || b.pendingWorkPriority > c) return S(a, b);
              b.firstEffect = null;
              b.lastEffect = null;
              g(a, b, null, c);
              b.tag === tf && (a = b.stateNode, b.memoizedProps = a.props, b.memoizedState = a.state);
              return b.child;
            }
          };
        }

        var Mf = Se.reconcileChildFibers,
            Nf = R.popContextProvider,
            Of = R.popTopLevelContextObject,
            Pf = E.IndeterminateComponent,
            Qf = E.FunctionalComponent,
            Rf = E.ClassComponent,
            Sf = E.HostRoot,
            Tf = E.HostComponent,
            Uf = E.HostText,
            Vf = E.HostPortal,
            Wf = E.CoroutineComponent,
            Xf = E.CoroutineHandlerPhase,
            Yf = E.YieldComponent,
            Zf = E.Fragment,
            ag = J.Placement,
            bg = J.Ref,
            cg = J.Update,
            dg = Q.OffscreenPriority;

        function eg(a, b, c) {
          var d = a.createInstance,
              e = a.createTextInstance,
              f = a.appendInitialChild,
              g = a.finalizeInitialChildren,
              h = a.prepareUpdate,
              k = b.getRootHostContainer,
              p = b.popHostContext,
              x = b.getHostContext,
              S = b.popHostContainer,
              D = c.prepareToHydrateHostInstance,
              y = c.prepareToHydrateHostTextInstance,
              B = c.popHydrationState;
          return {
            completeWork: function completeWork(a, b, c) {
              var r = b.pendingProps;
              if (null === r) r = b.memoizedProps;else if (b.pendingWorkPriority !== dg || c === dg) b.pendingProps = null;

              switch (b.tag) {
                case Qf:
                  return null;

                case Rf:
                  return Nf(b), null;

                case Sf:
                  S(b);
                  Of(b);
                  r = b.stateNode;
                  r.pendingContext && (r.context = r.pendingContext, r.pendingContext = null);
                  if (null === a || null === a.child) B(b), b.effectTag &= ~ag;
                  return null;

                case Tf:
                  p(b);
                  c = k();
                  var m = b.type;

                  if (null !== a && null != b.stateNode) {
                    var t = a.memoizedProps,
                        C = b.stateNode,
                        V = x();
                    r = h(C, m, t, r, c, V);
                    if (b.updateQueue = r) b.effectTag |= cg;
                    a.ref !== b.ref && (b.effectTag |= bg);
                  } else {
                    if (!r) return null === b.stateNode ? w("166") : void 0, null;
                    a = x();
                    if (B(b)) D(b, c, a) && (b.effectTag |= cg);else {
                      a = d(m, r, c, a, b);

                      a: for (t = b.child; null !== t;) {
                        if (t.tag === Tf || t.tag === Uf) f(a, t.stateNode);else if (t.tag !== Vf && null !== t.child) {
                          t = t.child;
                          continue;
                        }
                        if (t === b) break a;

                        for (; null === t.sibling;) {
                          if (null === t["return"] || t["return"] === b) break a;
                          t = t["return"];
                        }

                        t = t.sibling;
                      }

                      g(a, m, r, c) && (b.effectTag |= cg);
                      b.stateNode = a;
                    }
                    null !== b.ref && (b.effectTag |= bg);
                  }

                  return null;

                case Uf:
                  if (a && null != b.stateNode) a.memoizedProps !== r && (b.effectTag |= cg);else {
                    if ("string" !== typeof r) return null === b.stateNode ? w("166") : void 0, null;
                    a = k();
                    c = x();
                    B(b) ? y(b) && (b.effectTag |= cg) : b.stateNode = e(r, a, c, b);
                  }
                  return null;

                case Wf:
                  (r = b.memoizedProps) ? void 0 : w("165");
                  b.tag = Xf;
                  c = [];

                  a: for ((m = b.stateNode) && (m["return"] = b); null !== m;) {
                    if (m.tag === Tf || m.tag === Uf || m.tag === Vf) w("164");else if (m.tag === Yf) c.push(m.type);else if (null !== m.child) {
                      m.child["return"] = m;
                      m = m.child;
                      continue;
                    }

                    for (; null === m.sibling;) {
                      if (null === m["return"] || m["return"] === b) break a;
                      m = m["return"];
                    }

                    m.sibling["return"] = m["return"];
                    m = m.sibling;
                  }

                  m = r.handler;
                  r = m(r.props, c);
                  b.child = Mf(b, null !== a ? a.child : null, r, b.pendingWorkPriority);
                  return b.child;

                case Xf:
                  return b.tag = Wf, null;

                case Yf:
                  return null;

                case Zf:
                  return null;

                case Vf:
                  return b.effectTag |= cg, S(b), null;

                case Pf:
                  w("167");

                default:
                  w("156");
              }
            }
          };
        }

        var fg = null,
            gg = null;

        function hg(a) {
          return function (b) {
            try {
              return a(b);
            } catch (c) {}
          };
        }

        var ig = {
          injectInternals: function injectInternals(a) {
            if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
            var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (!b.supportsFiber) return !0;

            try {
              var c = b.inject(a);
              fg = hg(function (a) {
                return b.onCommitFiberRoot(c, a);
              });
              gg = hg(function (a) {
                return b.onCommitFiberUnmount(c, a);
              });
            } catch (d) {}

            return !0;
          },
          onCommitRoot: function onCommitRoot(a) {
            "function" === typeof fg && fg(a);
          },
          onCommitUnmount: function onCommitUnmount(a) {
            "function" === typeof gg && gg(a);
          }
        },
            jg = E.ClassComponent,
            kg = E.HostRoot,
            lg = E.HostComponent,
            mg = E.HostText,
            ng = E.HostPortal,
            og = E.CoroutineComponent,
            pg = ud.commitCallbacks,
            qg = ig.onCommitUnmount,
            rg = J.Placement,
            sg = J.Update,
            tg = J.Callback,
            ug = J.ContentReset;

        function vg(a, b) {
          function c(a) {
            var c = a.ref;
            if (null !== c) try {
              c(null);
            } catch (t) {
              b(a, t);
            }
          }

          function d(a) {
            return a.tag === lg || a.tag === kg || a.tag === ng;
          }

          function e(a) {
            for (var b = a;;) {
              if (g(b), null !== b.child && b.tag !== ng) b.child["return"] = b, b = b.child;else {
                if (b === a) break;

                for (; null === b.sibling;) {
                  if (null === b["return"] || b["return"] === a) return;
                  b = b["return"];
                }

                b.sibling["return"] = b["return"];
                b = b.sibling;
              }
            }
          }

          function f(a) {
            for (var b = a, c = !1, d = void 0, f = void 0;;) {
              if (!c) {
                c = b["return"];

                a: for (;;) {
                  null === c ? w("160") : void 0;

                  switch (c.tag) {
                    case lg:
                      d = c.stateNode;
                      f = !1;
                      break a;

                    case kg:
                      d = c.stateNode.containerInfo;
                      f = !0;
                      break a;

                    case ng:
                      d = c.stateNode.containerInfo;
                      f = !0;
                      break a;
                  }

                  c = c["return"];
                }

                c = !0;
              }

              if (b.tag === lg || b.tag === mg) e(b), f ? C(d, b.stateNode) : H(d, b.stateNode);else if (b.tag === ng ? d = b.stateNode.containerInfo : g(b), null !== b.child) {
                b.child["return"] = b;
                b = b.child;
                continue;
              }
              if (b === a) break;

              for (; null === b.sibling;) {
                if (null === b["return"] || b["return"] === a) return;
                b = b["return"];
                b.tag === ng && (c = !1);
              }

              b.sibling["return"] = b["return"];
              b = b.sibling;
            }
          }

          function g(a) {
            "function" === typeof qg && qg(a);

            switch (a.tag) {
              case jg:
                c(a);
                var d = a.stateNode;
                if ("function" === typeof d.componentWillUnmount) try {
                  d.props = a.memoizedProps, d.state = a.memoizedState, d.componentWillUnmount();
                } catch (t) {
                  b(a, t);
                }
                break;

              case lg:
                c(a);
                break;

              case og:
                e(a.stateNode);
                break;

              case ng:
                f(a);
            }
          }

          var h = a.commitMount,
              k = a.commitUpdate,
              p = a.resetTextContent,
              x = a.commitTextUpdate,
              S = a.appendChild,
              D = a.appendChildToContainer,
              y = a.insertBefore,
              B = a.insertInContainerBefore,
              H = a.removeChild,
              C = a.removeChildFromContainer,
              Ca = a.getPublicInstance;
          return {
            commitPlacement: function commitPlacement(a) {
              a: {
                for (var b = a["return"]; null !== b;) {
                  if (d(b)) {
                    var c = b;
                    break a;
                  }

                  b = b["return"];
                }

                w("160");
                c = void 0;
              }

              var e = b = void 0;

              switch (c.tag) {
                case lg:
                  b = c.stateNode;
                  e = !1;
                  break;

                case kg:
                  b = c.stateNode.containerInfo;
                  e = !0;
                  break;

                case ng:
                  b = c.stateNode.containerInfo;
                  e = !0;
                  break;

                default:
                  w("161");
              }

              c.effectTag & ug && (p(b), c.effectTag &= ~ug);

              a: b: for (c = a;;) {
                for (; null === c.sibling;) {
                  if (null === c["return"] || d(c["return"])) {
                    c = null;
                    break a;
                  }

                  c = c["return"];
                }

                c.sibling["return"] = c["return"];

                for (c = c.sibling; c.tag !== lg && c.tag !== mg;) {
                  if (c.effectTag & rg) continue b;
                  if (null === c.child || c.tag === ng) continue b;else c.child["return"] = c, c = c.child;
                }

                if (!(c.effectTag & rg)) {
                  c = c.stateNode;
                  break a;
                }
              }

              for (var f = a;;) {
                if (f.tag === lg || f.tag === mg) c ? e ? B(b, f.stateNode, c) : y(b, f.stateNode, c) : e ? D(b, f.stateNode) : S(b, f.stateNode);else if (f.tag !== ng && null !== f.child) {
                  f.child["return"] = f;
                  f = f.child;
                  continue;
                }
                if (f === a) break;

                for (; null === f.sibling;) {
                  if (null === f["return"] || f["return"] === a) return;
                  f = f["return"];
                }

                f.sibling["return"] = f["return"];
                f = f.sibling;
              }
            },
            commitDeletion: function commitDeletion(a) {
              f(a);
              a["return"] = null;
              a.child = null;
              a.alternate && (a.alternate.child = null, a.alternate["return"] = null);
            },
            commitWork: function commitWork(a, b) {
              switch (b.tag) {
                case jg:
                  break;

                case lg:
                  var c = b.stateNode;

                  if (null != c) {
                    var d = b.memoizedProps;
                    a = null !== a ? a.memoizedProps : d;
                    var e = b.type,
                        f = b.updateQueue;
                    b.updateQueue = null;
                    null !== f && k(c, f, e, a, d, b);
                  }

                  break;

                case mg:
                  null === b.stateNode ? w("162") : void 0;
                  c = b.memoizedProps;
                  x(b.stateNode, null !== a ? a.memoizedProps : c, c);
                  break;

                case kg:
                  break;

                case ng:
                  break;

                default:
                  w("163");
              }
            },
            commitLifeCycles: function commitLifeCycles(a, b) {
              switch (b.tag) {
                case jg:
                  var c = b.stateNode;
                  if (b.effectTag & sg) if (null === a) c.props = b.memoizedProps, c.state = b.memoizedState, c.componentDidMount();else {
                    var d = a.memoizedProps;
                    a = a.memoizedState;
                    c.props = b.memoizedProps;
                    c.state = b.memoizedState;
                    c.componentDidUpdate(d, a);
                  }
                  b.effectTag & tg && null !== b.updateQueue && pg(b, b.updateQueue, c);
                  break;

                case kg:
                  a = b.updateQueue;
                  null !== a && pg(b, a, b.child && b.child.stateNode);
                  break;

                case lg:
                  c = b.stateNode;
                  null === a && b.effectTag & sg && h(c, b.type, b.memoizedProps, b);
                  break;

                case mg:
                  break;

                case ng:
                  break;

                default:
                  w("163");
              }
            },
            commitAttachRef: function commitAttachRef(a) {
              var b = a.ref;

              if (null !== b) {
                var c = a.stateNode;

                switch (a.tag) {
                  case lg:
                    b(Ca(c));
                    break;

                  default:
                    b(c);
                }
              }
            },
            commitDetachRef: function commitDetachRef(a) {
              a = a.ref;
              null !== a && a(null);
            }
          };
        }

        var wg = xd.createCursor,
            xg = xd.pop,
            yg = xd.push,
            zg = {};

        function Ag(a) {
          function b(a) {
            a === zg ? w("174") : void 0;
            return a;
          }

          var c = a.getChildHostContext,
              d = a.getRootHostContext,
              e = wg(zg),
              f = wg(zg),
              g = wg(zg);
          return {
            getHostContext: function getHostContext() {
              return b(e.current);
            },
            getRootHostContainer: function getRootHostContainer() {
              return b(g.current);
            },
            popHostContainer: function popHostContainer(a) {
              xg(e, a);
              xg(f, a);
              xg(g, a);
            },
            popHostContext: function popHostContext(a) {
              f.current === a && (xg(e, a), xg(f, a));
            },
            pushHostContainer: function pushHostContainer(a, b) {
              yg(g, b, a);
              b = d(b);
              yg(f, a, a);
              yg(e, b, a);
            },
            pushHostContext: function pushHostContext(a) {
              var d = b(g.current),
                  h = b(e.current);
              d = c(h, a.type, d);
              h !== d && (yg(f, a, a), yg(e, d, a));
            },
            resetHostContainer: function resetHostContainer() {
              e.current = zg;
              g.current = zg;
            }
          };
        }

        var Bg = E.HostComponent,
            Cg = E.HostText,
            Dg = E.HostRoot,
            Eg = J.Deletion,
            Fg = J.Placement,
            Gg = de.createFiberFromHostInstanceForDeletion;

        function Hg(a) {
          function b(a, b) {
            var c = Gg();
            c.stateNode = b;
            c["return"] = a;
            c.effectTag = Eg;
            null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
          }

          function c(a, b) {
            switch (a.tag) {
              case Bg:
                return f(b, a.type, a.pendingProps);

              case Cg:
                return g(b, a.pendingProps);

              default:
                return !1;
            }
          }

          function d(a) {
            for (a = a["return"]; null !== a && a.tag !== Bg && a.tag !== Dg;) {
              a = a["return"];
            }

            y = a;
          }

          var e = a.shouldSetTextContent,
              f = a.canHydrateInstance,
              g = a.canHydrateTextInstance,
              h = a.getNextHydratableSibling,
              k = a.getFirstHydratableChild,
              p = a.hydrateInstance,
              x = a.hydrateTextInstance,
              S = a.didNotHydrateInstance,
              D = a.didNotFindHydratableInstance;
          a = a.didNotFindHydratableTextInstance;
          if (!(f && g && h && k && p && x && S && D && a)) return {
            enterHydrationState: function enterHydrationState() {
              return !1;
            },
            resetHydrationState: function resetHydrationState() {},
            tryToClaimNextHydratableInstance: function tryToClaimNextHydratableInstance() {},
            prepareToHydrateHostInstance: function prepareToHydrateHostInstance() {
              w("175");
            },
            prepareToHydrateHostTextInstance: function prepareToHydrateHostTextInstance() {
              w("176");
            },
            popHydrationState: function popHydrationState() {
              return !1;
            }
          };
          var y = null,
              B = null,
              H = !1;
          return {
            enterHydrationState: function enterHydrationState(a) {
              B = k(a.stateNode.containerInfo);
              y = a;
              return H = !0;
            },
            resetHydrationState: function resetHydrationState() {
              B = y = null;
              H = !1;
            },
            tryToClaimNextHydratableInstance: function tryToClaimNextHydratableInstance(a) {
              if (H) {
                var d = B;

                if (d) {
                  if (!c(a, d)) {
                    d = h(d);

                    if (!d || !c(a, d)) {
                      a.effectTag |= Fg;
                      H = !1;
                      y = a;
                      return;
                    }

                    b(y, B);
                  }

                  a.stateNode = d;
                  y = a;
                  B = k(d);
                } else a.effectTag |= Fg, H = !1, y = a;
              }
            },
            prepareToHydrateHostInstance: function prepareToHydrateHostInstance(a, b, c) {
              b = p(a.stateNode, a.type, a.memoizedProps, b, c, a);
              a.updateQueue = b;
              return null !== b ? !0 : !1;
            },
            prepareToHydrateHostTextInstance: function prepareToHydrateHostTextInstance(a) {
              return x(a.stateNode, a.memoizedProps, a);
            },
            popHydrationState: function popHydrationState(a) {
              if (a !== y) return !1;
              if (!H) return d(a), H = !0, !1;
              var c = a.type;
              if (a.tag !== Bg || "head" !== c && "body" !== c && !e(c, a.memoizedProps)) for (c = B; c;) {
                b(a, c), c = h(c);
              }
              d(a);
              B = y ? h(a.stateNode) : null;
              return !0;
            }
          };
        }

        var Ig = R.popContextProvider,
            Jg = xd.reset,
            Kg = Qa.ReactCurrentOwner,
            Lg = de.createWorkInProgress,
            Mg = de.largerPriority,
            Ng = ig.onCommitRoot,
            T = Q.NoWork,
            Og = Q.SynchronousPriority,
            U = Q.TaskPriority,
            Pg = Q.HighPriority,
            Qg = Q.LowPriority,
            Rg = Q.OffscreenPriority,
            Sg = Pd.AsyncUpdates,
            Tg = J.PerformedWork,
            Ug = J.Placement,
            Vg = J.Update,
            Wg = J.PlacementAndUpdate,
            Xg = J.Deletion,
            Yg = J.ContentReset,
            Zg = J.Callback,
            $g = J.Err,
            ah = J.Ref,
            bh = E.HostRoot,
            ch = E.HostComponent,
            dh = E.HostPortal,
            eh = E.ClassComponent,
            fh = ud.getUpdatePriority,
            gh = R.resetContext;

        function hh(a) {
          function b() {
            for (; null !== ma && ma.current.pendingWorkPriority === T;) {
              ma.isScheduled = !1;
              var a = ma.nextScheduledRoot;
              ma.nextScheduledRoot = null;
              if (ma === zb) return zb = ma = null, z = T, null;
              ma = a;
            }

            a = ma;

            for (var b = null, c = T; null !== a;) {
              a.current.pendingWorkPriority !== T && (c === T || c > a.current.pendingWorkPriority) && (c = a.current.pendingWorkPriority, b = a), a = a.nextScheduledRoot;
            }

            null !== b ? (z = c, Jg(), gh(), t(), I = Lg(b.current, c), b !== nc && (oc = 0, nc = b)) : (z = T, nc = I = null);
          }

          function c(c) {
            Hd = !0;
            na = null;
            var d = c.stateNode;
            d.current === c ? w("177") : void 0;
            z !== Og && z !== U || oc++;
            Kg.current = null;
            if (c.effectTag > Tg) {
              if (null !== c.lastEffect) {
                c.lastEffect.nextEffect = c;
                var e = c.firstEffect;
              } else e = c;
            } else e = c.firstEffect;
            Ui();

            for (u = e; null !== u;) {
              var f = !1,
                  g = void 0;

              try {
                for (; null !== u;) {
                  var h = u.effectTag;
                  h & Yg && a.resetTextContent(u.stateNode);

                  if (h & ah) {
                    var k = u.alternate;
                    null !== k && Ph(k);
                  }

                  switch (h & ~(Zg | $g | Yg | ah | Tg)) {
                    case Ug:
                      q(u);
                      u.effectTag &= ~Ug;
                      break;

                    case Wg:
                      q(u);
                      u.effectTag &= ~Ug;
                      vf(u.alternate, u);
                      break;

                    case Vg:
                      vf(u.alternate, u);
                      break;

                    case Xg:
                      Id = !0, Mh(u), Id = !1;
                  }

                  u = u.nextEffect;
                }
              } catch (Jd) {
                f = !0, g = Jd;
              }

              f && (null === u ? w("178") : void 0, x(u, g), null !== u && (u = u.nextEffect));
            }

            Vi();
            d.current = c;

            for (u = e; null !== u;) {
              d = !1;
              e = void 0;

              try {
                for (; null !== u;) {
                  var Gd = u.effectTag;
                  Gd & (Vg | Zg) && Nh(u.alternate, u);
                  Gd & ah && Oh(u);
                  if (Gd & $g) switch (f = u, g = void 0, null !== P && (g = P.get(f), P["delete"](f), null == g && null !== f.alternate && (f = f.alternate, g = P.get(f), P["delete"](f))), null == g ? w("184") : void 0, f.tag) {
                    case eh:
                      f.stateNode.componentDidCatch(g.error, {
                        componentStack: g.componentStack
                      });
                      break;

                    case bh:
                      null === Ja && (Ja = g.error);
                      break;

                    default:
                      w("157");
                  }
                  var m = u.nextEffect;
                  u.nextEffect = null;
                  u = m;
                }
              } catch (Jd) {
                d = !0, e = Jd;
              }

              d && (null === u ? w("178") : void 0, x(u, e), null !== u && (u = u.nextEffect));
            }

            Hd = !1;
            "function" === typeof Ng && Ng(c.stateNode);
            va && (va.forEach(H), va = null);
            b();
          }

          function d(a) {
            for (;;) {
              var b = Lh(a.alternate, a, z),
                  c = a["return"],
                  d = a.sibling;
              var e = a;

              if (!(e.pendingWorkPriority !== T && e.pendingWorkPriority > z)) {
                for (var f = fh(e), g = e.child; null !== g;) {
                  f = Mg(f, g.pendingWorkPriority), g = g.sibling;
                }

                e.pendingWorkPriority = f;
              }

              if (null !== b) return b;
              null !== c && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), a.effectTag > Tg && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));
              if (null !== d) return d;
              if (null !== c) a = c;else {
                na = a;
                break;
              }
            }

            return null;
          }

          function e(a) {
            var b = V(a.alternate, a, z);
            null === b && (b = d(a));
            Kg.current = null;
            return b;
          }

          function f(a) {
            var b = ld(a.alternate, a, z);
            null === b && (b = d(a));
            Kg.current = null;
            return b;
          }

          function g(a) {
            p(Rg, a);
          }

          function h() {
            if (null !== P && 0 < P.size && z === U) for (; null !== I;) {
              var a = I;
              I = null !== P && (P.has(a) || null !== a.alternate && P.has(a.alternate)) ? f(I) : e(I);
              if (null === I && (null === na ? w("179") : void 0, O = U, c(na), O = z, null === P || 0 === P.size || z !== U)) break;
            }
          }

          function k(a, d) {
            null !== na ? (O = U, c(na), h()) : null === I && b();

            if (!(z === T || z > a)) {
              O = z;

              a: do {
                if (z <= U) for (; null !== I && !(I = e(I), null === I && (null === na ? w("179") : void 0, O = U, c(na), O = z, h(), z === T || z > a || z > U));) {
                  ;
                } else if (null !== d) for (; null !== I && !Ab;) {
                  if (1 < d.timeRemaining()) {
                    if (I = e(I), null === I) if (null === na ? w("179") : void 0, 1 < d.timeRemaining()) {
                      if (O = U, c(na), O = z, h(), z === T || z > a || z < Pg) break;
                    } else Ab = !0;
                  } else Ab = !0;
                }

                switch (z) {
                  case Og:
                  case U:
                    if (z <= a) continue a;
                    break a;

                  case Pg:
                  case Qg:
                  case Rg:
                    if (null === d) break a;
                    if (!Ab && z <= a) continue a;
                    break a;

                  case T:
                    break a;

                  default:
                    w("181");
                }
              } while (1);
            }
          }

          function p(a, b) {
            Da ? w("182") : void 0;
            Da = !0;
            var c = O,
                d = !1,
                e = null;

            try {
              k(a, b);
            } catch (Kd) {
              d = !0, e = Kd;
            }

            for (; d;) {
              if (Ya) {
                Ja = e;
                break;
              }

              var h = I;
              if (null === h) Ya = !0;else {
                var p = x(h, e);
                null === p ? w("183") : void 0;

                if (!Ya) {
                  try {
                    d = p;
                    e = a;
                    p = b;

                    for (var q = d; null !== h;) {
                      switch (h.tag) {
                        case eh:
                          Ig(h);
                          break;

                        case ch:
                          m(h);
                          break;

                        case bh:
                          r(h);
                          break;

                        case dh:
                          r(h);
                      }

                      if (h === q || h.alternate === q) break;
                      h = h["return"];
                    }

                    I = f(d);
                    k(e, p);
                  } catch (Kd) {
                    d = !0;
                    e = Kd;
                    continue;
                  }

                  break;
                }
              }
            }

            O = c;
            null !== b && (Bb = !1);
            z > U && !Bb && ($f(g), Bb = !0);
            a = Ja;
            Ya = Ab = Da = !1;
            nc = Ka = P = Ja = null;
            oc = 0;
            if (null !== a) throw a;
          }

          function x(a, b) {
            var c = Kg.current = null,
                d = !1,
                e = !1,
                f = null;
            if (a.tag === bh) c = a, S(a) && (Ya = !0);else for (var g = a["return"]; null !== g && null === c;) {
              g.tag === eh ? "function" === typeof g.stateNode.componentDidCatch && (d = !0, f = Ra(g), c = g, e = !0) : g.tag === bh && (c = g);

              if (S(g)) {
                if (Id || null !== va && (va.has(g) || null !== g.alternate && va.has(g.alternate))) return null;
                c = null;
                e = !1;
              }

              g = g["return"];
            }

            if (null !== c) {
              null === Ka && (Ka = new Set());
              Ka.add(c);
              var h = "";
              g = a;

              do {
                a: switch (g.tag) {
                  case fe:
                  case ge:
                  case he:
                  case ie:
                    var k = g._debugOwner,
                        m = g._debugSource;
                    var p = Ra(g);
                    var q = null;
                    k && (q = Ra(k));
                    k = m;
                    p = "\n    in " + (p || "Unknown") + (k ? " (at " + k.fileName.replace(/^.*[\\\/]/, "") + ":" + k.lineNumber + ")" : q ? " (created by " + q + ")" : "");
                    break a;

                  default:
                    p = "";
                }

                h += p;
                g = g["return"];
              } while (g);

              g = h;
              a = Ra(a);
              null === P && (P = new Map());
              b = {
                componentName: a,
                componentStack: g,
                error: b,
                errorBoundary: d ? c.stateNode : null,
                errorBoundaryFound: d,
                errorBoundaryName: f,
                willRetry: e
              };
              P.set(c, b);

              try {
                console.error(b.error);
              } catch (Wi) {
                console.error(Wi);
              }

              Hd ? (null === va && (va = new Set()), va.add(c)) : H(c);
              return c;
            }

            null === Ja && (Ja = b);
            return null;
          }

          function S(a) {
            return null !== Ka && (Ka.has(a) || null !== a.alternate && Ka.has(a.alternate));
          }

          function D(a, b) {
            return y(a, b, !1);
          }

          function y(a, b) {
            oc > Xi && (Ya = !0, w("185"));
            !Da && b <= z && (I = null);

            for (var c = !0; null !== a && c;) {
              c = !1;
              if (a.pendingWorkPriority === T || a.pendingWorkPriority > b) c = !0, a.pendingWorkPriority = b;
              null !== a.alternate && (a.alternate.pendingWorkPriority === T || a.alternate.pendingWorkPriority > b) && (c = !0, a.alternate.pendingWorkPriority = b);
              if (null === a["return"]) if (a.tag === bh) {
                var d = a.stateNode;
                b === T || d.isScheduled || (d.isScheduled = !0, zb ? zb.nextScheduledRoot = d : ma = d, zb = d);
                if (!Da) switch (b) {
                  case Og:
                    pc ? p(Og, null) : p(U, null);
                    break;

                  case U:
                    W ? void 0 : w("186");
                    break;

                  default:
                    Bb || ($f(g), Bb = !0);
                }
              } else break;
              a = a["return"];
            }
          }

          function B(a, b) {
            var c = O;
            c === T && (c = !Yi || a.internalContextTag & Sg || b ? Qg : Og);
            return c === Og && (Da || W) ? U : c;
          }

          function H(a) {
            y(a, U, !0);
          }

          var C = Ag(a),
              Ca = Hg(a),
              r = C.popHostContainer,
              m = C.popHostContext,
              t = C.resetHostContainer,
              v = Lf(a, C, Ca, D, B),
              V = v.beginWork,
              ld = v.beginFailedWork,
              Lh = eg(a, C, Ca).completeWork;
          C = vg(a, x);
          var q = C.commitPlacement,
              Mh = C.commitDeletion,
              vf = C.commitWork,
              Nh = C.commitLifeCycles,
              Oh = C.commitAttachRef,
              Ph = C.commitDetachRef,
              $f = a.scheduleDeferredCallback,
              Yi = a.useSyncScheduling,
              Ui = a.prepareForCommit,
              Vi = a.resetAfterCommit,
              O = T,
              Da = !1,
              Ab = !1,
              W = !1,
              pc = !1,
              I = null,
              z = T,
              u = null,
              na = null,
              ma = null,
              zb = null,
              Bb = !1,
              P = null,
              Ka = null,
              va = null,
              Ja = null,
              Ya = !1,
              Hd = !1,
              Id = !1,
              Xi = 1E3,
              oc = 0,
              nc = null;
          return {
            scheduleUpdate: D,
            getPriorityContext: B,
            batchedUpdates: function batchedUpdates(a, b) {
              var c = W;
              W = !0;

              try {
                return a(b);
              } finally {
                W = c, Da || W || p(U, null);
              }
            },
            unbatchedUpdates: function unbatchedUpdates(a) {
              var b = pc,
                  c = W;
              pc = W;
              W = !1;

              try {
                return a();
              } finally {
                W = c, pc = b;
              }
            },
            flushSync: function flushSync(a) {
              var b = W,
                  c = O;
              W = !0;
              O = Og;

              try {
                return a();
              } finally {
                W = b, O = c, Da ? w("187") : void 0, p(U, null);
              }
            },
            deferredUpdates: function deferredUpdates(a) {
              var b = O;
              O = Qg;

              try {
                return a();
              } finally {
                O = b;
              }
            }
          };
        }

        function ih() {
          w("196");
        }

        function jh(a) {
          if (!a) return da;
          a = Pa.get(a);
          return "number" === typeof a.tag ? ih(a) : a._processChildContext(a._context);
        }

        jh._injectFiber = function (a) {
          ih = a;
        };

        var kh = ud.addTopLevelUpdate,
            lh = R.findCurrentUnmaskedContext,
            mh = R.isContextProvider,
            nh = R.processChildContext,
            oh = E.HostComponent,
            ph = bb.findCurrentHostFiber,
            qh = bb.findCurrentHostFiberWithNoPortals;

        jh._injectFiber(function (a) {
          var b = lh(a);
          return mh(a) ? nh(a, b, !1) : b;
        });

        var rh = F.TEXT_NODE;

        function sh(a) {
          for (; a && a.firstChild;) {
            a = a.firstChild;
          }

          return a;
        }

        function th(a, b) {
          var c = sh(a);
          a = 0;

          for (var d; c;) {
            if (c.nodeType === rh) {
              d = a + c.textContent.length;
              if (a <= b && d >= b) return {
                node: c,
                offset: b - a
              };
              a = d;
            }

            a: {
              for (; c;) {
                if (c.nextSibling) {
                  c = c.nextSibling;
                  break a;
                }

                c = c.parentNode;
              }

              c = void 0;
            }

            c = sh(c);
          }
        }

        var uh = null;

        function vh() {
          !uh && l.canUseDOM && (uh = "textContent" in document.documentElement ? "textContent" : "innerText");
          return uh;
        }

        var wh = {
          getOffsets: function getOffsets(a) {
            var b = window.getSelection && window.getSelection();
            if (!b || 0 === b.rangeCount) return null;
            var c = b.anchorNode,
                d = b.anchorOffset,
                e = b.focusNode,
                f = b.focusOffset,
                g = b.getRangeAt(0);

            try {
              g.startContainer.nodeType, g.endContainer.nodeType;
            } catch (k) {
              return null;
            }

            b = b.anchorNode === b.focusNode && b.anchorOffset === b.focusOffset ? 0 : g.toString().length;
            var h = g.cloneRange();
            h.selectNodeContents(a);
            h.setEnd(g.startContainer, g.startOffset);
            a = h.startContainer === h.endContainer && h.startOffset === h.endOffset ? 0 : h.toString().length;
            g = a + b;
            b = document.createRange();
            b.setStart(c, d);
            b.setEnd(e, f);
            c = b.collapsed;
            return {
              start: c ? g : a,
              end: c ? a : g
            };
          },
          setOffsets: function setOffsets(a, b) {
            if (window.getSelection) {
              var c = window.getSelection(),
                  d = a[vh()].length,
                  e = Math.min(b.start, d);
              b = void 0 === b.end ? e : Math.min(b.end, d);
              !c.extend && e > b && (d = b, b = e, e = d);
              d = th(a, e);
              a = th(a, b);

              if (d && a) {
                var f = document.createRange();
                f.setStart(d.node, d.offset);
                c.removeAllRanges();
                e > b ? (c.addRange(f), c.extend(a.node, a.offset)) : (f.setEnd(a.node, a.offset), c.addRange(f));
              }
            }
          }
        },
            xh = F.ELEMENT_NODE,
            yh = {
          hasSelectionCapabilities: function hasSelectionCapabilities(a) {
            var b = a && a.nodeName && a.nodeName.toLowerCase();
            return b && ("input" === b && "text" === a.type || "textarea" === b || "true" === a.contentEditable);
          },
          getSelectionInformation: function getSelectionInformation() {
            var a = ia();
            return {
              focusedElem: a,
              selectionRange: yh.hasSelectionCapabilities(a) ? yh.getSelection(a) : null
            };
          },
          restoreSelection: function restoreSelection(a) {
            var b = ia(),
                c = a.focusedElem;
            a = a.selectionRange;

            if (b !== c && fa(document.documentElement, c)) {
              yh.hasSelectionCapabilities(c) && yh.setSelection(c, a);
              b = [];

              for (a = c; a = a.parentNode;) {
                a.nodeType === xh && b.push({
                  element: a,
                  left: a.scrollLeft,
                  top: a.scrollTop
                });
              }

              ha(c);

              for (c = 0; c < b.length; c++) {
                a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
              }
            }
          },
          getSelection: function getSelection(a) {
            return ("selectionStart" in a ? {
              start: a.selectionStart,
              end: a.selectionEnd
            } : wh.getOffsets(a)) || {
              start: 0,
              end: 0
            };
          },
          setSelection: function setSelection(a, b) {
            var c = b.start,
                d = b.end;
            void 0 === d && (d = c);
            "selectionStart" in a ? (a.selectionStart = c, a.selectionEnd = Math.min(d, a.value.length)) : wh.setOffsets(a, b);
          }
        },
            zh = yh,
            Ah = F.ELEMENT_NODE;

        function Bh() {
          w("211");
        }

        function Ch() {
          w("212");
        }

        function Dh(a) {
          if (null == a) return null;
          if (a.nodeType === Ah) return a;
          var b = Pa.get(a);
          if (b) return "number" === typeof b.tag ? Bh(b) : Ch(b);
          "function" === typeof a.render ? w("188") : w("213", Object.keys(a));
        }

        Dh._injectFiber = function (a) {
          Bh = a;
        };

        Dh._injectStack = function (a) {
          Ch = a;
        };

        var Eh = E.HostComponent;

        function Fh(a) {
          if (void 0 !== a._hostParent) return a._hostParent;

          if ("number" === typeof a.tag) {
            do {
              a = a["return"];
            } while (a && a.tag !== Eh);

            if (a) return a;
          }

          return null;
        }

        function Gh(a, b) {
          for (var c = 0, d = a; d; d = Fh(d)) {
            c++;
          }

          d = 0;

          for (var e = b; e; e = Fh(e)) {
            d++;
          }

          for (; 0 < c - d;) {
            a = Fh(a), c--;
          }

          for (; 0 < d - c;) {
            b = Fh(b), d--;
          }

          for (; c--;) {
            if (a === b || a === b.alternate) return a;
            a = Fh(a);
            b = Fh(b);
          }

          return null;
        }

        var Hh = {
          isAncestor: function isAncestor(a, b) {
            for (; b;) {
              if (a === b || a === b.alternate) return !0;
              b = Fh(b);
            }

            return !1;
          },
          getLowestCommonAncestor: Gh,
          getParentInstance: function getParentInstance(a) {
            return Fh(a);
          },
          traverseTwoPhase: function traverseTwoPhase(a, b, c) {
            for (var d = []; a;) {
              d.push(a), a = Fh(a);
            }

            for (a = d.length; 0 < a--;) {
              b(d[a], "captured", c);
            }

            for (a = 0; a < d.length; a++) {
              b(d[a], "bubbled", c);
            }
          },
          traverseEnterLeave: function traverseEnterLeave(a, b, c, d, e) {
            for (var f = a && b ? Gh(a, b) : null, g = []; a && a !== f;) {
              g.push(a), a = Fh(a);
            }

            for (a = []; b && b !== f;) {
              a.push(b), b = Fh(b);
            }

            for (b = 0; b < g.length; b++) {
              c(g[b], "bubbled", d);
            }

            for (b = a.length; 0 < b--;) {
              c(a[b], "captured", e);
            }
          }
        },
            Ih = Jb.getListener;

        function Jh(a, b, c) {
          if (b = Ih(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = Cb(c._dispatchListeners, b), c._dispatchInstances = Cb(c._dispatchInstances, a);
        }

        function Kh(a) {
          a && a.dispatchConfig.phasedRegistrationNames && Hh.traverseTwoPhase(a._targetInst, Jh, a);
        }

        function Qh(a) {
          if (a && a.dispatchConfig.phasedRegistrationNames) {
            var b = a._targetInst;
            b = b ? Hh.getParentInstance(b) : null;
            Hh.traverseTwoPhase(b, Jh, a);
          }
        }

        function Rh(a, b, c) {
          a && c && c.dispatchConfig.registrationName && (b = Ih(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = Cb(c._dispatchListeners, b), c._dispatchInstances = Cb(c._dispatchInstances, a));
        }

        function Sh(a) {
          a && a.dispatchConfig.registrationName && Rh(a._targetInst, null, a);
        }

        var Th = {
          accumulateTwoPhaseDispatches: function accumulateTwoPhaseDispatches(a) {
            Db(a, Kh);
          },
          accumulateTwoPhaseDispatchesSkipTarget: function accumulateTwoPhaseDispatchesSkipTarget(a) {
            Db(a, Qh);
          },
          accumulateDirectDispatches: function accumulateDirectDispatches(a) {
            Db(a, Sh);
          },
          accumulateEnterLeaveDispatches: function accumulateEnterLeaveDispatches(a, b, c, d) {
            Hh.traverseEnterLeave(c, d, Rh, a, b);
          }
        },
            X = {
          _root: null,
          _startText: null,
          _fallbackText: null
        },
            Uh = {
          initialize: function initialize(a) {
            X._root = a;
            X._startText = Uh.getText();
            return !0;
          },
          reset: function reset() {
            X._root = null;
            X._startText = null;
            X._fallbackText = null;
          },
          getData: function getData() {
            if (X._fallbackText) return X._fallbackText;
            var a,
                b = X._startText,
                c = b.length,
                d,
                e = Uh.getText(),
                f = e.length;

            for (a = 0; a < c && b[a] === e[a]; a++) {
              ;
            }

            var g = c - a;

            for (d = 1; d <= g && b[c - d] === e[f - d]; d++) {
              ;
            }

            X._fallbackText = e.slice(a, 1 < d ? 1 - d : void 0);
            return X._fallbackText;
          },
          getText: function getText() {
            return "value" in X._root ? X._root.value : X._root[vh()];
          }
        },
            Vh = Uh,
            Wh = "dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),
            Xh = {
          type: null,
          target: null,
          currentTarget: ca.thatReturnsNull,
          eventPhase: null,
          bubbles: null,
          cancelable: null,
          timeStamp: function timeStamp(a) {
            return a.timeStamp || Date.now();
          },
          defaultPrevented: null,
          isTrusted: null
        };

        function Y(a, b, c, d) {
          this.dispatchConfig = a;
          this._targetInst = b;
          this.nativeEvent = c;
          a = this.constructor.Interface;

          for (var e in a) {
            a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
          }

          this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? ca.thatReturnsTrue : ca.thatReturnsFalse;
          this.isPropagationStopped = ca.thatReturnsFalse;
          return this;
        }

        n(Y.prototype, {
          preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = ca.thatReturnsTrue);
          },
          stopPropagation: function stopPropagation() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = ca.thatReturnsTrue);
          },
          persist: function persist() {
            this.isPersistent = ca.thatReturnsTrue;
          },
          isPersistent: ca.thatReturnsFalse,
          destructor: function destructor() {
            var a = this.constructor.Interface,
                b;

            for (b in a) {
              this[b] = null;
            }

            for (a = 0; a < Wh.length; a++) {
              this[Wh[a]] = null;
            }
          }
        });
        Y.Interface = Xh;

        Y.augmentClass = function (a, b) {
          function c() {}

          c.prototype = this.prototype;
          var d = new c();
          n(d, a.prototype);
          a.prototype = d;
          a.prototype.constructor = a;
          a.Interface = n({}, this.Interface, b);
          a.augmentClass = this.augmentClass;
          Yh(a);
        };

        Yh(Y);

        function Zh(a, b, c, d) {
          if (this.eventPool.length) {
            var e = this.eventPool.pop();
            this.call(e, a, b, c, d);
            return e;
          }

          return new this(a, b, c, d);
        }

        function $h(a) {
          a instanceof this ? void 0 : w("223");
          a.destructor();
          10 > this.eventPool.length && this.eventPool.push(a);
        }

        function Yh(a) {
          a.eventPool = [];
          a.getPooled = Zh;
          a.release = $h;
        }

        function ai(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Y.augmentClass(ai, {
          data: null
        });

        function bi(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Y.augmentClass(bi, {
          data: null
        });
        var ci = [9, 13, 27, 32],
            di = l.canUseDOM && "CompositionEvent" in window,
            ei = null;
        l.canUseDOM && "documentMode" in document && (ei = document.documentMode);
        var fi;

        if (fi = l.canUseDOM && "TextEvent" in window && !ei) {
          var gi = window.opera;
          fi = !("object" === typeof gi && "function" === typeof gi.version && 12 >= parseInt(gi.version(), 10));
        }

        var hi = fi,
            ii = l.canUseDOM && (!di || ei && 8 < ei && 11 >= ei),
            ji = String.fromCharCode(32),
            ki = {
          beforeInput: {
            phasedRegistrationNames: {
              bubbled: "onBeforeInput",
              captured: "onBeforeInputCapture"
            },
            dependencies: ["topCompositionEnd", "topKeyPress", "topTextInput", "topPaste"]
          },
          compositionEnd: {
            phasedRegistrationNames: {
              bubbled: "onCompositionEnd",
              captured: "onCompositionEndCapture"
            },
            dependencies: "topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")
          },
          compositionStart: {
            phasedRegistrationNames: {
              bubbled: "onCompositionStart",
              captured: "onCompositionStartCapture"
            },
            dependencies: "topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")
          },
          compositionUpdate: {
            phasedRegistrationNames: {
              bubbled: "onCompositionUpdate",
              captured: "onCompositionUpdateCapture"
            },
            dependencies: "topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")
          }
        },
            li = !1;

        function mi(a, b) {
          switch (a) {
            case "topKeyUp":
              return -1 !== ci.indexOf(b.keyCode);

            case "topKeyDown":
              return 229 !== b.keyCode;

            case "topKeyPress":
            case "topMouseDown":
            case "topBlur":
              return !0;

            default:
              return !1;
          }
        }

        function ni(a) {
          a = a.detail;
          return "object" === typeof a && "data" in a ? a.data : null;
        }

        var oi = !1;

        function pi(a, b) {
          switch (a) {
            case "topCompositionEnd":
              return ni(b);

            case "topKeyPress":
              if (32 !== b.which) return null;
              li = !0;
              return ji;

            case "topTextInput":
              return a = b.data, a === ji && li ? null : a;

            default:
              return null;
          }
        }

        function qi(a, b) {
          if (oi) return "topCompositionEnd" === a || !di && mi(a, b) ? (a = Vh.getData(), Vh.reset(), oi = !1, a) : null;

          switch (a) {
            case "topPaste":
              return null;

            case "topKeyPress":
              if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
              }

              return null;

            case "topCompositionEnd":
              return ii ? null : b.data;

            default:
              return null;
          }
        }

        var ri = {
          eventTypes: ki,
          extractEvents: function extractEvents(a, b, c, d) {
            var e;
            if (di) b: {
              switch (a) {
                case "topCompositionStart":
                  var f = ki.compositionStart;
                  break b;

                case "topCompositionEnd":
                  f = ki.compositionEnd;
                  break b;

                case "topCompositionUpdate":
                  f = ki.compositionUpdate;
                  break b;
              }

              f = void 0;
            } else oi ? mi(a, c) && (f = ki.compositionEnd) : "topKeyDown" === a && 229 === c.keyCode && (f = ki.compositionStart);
            f ? (ii && (oi || f !== ki.compositionStart ? f === ki.compositionEnd && oi && (e = Vh.getData()) : oi = Vh.initialize(d)), f = ai.getPooled(f, b, c, d), e ? f.data = e : (e = ni(c), null !== e && (f.data = e)), Th.accumulateTwoPhaseDispatches(f), e = f) : e = null;
            (a = hi ? pi(a, c) : qi(a, c)) ? (b = bi.getPooled(ki.beforeInput, b, c, d), b.data = a, Th.accumulateTwoPhaseDispatches(b)) : b = null;
            return [e, b];
          }
        },
            si = {
          color: !0,
          date: !0,
          datetime: !0,
          "datetime-local": !0,
          email: !0,
          month: !0,
          number: !0,
          password: !0,
          range: !0,
          search: !0,
          tel: !0,
          text: !0,
          time: !0,
          url: !0,
          week: !0
        };

        function ti(a) {
          var b = a && a.nodeName && a.nodeName.toLowerCase();
          return "input" === b ? !!si[a.type] : "textarea" === b ? !0 : !1;
        }

        var ui = {
          change: {
            phasedRegistrationNames: {
              bubbled: "onChange",
              captured: "onChangeCapture"
            },
            dependencies: "topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")
          }
        };

        function vi(a, b, c) {
          a = Y.getPooled(ui.change, a, b, c);
          a.type = "change";
          nb.enqueueStateRestore(c);
          Th.accumulateTwoPhaseDispatches(a);
          return a;
        }

        var wi = null,
            xi = null;

        function yi(a) {
          Jb.enqueueEvents(a);
          Jb.processEventQueue(!1);
        }

        function zi(a) {
          var b = G.getNodeFromInstance(a);
          if (Bc.updateValueIfChanged(b)) return a;
        }

        function Ai(a, b) {
          if ("topChange" === a) return b;
        }

        var Bi = !1;
        l.canUseDOM && (Bi = Lb("input") && (!document.documentMode || 9 < document.documentMode));

        function Ci() {
          wi && (wi.detachEvent("onpropertychange", Di), xi = wi = null);
        }

        function Di(a) {
          "value" === a.propertyName && zi(xi) && (a = vi(xi, a, ub(a)), sb.batchedUpdates(yi, a));
        }

        function Ei(a, b, c) {
          "topFocus" === a ? (Ci(), wi = b, xi = c, wi.attachEvent("onpropertychange", Di)) : "topBlur" === a && Ci();
        }

        function Fi(a) {
          if ("topSelectionChange" === a || "topKeyUp" === a || "topKeyDown" === a) return zi(xi);
        }

        function Gi(a, b) {
          if ("topClick" === a) return zi(b);
        }

        function Hi(a, b) {
          if ("topInput" === a || "topChange" === a) return zi(b);
        }

        var Ii = {
          eventTypes: ui,
          _isInputEventSupported: Bi,
          extractEvents: function extractEvents(a, b, c, d) {
            var e = b ? G.getNodeFromInstance(b) : window,
                f = e.nodeName && e.nodeName.toLowerCase();
            if ("select" === f || "input" === f && "file" === e.type) var g = Ai;else if (ti(e)) {
              if (Bi) g = Hi;else {
                g = Fi;
                var h = Ei;
              }
            } else f = e.nodeName, !f || "input" !== f.toLowerCase() || "checkbox" !== e.type && "radio" !== e.type || (g = Gi);
            if (g && (g = g(a, b))) return vi(g, c, d);
            h && h(a, e, b);
            "topBlur" === a && null != b && (a = b._wrapperState || e._wrapperState) && a.controlled && "number" === e.type && (a = "" + e.value, e.getAttribute("value") !== a && e.setAttribute("value", a));
          }
        };

        function Ji(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Y.augmentClass(Ji, {
          view: function view(a) {
            if (a.view) return a.view;
            a = ub(a);
            return a.window === a ? a : (a = a.ownerDocument) ? a.defaultView || a.parentWindow : window;
          },
          detail: function detail(a) {
            return a.detail || 0;
          }
        });
        var Ki = {
          Alt: "altKey",
          Control: "ctrlKey",
          Meta: "metaKey",
          Shift: "shiftKey"
        };

        function Li(a) {
          var b = this.nativeEvent;
          return b.getModifierState ? b.getModifierState(a) : (a = Ki[a]) ? !!b[a] : !1;
        }

        function Mi() {
          return Li;
        }

        function Ni(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Ji.augmentClass(Ni, {
          screenX: null,
          screenY: null,
          clientX: null,
          clientY: null,
          pageX: null,
          pageY: null,
          ctrlKey: null,
          shiftKey: null,
          altKey: null,
          metaKey: null,
          getModifierState: Mi,
          button: null,
          buttons: null,
          relatedTarget: function relatedTarget(a) {
            return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
          }
        });
        var Oi = {
          mouseEnter: {
            registrationName: "onMouseEnter",
            dependencies: ["topMouseOut", "topMouseOver"]
          },
          mouseLeave: {
            registrationName: "onMouseLeave",
            dependencies: ["topMouseOut", "topMouseOver"]
          }
        },
            Pi = {
          eventTypes: Oi,
          extractEvents: function extractEvents(a, b, c, d) {
            if ("topMouseOver" === a && (c.relatedTarget || c.fromElement) || "topMouseOut" !== a && "topMouseOver" !== a) return null;
            var e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;
            "topMouseOut" === a ? (a = b, b = (b = c.relatedTarget || c.toElement) ? G.getClosestInstanceFromNode(b) : null) : a = null;
            if (a === b) return null;
            var f = null == a ? e : G.getNodeFromInstance(a);
            e = null == b ? e : G.getNodeFromInstance(b);
            var g = Ni.getPooled(Oi.mouseLeave, a, c, d);
            g.type = "mouseleave";
            g.target = f;
            g.relatedTarget = e;
            c = Ni.getPooled(Oi.mouseEnter, b, c, d);
            c.type = "mouseenter";
            c.target = e;
            c.relatedTarget = f;
            Th.accumulateEnterLeaveDispatches(g, c, a, b);
            return [g, c];
          }
        },
            Qi = F.DOCUMENT_NODE,
            Ri = l.canUseDOM && "documentMode" in document && 11 >= document.documentMode,
            Si = {
          select: {
            phasedRegistrationNames: {
              bubbled: "onSelect",
              captured: "onSelectCapture"
            },
            dependencies: "topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")
          }
        },
            Ti = null,
            Zi = null,
            $i = null,
            aj = !1,
            bj = M.isListeningToAllDependencies;

        function cj(a, b) {
          if (aj || null == Ti || Ti !== ia()) return null;
          var c = Ti;
          "selectionStart" in c && zh.hasSelectionCapabilities(c) ? c = {
            start: c.selectionStart,
            end: c.selectionEnd
          } : window.getSelection ? (c = window.getSelection(), c = {
            anchorNode: c.anchorNode,
            anchorOffset: c.anchorOffset,
            focusNode: c.focusNode,
            focusOffset: c.focusOffset
          }) : c = void 0;
          return $i && ea($i, c) ? null : ($i = c, a = Y.getPooled(Si.select, Zi, a, b), a.type = "select", a.target = Ti, Th.accumulateTwoPhaseDispatches(a), a);
        }

        var dj = {
          eventTypes: Si,
          extractEvents: function extractEvents(a, b, c, d) {
            var e = d.window === d ? d.document : d.nodeType === Qi ? d : d.ownerDocument;
            if (!e || !bj("onSelect", e)) return null;
            e = b ? G.getNodeFromInstance(b) : window;

            switch (a) {
              case "topFocus":
                if (ti(e) || "true" === e.contentEditable) Ti = e, Zi = b, $i = null;
                break;

              case "topBlur":
                $i = Zi = Ti = null;
                break;

              case "topMouseDown":
                aj = !0;
                break;

              case "topContextMenu":
              case "topMouseUp":
                return aj = !1, cj(c, d);

              case "topSelectionChange":
                if (Ri) break;

              case "topKeyDown":
              case "topKeyUp":
                return cj(c, d);
            }

            return null;
          }
        };

        function ej(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Y.augmentClass(ej, {
          animationName: null,
          elapsedTime: null,
          pseudoElement: null
        });

        function fj(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Y.augmentClass(fj, {
          clipboardData: function clipboardData(a) {
            return "clipboardData" in a ? a.clipboardData : window.clipboardData;
          }
        });

        function gj(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Ji.augmentClass(gj, {
          relatedTarget: null
        });

        function hj(a) {
          var b = a.keyCode;
          "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
          return 32 <= a || 13 === a ? a : 0;
        }

        var ij = {
          Esc: "Escape",
          Spacebar: " ",
          Left: "ArrowLeft",
          Up: "ArrowUp",
          Right: "ArrowRight",
          Down: "ArrowDown",
          Del: "Delete",
          Win: "OS",
          Menu: "ContextMenu",
          Apps: "ContextMenu",
          Scroll: "ScrollLock",
          MozPrintableKey: "Unidentified"
        },
            jj = {
          8: "Backspace",
          9: "Tab",
          12: "Clear",
          13: "Enter",
          16: "Shift",
          17: "Control",
          18: "Alt",
          19: "Pause",
          20: "CapsLock",
          27: "Escape",
          32: " ",
          33: "PageUp",
          34: "PageDown",
          35: "End",
          36: "Home",
          37: "ArrowLeft",
          38: "ArrowUp",
          39: "ArrowRight",
          40: "ArrowDown",
          45: "Insert",
          46: "Delete",
          112: "F1",
          113: "F2",
          114: "F3",
          115: "F4",
          116: "F5",
          117: "F6",
          118: "F7",
          119: "F8",
          120: "F9",
          121: "F10",
          122: "F11",
          123: "F12",
          144: "NumLock",
          145: "ScrollLock",
          224: "Meta"
        };

        function kj(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Ji.augmentClass(kj, {
          key: function key(a) {
            if (a.key) {
              var b = ij[a.key] || a.key;
              if ("Unidentified" !== b) return b;
            }

            return "keypress" === a.type ? (a = hj(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? jj[a.keyCode] || "Unidentified" : "";
          },
          location: null,
          ctrlKey: null,
          shiftKey: null,
          altKey: null,
          metaKey: null,
          repeat: null,
          locale: null,
          getModifierState: Mi,
          charCode: function charCode(a) {
            return "keypress" === a.type ? hj(a) : 0;
          },
          keyCode: function keyCode(a) {
            return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
          },
          which: function which(a) {
            return "keypress" === a.type ? hj(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
          }
        });

        function lj(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Ni.augmentClass(lj, {
          dataTransfer: null
        });

        function mj(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Ji.augmentClass(mj, {
          touches: null,
          targetTouches: null,
          changedTouches: null,
          altKey: null,
          metaKey: null,
          ctrlKey: null,
          shiftKey: null,
          getModifierState: Mi
        });

        function nj(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Y.augmentClass(nj, {
          propertyName: null,
          elapsedTime: null,
          pseudoElement: null
        });

        function oj(a, b, c, d) {
          return Y.call(this, a, b, c, d);
        }

        Ni.augmentClass(oj, {
          deltaX: function deltaX(a) {
            return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
          },
          deltaY: function deltaY(a) {
            return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
          },
          deltaZ: null,
          deltaMode: null
        });
        var pj = {},
            qj = {};
        "abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function (a) {
          var b = a[0].toUpperCase() + a.slice(1),
              c = "on" + b;
          b = "top" + b;
          c = {
            phasedRegistrationNames: {
              bubbled: c,
              captured: c + "Capture"
            },
            dependencies: [b]
          };
          pj[a] = c;
          qj[b] = c;
        });
        var rj = {
          eventTypes: pj,
          extractEvents: function extractEvents(a, b, c, d) {
            var e = qj[a];
            if (!e) return null;

            switch (a) {
              case "topAbort":
              case "topCancel":
              case "topCanPlay":
              case "topCanPlayThrough":
              case "topClose":
              case "topDurationChange":
              case "topEmptied":
              case "topEncrypted":
              case "topEnded":
              case "topError":
              case "topInput":
              case "topInvalid":
              case "topLoad":
              case "topLoadedData":
              case "topLoadedMetadata":
              case "topLoadStart":
              case "topPause":
              case "topPlay":
              case "topPlaying":
              case "topProgress":
              case "topRateChange":
              case "topReset":
              case "topSeeked":
              case "topSeeking":
              case "topStalled":
              case "topSubmit":
              case "topSuspend":
              case "topTimeUpdate":
              case "topToggle":
              case "topVolumeChange":
              case "topWaiting":
                var f = Y;
                break;

              case "topKeyPress":
                if (0 === hj(c)) return null;

              case "topKeyDown":
              case "topKeyUp":
                f = kj;
                break;

              case "topBlur":
              case "topFocus":
                f = gj;
                break;

              case "topClick":
                if (2 === c.button) return null;

              case "topDoubleClick":
              case "topMouseDown":
              case "topMouseMove":
              case "topMouseUp":
              case "topMouseOut":
              case "topMouseOver":
              case "topContextMenu":
                f = Ni;
                break;

              case "topDrag":
              case "topDragEnd":
              case "topDragEnter":
              case "topDragExit":
              case "topDragLeave":
              case "topDragOver":
              case "topDragStart":
              case "topDrop":
                f = lj;
                break;

              case "topTouchCancel":
              case "topTouchEnd":
              case "topTouchMove":
              case "topTouchStart":
                f = mj;
                break;

              case "topAnimationEnd":
              case "topAnimationIteration":
              case "topAnimationStart":
                f = ej;
                break;

              case "topTransitionEnd":
                f = nj;
                break;

              case "topScroll":
                f = Ji;
                break;

              case "topWheel":
                f = oj;
                break;

              case "topCopy":
              case "topCut":
              case "topPaste":
                f = fj;
            }

            f ? void 0 : w("86", a);
            a = f.getPooled(e, b, c, d);
            Th.accumulateTwoPhaseDispatches(a);
            return a;
          }
        };
        L.setHandleTopLevel(M.handleTopLevel);
        Jb.injection.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
        ib.injection.injectComponentTree(G);
        Jb.injection.injectEventPluginsByName({
          SimpleEventPlugin: rj,
          EnterLeaveEventPlugin: Pi,
          ChangeEventPlugin: Ii,
          SelectEventPlugin: dj,
          BeforeInputEventPlugin: ri
        });
        var sj = A.injection.MUST_USE_PROPERTY,
            Z = A.injection.HAS_BOOLEAN_VALUE,
            tj = A.injection.HAS_NUMERIC_VALUE,
            uj = A.injection.HAS_POSITIVE_NUMERIC_VALUE,
            vj = A.injection.HAS_STRING_BOOLEAN_VALUE,
            wj = {
          Properties: {
            allowFullScreen: Z,
            allowTransparency: vj,
            async: Z,
            autoPlay: Z,
            capture: Z,
            checked: sj | Z,
            cols: uj,
            contentEditable: vj,
            controls: Z,
            "default": Z,
            defer: Z,
            disabled: Z,
            download: A.injection.HAS_OVERLOADED_BOOLEAN_VALUE,
            draggable: vj,
            formNoValidate: Z,
            hidden: Z,
            loop: Z,
            multiple: sj | Z,
            muted: sj | Z,
            noValidate: Z,
            open: Z,
            playsInline: Z,
            readOnly: Z,
            required: Z,
            reversed: Z,
            rows: uj,
            rowSpan: tj,
            scoped: Z,
            seamless: Z,
            selected: sj | Z,
            size: uj,
            start: tj,
            span: uj,
            spellCheck: vj,
            style: 0,
            itemScope: Z,
            acceptCharset: 0,
            className: 0,
            htmlFor: 0,
            httpEquiv: 0,
            value: vj
          },
          DOMAttributeNames: {
            acceptCharset: "accept-charset",
            className: "class",
            htmlFor: "for",
            httpEquiv: "http-equiv"
          },
          DOMMutationMethods: {
            value: function value(a, b) {
              if (null == b) return a.removeAttribute("value");
              "number" !== a.type || !1 === a.hasAttribute("value") ? a.setAttribute("value", "" + b) : a.validity && !a.validity.badInput && a.ownerDocument.activeElement !== a && a.setAttribute("value", "" + b);
            }
          }
        },
            xj = A.injection.HAS_STRING_BOOLEAN_VALUE,
            yj = {
          xlink: "http://www.w3.org/1999/xlink",
          xml: "http://www.w3.org/XML/1998/namespace"
        },
            zj = {
          Properties: {
            autoReverse: xj,
            externalResourcesRequired: xj,
            preserveAlpha: xj
          },
          DOMAttributeNames: {
            autoReverse: "autoReverse",
            externalResourcesRequired: "externalResourcesRequired",
            preserveAlpha: "preserveAlpha"
          },
          DOMAttributeNamespaces: {
            xlinkActuate: yj.xlink,
            xlinkArcrole: yj.xlink,
            xlinkHref: yj.xlink,
            xlinkRole: yj.xlink,
            xlinkShow: yj.xlink,
            xlinkTitle: yj.xlink,
            xlinkType: yj.xlink,
            xmlBase: yj.xml,
            xmlLang: yj.xml,
            xmlSpace: yj.xml
          }
        },
            Aj = /[\-\:]([a-z])/g;

        function Bj(a) {
          return a[1].toUpperCase();
        }

        "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function (a) {
          var b = a.replace(Aj, Bj);
          zj.Properties[b] = 0;
          zj.DOMAttributeNames[b] = a;
        });
        A.injection.injectDOMPropertyConfig(wj);
        A.injection.injectDOMPropertyConfig(zj);
        var Cj = ig.injectInternals,
            Dj = F.ELEMENT_NODE,
            Ej = F.TEXT_NODE,
            Fj = F.COMMENT_NODE,
            Gj = F.DOCUMENT_NODE,
            Hj = F.DOCUMENT_FRAGMENT_NODE,
            Ij = A.ROOT_ATTRIBUTE_NAME,
            Jj = ka.getChildNamespace,
            Kj = N.createElement,
            Lj = N.createTextNode,
            Mj = N.setInitialProperties,
            Nj = N.diffProperties,
            Oj = N.updateProperties,
            Pj = N.diffHydratedProperties,
            Qj = N.diffHydratedText,
            Rj = N.warnForDeletedHydratableElement,
            Sj = N.warnForDeletedHydratableText,
            Tj = N.warnForInsertedHydratedElement,
            Uj = N.warnForInsertedHydratedText,
            Vj = G.precacheFiberNode,
            Wj = G.updateFiberProps;
        nb.injection.injectFiberControlledHostComponent(N);

        Dh._injectFiber(function (a) {
          return Xj.findHostInstance(a);
        });

        var Yj = null,
            Zj = null;

        function ak(a) {
          return !(!a || a.nodeType !== Dj && a.nodeType !== Gj && a.nodeType !== Hj && (a.nodeType !== Fj || " react-mount-point-unstable " !== a.nodeValue));
        }

        function bk(a) {
          a = a ? a.nodeType === Gj ? a.documentElement : a.firstChild : null;
          return !(!a || a.nodeType !== Dj || !a.hasAttribute(Ij));
        }

        var Xj = function (a) {
          var b = a.getPublicInstance;
          a = hh(a);
          var c = a.scheduleUpdate,
              d = a.getPriorityContext;
          return {
            createContainer: function createContainer(a) {
              var b = ee();
              a = {
                current: b,
                containerInfo: a,
                isScheduled: !1,
                nextScheduledRoot: null,
                context: null,
                pendingContext: null
              };
              return b.stateNode = a;
            },
            updateContainer: function updateContainer(a, b, g, h) {
              var e = b.current;
              g = jh(g);
              null === b.context ? b.context = g : b.pendingContext = g;
              b = h;
              h = d(e, ed.enableAsyncSubtreeAPI && null != a && null != a.type && null != a.type.prototype && !0 === a.type.prototype.unstable_isAsyncReactComponent);
              a = {
                element: a
              };
              kh(e, a, void 0 === b ? null : b, h);
              c(e, h);
            },
            batchedUpdates: a.batchedUpdates,
            unbatchedUpdates: a.unbatchedUpdates,
            deferredUpdates: a.deferredUpdates,
            flushSync: a.flushSync,
            getPublicRootInstance: function getPublicRootInstance(a) {
              a = a.current;
              if (!a.child) return null;

              switch (a.child.tag) {
                case oh:
                  return b(a.child.stateNode);

                default:
                  return a.child.stateNode;
              }
            },
            findHostInstance: function findHostInstance(a) {
              a = ph(a);
              return null === a ? null : a.stateNode;
            },
            findHostInstanceWithNoPortals: function findHostInstanceWithNoPortals(a) {
              a = qh(a);
              return null === a ? null : a.stateNode;
            }
          };
        }({
          getRootHostContext: function getRootHostContext(a) {
            if (a.nodeType === Gj) a = (a = a.documentElement) ? a.namespaceURI : Jj(null, "");else {
              var b = a.nodeType === Fj ? a.parentNode : a;
              a = b.namespaceURI || null;
              b = b.tagName;
              a = Jj(a, b);
            }
            return a;
          },
          getChildHostContext: function getChildHostContext(a, b) {
            return Jj(a, b);
          },
          getPublicInstance: function getPublicInstance(a) {
            return a;
          },
          prepareForCommit: function prepareForCommit() {
            Yj = M.isEnabled();
            Zj = zh.getSelectionInformation();
            M.setEnabled(!1);
          },
          resetAfterCommit: function resetAfterCommit() {
            zh.restoreSelection(Zj);
            Zj = null;
            M.setEnabled(Yj);
            Yj = null;
          },
          createInstance: function createInstance(a, b, c, d, e) {
            a = Kj(a, b, c, d);
            Vj(e, a);
            Wj(a, b);
            return a;
          },
          appendInitialChild: function appendInitialChild(a, b) {
            a.appendChild(b);
          },
          finalizeInitialChildren: function finalizeInitialChildren(a, b, c, d) {
            Mj(a, b, c, d);

            a: {
              switch (b) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  a = !!c.autoFocus;
                  break a;
              }

              a = !1;
            }

            return a;
          },
          prepareUpdate: function prepareUpdate(a, b, c, d, e) {
            return Nj(a, b, c, d, e);
          },
          commitMount: function commitMount(a) {
            a.focus();
          },
          commitUpdate: function commitUpdate(a, b, c, d, e) {
            Wj(a, e);
            Oj(a, b, c, d, e);
          },
          shouldSetTextContent: function shouldSetTextContent(a, b) {
            return "textarea" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && "string" === typeof b.dangerouslySetInnerHTML.__html;
          },
          resetTextContent: function resetTextContent(a) {
            a.textContent = "";
          },
          shouldDeprioritizeSubtree: function shouldDeprioritizeSubtree(a, b) {
            return !!b.hidden;
          },
          createTextInstance: function createTextInstance(a, b, c, d) {
            a = Lj(a, b);
            Vj(d, a);
            return a;
          },
          commitTextUpdate: function commitTextUpdate(a, b, c) {
            a.nodeValue = c;
          },
          appendChild: function appendChild(a, b) {
            a.appendChild(b);
          },
          appendChildToContainer: function appendChildToContainer(a, b) {
            a.nodeType === Fj ? a.parentNode.insertBefore(b, a) : a.appendChild(b);
          },
          insertBefore: function insertBefore(a, b, c) {
            a.insertBefore(b, c);
          },
          insertInContainerBefore: function insertInContainerBefore(a, b, c) {
            a.nodeType === Fj ? a.parentNode.insertBefore(b, c) : a.insertBefore(b, c);
          },
          removeChild: function removeChild(a, b) {
            a.removeChild(b);
          },
          removeChildFromContainer: function removeChildFromContainer(a, b) {
            a.nodeType === Fj ? a.parentNode.removeChild(b) : a.removeChild(b);
          },
          canHydrateInstance: function canHydrateInstance(a, b) {
            return a.nodeType === Dj && b === a.nodeName.toLowerCase();
          },
          canHydrateTextInstance: function canHydrateTextInstance(a, b) {
            return "" === b ? !1 : a.nodeType === Ej;
          },
          getNextHydratableSibling: function getNextHydratableSibling(a) {
            for (a = a.nextSibling; a && a.nodeType !== Dj && a.nodeType !== Ej;) {
              a = a.nextSibling;
            }

            return a;
          },
          getFirstHydratableChild: function getFirstHydratableChild(a) {
            for (a = a.firstChild; a && a.nodeType !== Dj && a.nodeType !== Ej;) {
              a = a.nextSibling;
            }

            return a;
          },
          hydrateInstance: function hydrateInstance(a, b, c, d, e, f) {
            Vj(f, a);
            Wj(a, c);
            return Pj(a, b, c, e, d);
          },
          hydrateTextInstance: function hydrateTextInstance(a, b, c) {
            Vj(c, a);
            return Qj(a, b);
          },
          didNotHydrateInstance: function didNotHydrateInstance(a, b) {
            1 === b.nodeType ? Rj(a, b) : Sj(a, b);
          },
          didNotFindHydratableInstance: function didNotFindHydratableInstance(a, b, c) {
            Tj(a, b, c);
          },
          didNotFindHydratableTextInstance: function didNotFindHydratableTextInstance(a, b) {
            Uj(a, b);
          },
          scheduleDeferredCallback: dd.rIC,
          useSyncScheduling: !0
        });

        sb.injection.injectFiberBatchedUpdates(Xj.batchedUpdates);

        function ck(a, b, c, d, e) {
          ak(c) ? void 0 : w("200");
          var f = c._reactRootContainer;
          if (f) Xj.updateContainer(b, f, a, e);else {
            if (!d && !bk(c)) for (d = void 0; d = c.lastChild;) {
              c.removeChild(d);
            }
            var g = Xj.createContainer(c);
            f = c._reactRootContainer = g;
            Xj.unbatchedUpdates(function () {
              Xj.updateContainer(b, g, a, e);
            });
          }
          return Xj.getPublicRootInstance(f);
        }

        function dk(a, b) {
          var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
          ak(b) ? void 0 : w("200");
          return ne.createPortal(a, b, null, c);
        }

        var ek = {
          createPortal: dk,
          hydrate: function hydrate(a, b, c) {
            return ck(null, a, b, !0, c);
          },
          render: function render(a, b, c) {
            return ck(null, a, b, !1, c);
          },
          unstable_renderSubtreeIntoContainer: function unstable_renderSubtreeIntoContainer(a, b, c, d) {
            null != a && Pa.has(a) ? void 0 : w("38");
            return ck(a, b, c, !1, d);
          },
          unmountComponentAtNode: function unmountComponentAtNode(a) {
            ak(a) ? void 0 : w("40");
            return a._reactRootContainer ? (Xj.unbatchedUpdates(function () {
              ck(null, null, a, !1, function () {
                a._reactRootContainer = null;
              });
            }), !0) : !1;
          },
          findDOMNode: Dh,
          unstable_createPortal: dk,
          unstable_batchedUpdates: sb.batchedUpdates,
          unstable_deferredUpdates: Xj.deferredUpdates,
          flushSync: Xj.flushSync,
          __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: {
            EventPluginHub: Jb,
            EventPluginRegistry: sa,
            EventPropagators: Th,
            ReactControlledComponent: nb,
            ReactDOMComponentTree: G,
            ReactDOMEventListener: L
          }
        };
        Cj({
          findFiberByHostInstance: G.getClosestInstanceFromNode,
          findHostInstanceByFiber: Xj.findHostInstance,
          bundleType: 0,
          version: "16.0.0",
          rendererPackageName: "react-dom"
        });
        module.exports = ek;
        /***/
      },

      /***/
      "./node_modules/react-dom/index.js":
      /*!*****************************************!*\
        !*** ./node_modules/react-dom/index.js ***!
        \*****************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactDomIndexJs(module, exports, __webpack_require__) {
        "use strict";

        function checkDCE() {
          /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
          if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
            return;
          }

          if (false) {}

          try {
            // Verify that the code above has been dead code eliminated (DCE'd).
            __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
          } catch (err) {
            // DevTools shouldn't crash React, no matter what.
            // We should still report in case we break this code.
            console.error(err);
          }
        }

        if (true) {
          // DCE check should happen before ReactDOM bundle executes so that
          // DevTools can report bad minification during injection.
          checkDCE();
          module.exports = __webpack_require__(
          /*! ./cjs/react-dom.production.min.js */
          "./node_modules/react-dom/cjs/react-dom.production.min.js");
        } else {}
        /***/

      },

      /***/
      "./node_modules/react-infinite-scroll-component/lib/index.js":
      /*!*******************************************************************!*\
        !*** ./node_modules/react-infinite-scroll-component/lib/index.js ***!
        \*******************************************************************/

      /*! no static exports found */

      /***/
      function node_modulesReactInfiniteScrollComponentLibIndexJs(module, exports, __webpack_require__) {
        (function webpackUniversalModuleDefinition(root, factory) {
          if (true) module.exports = factory(__webpack_require__(
          /*! react */
          "react"));else {}
        })(this, function (__WEBPACK_EXTERNAL_MODULE_8__) {
          return (
            /******/
            function (modules) {
              // webpackBootstrap

              /******/
              // The module cache

              /******/
              var installedModules = {};
              /******/
              // The require function

              /******/

              function __webpack_require__(moduleId) {
                /******/
                // Check if module is in cache

                /******/
                if (installedModules[moduleId])
                  /******/
                  return installedModules[moduleId].exports;
                /******/
                // Create a new module (and put it into the cache)

                /******/

                var module = installedModules[moduleId] = {
                  /******/
                  exports: {},

                  /******/
                  id: moduleId,

                  /******/
                  loaded: false
                  /******/

                };
                /******/
                // Execute the module function

                /******/

                modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
                /******/
                // Flag the module as loaded

                /******/

                module.loaded = true;
                /******/
                // Return the exports of the module

                /******/

                return module.exports;
                /******/
              }
              /******/
              // expose the modules object (__webpack_modules__)

              /******/


              __webpack_require__.m = modules;
              /******/
              // expose the module cache

              /******/

              __webpack_require__.c = installedModules;
              /******/
              // __webpack_public_path__

              /******/

              __webpack_require__.p = "";
              /******/
              // Load entry module and return exports

              /******/

              return __webpack_require__(0);
              /******/
            }(
            /************************************************************************/

            /******/
            [
            /* 0 */

            /***/
            function (module, exports, __webpack_require__) {
              "use strict";

              Object.defineProperty(exports, "__esModule", {
                value: true
              });

              var _extends = Object.assign || function (target) {
                for (var i = 1; i < arguments.length; i++) {
                  var source = arguments[i];

                  for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                      target[key] = source[key];
                    }
                  }
                }

                return target;
              };

              var _createClass = function () {
                function defineProperties(target, props) {
                  for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || false;
                    descriptor.configurable = true;
                    if ("value" in descriptor) descriptor.writable = true;
                    Object.defineProperty(target, descriptor.key, descriptor);
                  }
                }

                return function (Constructor, protoProps, staticProps) {
                  if (protoProps) defineProperties(Constructor.prototype, protoProps);
                  if (staticProps) defineProperties(Constructor, staticProps);
                  return Constructor;
                };
              }();

              var _get = function get(_x2, _x3, _x4) {
                var _again = true;

                _function: while (_again) {
                  var object = _x2,
                      property = _x3,
                      receiver = _x4;
                  _again = false;
                  if (object === null) object = Function.prototype;
                  var desc = Object.getOwnPropertyDescriptor(object, property);

                  if (desc === undefined) {
                    var parent = Object.getPrototypeOf(object);

                    if (parent === null) {
                      return undefined;
                    } else {
                      _x2 = parent;
                      _x3 = property;
                      _x4 = receiver;
                      _again = true;
                      desc = parent = undefined;
                      continue _function;
                    }
                  } else if ("value" in desc) {
                    return desc.value;
                  } else {
                    var getter = desc.get;

                    if (getter === undefined) {
                      return undefined;
                    }

                    return getter.call(receiver);
                  }
                }
              };

              function _interopRequireDefault(obj) {
                return obj && obj.__esModule ? obj : {
                  "default": obj
                };
              }

              function _classCallCheck(instance, Constructor) {
                if (!(instance instanceof Constructor)) {
                  throw new TypeError("Cannot call a class as a function");
                }
              }

              function _inherits(subClass, superClass) {
                if (typeof superClass !== "function" && superClass !== null) {
                  throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
                }

                subClass.prototype = Object.create(superClass && superClass.prototype, {
                  constructor: {
                    value: subClass,
                    enumerable: false,
                    writable: true,
                    configurable: true
                  }
                });
                if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
              }

              var _react = __webpack_require__(8);

              var _react2 = _interopRequireDefault(_react);

              var _propTypes = __webpack_require__(6);

              var _propTypes2 = _interopRequireDefault(_propTypes);

              var _utilsThrottle = __webpack_require__(2);

              var _utilsThrottle2 = _interopRequireDefault(_utilsThrottle);

              var _utilsThreshold = __webpack_require__(1);

              var InfiniteScroll = function (_Component) {
                _inherits(InfiniteScroll, _Component);

                function InfiniteScroll(props) {
                  _classCallCheck(this, InfiniteScroll);

                  _get(Object.getPrototypeOf(InfiniteScroll.prototype), "constructor", this).call(this, props);

                  this.lastScrollTop = 0;
                  this.actionTriggered = false;
                  this.state = {
                    showLoader: false,
                    pullToRefreshThresholdBreached: false
                  }; // variables to keep track of pull down behaviour

                  this.startY = 0;
                  this.currentY = 0;
                  this.dragging = false; // will be populated in componentDidMount
                  // based on the height of the pull down element

                  this.maxPullDownDistance = 0;
                  this.onScrollListener = this.onScrollListener.bind(this);
                  this.throttledOnScrollListener = (0, _utilsThrottle2["default"])(this.onScrollListener, 150).bind(this);
                  this.onStart = this.onStart.bind(this);
                  this.onMove = this.onMove.bind(this);
                  this.onEnd = this.onEnd.bind(this);
                  this.getScrollableTarget = this.getScrollableTarget.bind(this);
                }

                _createClass(InfiniteScroll, [{
                  key: "componentDidMount",
                  value: function componentDidMount() {
                    this._scrollableNode = this.getScrollableTarget();
                    this.el = this.props.height ? this._infScroll : this._scrollableNode || window;
                    this.el.addEventListener("scroll", this.throttledOnScrollListener);

                    if (typeof this.props.initialScrollY === "number" && this.el.scrollHeight > this.props.initialScrollY) {
                      this.el.scrollTo(0, this.props.initialScrollY);
                    }

                    if (this.props.pullDownToRefresh) {
                      this.el.addEventListener("touchstart", this.onStart);
                      this.el.addEventListener("touchmove", this.onMove);
                      this.el.addEventListener("touchend", this.onEnd);
                      this.el.addEventListener("mousedown", this.onStart);
                      this.el.addEventListener("mousemove", this.onMove);
                      this.el.addEventListener("mouseup", this.onEnd); // get BCR of pullDown element to position it above

                      this.maxPullDownDistance = this._pullDown.firstChild.getBoundingClientRect().height;
                      this.forceUpdate();

                      if (typeof this.props.refreshFunction !== "function") {
                        throw new Error("Mandatory prop \"refreshFunction\" missing.\n          Pull Down To Refresh functionality will not work\n          as expected. Check README.md for usage'");
                      }
                    }
                  }
                }, {
                  key: "componentWillUnmount",
                  value: function componentWillUnmount() {
                    this.el.removeEventListener("scroll", this.throttledOnScrollListener);

                    if (this.props.pullDownToRefresh) {
                      this.el.removeEventListener("touchstart", this.onStart);
                      this.el.removeEventListener("touchmove", this.onMove);
                      this.el.removeEventListener("touchend", this.onEnd);
                      this.el.removeEventListener("mousedown", this.onStart);
                      this.el.removeEventListener("mousemove", this.onMove);
                      this.el.removeEventListener("mouseup", this.onEnd);
                    }
                  }
                }, {
                  key: "componentWillReceiveProps",
                  value: function componentWillReceiveProps(props) {
                    // do nothing when dataLength and key are unchanged
                    if (this.props.key === props.key && this.props.dataLength === props.dataLength) return;
                    this.actionTriggered = false; // update state when new data was sent in

                    this.setState({
                      showLoader: false,
                      pullToRefreshThresholdBreached: false
                    });
                  }
                }, {
                  key: "getScrollableTarget",
                  value: function getScrollableTarget() {
                    if (this.props.scrollableTarget instanceof HTMLElement) return this.props.scrollableTarget;

                    if (typeof this.props.scrollableTarget === 'string') {
                      return document.getElementById(this.props.scrollableTarget);
                    }

                    if (this.props.scrollableTarget === null) {
                      console.warn("You are trying to pass scrollableTarget but it is null. This might\n        happen because the element may not have been added to DOM yet.\n        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.\n      ");
                    }

                    return null;
                  }
                }, {
                  key: "onStart",
                  value: function onStart(evt) {
                    if (this.lastScrollTop) return;
                    this.dragging = true;
                    this.startY = evt.pageY || evt.touches[0].pageY;
                    this.currentY = this.startY;
                    this._infScroll.style.willChange = "transform";
                    this._infScroll.style.transition = "transform 0.2s cubic-bezier(0,0,0.31,1)";
                  }
                }, {
                  key: "onMove",
                  value: function onMove(evt) {
                    if (!this.dragging) return;
                    this.currentY = evt.pageY || evt.touches[0].pageY; // user is scrolling down to up

                    if (this.currentY < this.startY) return;

                    if (this.currentY - this.startY >= this.props.pullDownToRefreshThreshold) {
                      this.setState({
                        pullToRefreshThresholdBreached: true
                      });
                    } // so you can drag upto 1.5 times of the maxPullDownDistance


                    if (this.currentY - this.startY > this.maxPullDownDistance * 1.5) return;
                    this._infScroll.style.overflow = "visible";
                    this._infScroll.style.transform = "translate3d(0px, " + (this.currentY - this.startY) + "px, 0px)";
                  }
                }, {
                  key: "onEnd",
                  value: function onEnd(evt) {
                    var _this = this;

                    this.startY = 0;
                    this.currentY = 0;
                    this.dragging = false;

                    if (this.state.pullToRefreshThresholdBreached) {
                      this.props.refreshFunction && this.props.refreshFunction();
                    }

                    requestAnimationFrame(function () {
                      // this._infScroll
                      if (_this._infScroll) {
                        _this._infScroll.style.overflow = "auto";
                        _this._infScroll.style.transform = "none";
                        _this._infScroll.style.willChange = "none";
                      }
                    });
                  }
                }, {
                  key: "isElementAtBottom",
                  value: function isElementAtBottom(target) {
                    var scrollThreshold = arguments.length <= 1 || arguments[1] === undefined ? 0.8 : arguments[1];
                    var clientHeight = target === document.body || target === document.documentElement ? window.screen.availHeight : target.clientHeight;
                    var threshold = (0, _utilsThreshold.parseThreshold)(scrollThreshold);

                    if (threshold.unit === _utilsThreshold.ThresholdUnits.Pixel) {
                      return target.scrollTop + clientHeight >= target.scrollHeight - threshold.value;
                    }

                    return target.scrollTop + clientHeight >= threshold.value / 100 * target.scrollHeight;
                  }
                }, {
                  key: "onScrollListener",
                  value: function onScrollListener(event) {
                    var _this2 = this;

                    if (typeof this.props.onScroll === "function") {
                      // Execute this callback in next tick so that it does not affect the
                      // functionality of the library.
                      setTimeout(function () {
                        return _this2.props.onScroll(event);
                      }, 0);
                    }

                    var target = this.props.height || this._scrollableNode ? event.target : document.documentElement.scrollTop ? document.documentElement : document.body; // return immediately if the action has already been triggered,
                    // prevents multiple triggers.

                    if (this.actionTriggered) return;
                    var atBottom = this.isElementAtBottom(target, this.props.scrollThreshold); // call the `next` function in the props to trigger the next data fetch

                    if (atBottom && this.props.hasMore) {
                      this.actionTriggered = true;
                      this.setState({
                        showLoader: true
                      });
                      this.props.next();
                    }

                    this.lastScrollTop = target.scrollTop;
                  }
                }, {
                  key: "render",
                  value: function render() {
                    var _this3 = this;

                    var style = _extends({
                      height: this.props.height || "auto",
                      overflow: "auto",
                      WebkitOverflowScrolling: "touch"
                    }, this.props.style);

                    var hasChildren = this.props.hasChildren || !!(this.props.children && this.props.children.length); // because heighted infiniteScroll visualy breaks
                    // on drag down as overflow becomes visible

                    var outerDivStyle = this.props.pullDownToRefresh && this.props.height ? {
                      overflow: "auto"
                    } : {};
                    return _react2["default"].createElement("div", {
                      style: outerDivStyle
                    }, _react2["default"].createElement("div", {
                      className: "infinite-scroll-component " + (this.props.className || ''),
                      ref: function ref(infScroll) {
                        return _this3._infScroll = infScroll;
                      },
                      style: style
                    }, this.props.pullDownToRefresh && _react2["default"].createElement("div", {
                      style: {
                        position: "relative"
                      },
                      ref: function ref(pullDown) {
                        return _this3._pullDown = pullDown;
                      }
                    }, _react2["default"].createElement("div", {
                      style: {
                        position: "absolute",
                        left: 0,
                        right: 0,
                        top: -1 * this.maxPullDownDistance
                      }
                    }, this.state.pullToRefreshThresholdBreached ? this.props.releaseToRefreshContent : this.props.pullDownToRefreshContent)), this.props.children, !this.state.showLoader && !hasChildren && this.props.hasMore && this.props.loader, this.state.showLoader && this.props.hasMore && this.props.loader, !this.props.hasMore && this.props.endMessage));
                  }
                }]);

                return InfiniteScroll;
              }(_react.Component);

              exports["default"] = InfiniteScroll;
              InfiniteScroll.defaultProps = {
                pullDownToRefreshContent: _react2["default"].createElement("h3", null, "Pull down to refresh"),
                releaseToRefreshContent: _react2["default"].createElement("h3", null, "Release to refresh"),
                pullDownToRefreshThreshold: 100,
                disableBrowserPullToRefresh: true
              };
              InfiniteScroll.propTypes = {
                next: _propTypes2["default"].func,
                hasMore: _propTypes2["default"].bool,
                children: _propTypes2["default"].node,
                loader: _propTypes2["default"].node.isRequired,
                scrollThreshold: _propTypes2["default"].oneOfType([_propTypes2["default"].number, _propTypes2["default"].string]),
                endMessage: _propTypes2["default"].node,
                style: _propTypes2["default"].object,
                height: _propTypes2["default"].number,
                scrollableTarget: _propTypes2["default"].node,
                hasChildren: _propTypes2["default"].bool,
                pullDownToRefresh: _propTypes2["default"].bool,
                pullDownToRefreshContent: _propTypes2["default"].node,
                releaseToRefreshContent: _propTypes2["default"].node,
                pullDownToRefreshThreshold: _propTypes2["default"].number,
                refreshFunction: _propTypes2["default"].func,
                onScroll: _propTypes2["default"].func,
                dataLength: _propTypes2["default"].number.isRequired,
                key: _propTypes2["default"].string
              };
              module.exports = exports["default"];
              /***/
            },
            /* 1 */

            /***/
            function (module, exports) {
              'use strict';

              Object.defineProperty(exports, '__esModule', {
                value: true
              });
              exports.parseThreshold = parseThreshold;
              var ThresholdUnits = {
                Pixel: 'Pixel',
                Percent: 'Percent'
              };
              exports.ThresholdUnits = ThresholdUnits;
              var defaultThreshold = {
                unit: ThresholdUnits.Percent,
                value: 0.8
              };

              function parseThreshold(scrollThreshold) {
                if (typeof scrollThreshold === "number") {
                  return {
                    unit: ThresholdUnits.Percent,
                    value: scrollThreshold * 100
                  };
                }

                if (typeof scrollThreshold === "string") {
                  if (scrollThreshold.match(/^(\d*(\.\d+)?)px$/)) {
                    return {
                      unit: ThresholdUnits.Pixel,
                      value: parseFloat(scrollThreshold)
                    };
                  }

                  if (scrollThreshold.match(/^(\d*(\.\d+)?)%$/)) {
                    return {
                      unit: ThresholdUnits.Percent,
                      value: parseFloat(scrollThreshold)
                    };
                  }

                  console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
                  return defaultThreshold;
                }

                console.warn('scrollThreshold should be string or number');
                return defaultThreshold;
              }
              /***/

            },
            /* 2 */

            /***/
            function (module, exports) {
              // https://remysharp.com/2010/07/21/throttling-function-calls
              "use strict";

              Object.defineProperty(exports, "__esModule", {
                value: true
              });
              exports["default"] = throttle;

              function throttle(fn, threshhold, scope) {
                threshhold || (threshhold = 250);
                var last, deferTimer;
                return function () {
                  var context = scope || this;
                  var now = +new Date(),
                      args = arguments;

                  if (last && now < last + threshhold) {
                    // hold on to it
                    clearTimeout(deferTimer);
                    deferTimer = setTimeout(function () {
                      last = now;
                      fn.apply(context, args);
                    }, threshhold);
                  } else {
                    last = now;
                    fn.apply(context, args);
                  }
                };
              }

              module.exports = exports["default"];
              /***/
            },
            /* 3 */

            /***/
            function (module, exports) {
              "use strict";
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               *
               * 
               */

              function makeEmptyFunction(arg) {
                return function () {
                  return arg;
                };
              }
              /**
               * This function accepts and discards inputs; it has no side effects. This is
               * primarily useful idiomatically for overridable function endpoints which
               * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
               */


              var emptyFunction = function emptyFunction() {};

              emptyFunction.thatReturns = makeEmptyFunction;
              emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
              emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
              emptyFunction.thatReturnsNull = makeEmptyFunction(null);

              emptyFunction.thatReturnsThis = function () {
                return this;
              };

              emptyFunction.thatReturnsArgument = function (arg) {
                return arg;
              };

              module.exports = emptyFunction;
              /***/
            },
            /* 4 */

            /***/
            function (module, exports, __webpack_require__) {
              /**
               * Copyright (c) 2013-present, Facebook, Inc.
               *
               * This source code is licensed under the MIT license found in the
               * LICENSE file in the root directory of this source tree.
               *
               */
              'use strict';
              /**
               * Use invariant() to assert state which your program assumes to be true.
               *
               * Provide sprintf-style format (only %s is supported) and arguments
               * to provide information about what broke and what you were
               * expecting.
               *
               * The invariant message will be stripped in production, but the invariant
               * will remain to ensure logic does not differ in production.
               */

              var validateFormat = function validateFormat(format) {};

              if (false) {}

              function invariant(condition, format, a, b, c, d, e, f) {
                validateFormat(format);

                if (!condition) {
                  var error;

                  if (format === undefined) {
                    error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
                  } else {
                    var args = [a, b, c, d, e, f];
                    var argIndex = 0;
                    error = new Error(format.replace(/%s/g, function () {
                      return args[argIndex++];
                    }));
                    error.name = 'Invariant Violation';
                  }

                  error.framesToPop = 1; // we don't care about invariant's own frame

                  throw error;
                }
              }

              module.exports = invariant;
              /***/
            },
            /* 5 */

            /***/
            function (module, exports, __webpack_require__) {
              /**
               * Copyright 2013-present, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               */
              'use strict';

              var emptyFunction = __webpack_require__(3);

              var invariant = __webpack_require__(4);

              var ReactPropTypesSecret = __webpack_require__(7);

              module.exports = function () {
                function shim(props, propName, componentName, location, propFullName, secret) {
                  if (secret === ReactPropTypesSecret) {
                    // It is still safe when called from React.
                    return;
                  }

                  invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
                }

                ;
                shim.isRequired = shim;

                function getShim() {
                  return shim;
                }

                ; // Important!
                // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.

                var ReactPropTypes = {
                  array: shim,
                  bool: shim,
                  func: shim,
                  number: shim,
                  object: shim,
                  string: shim,
                  symbol: shim,
                  any: shim,
                  arrayOf: getShim,
                  element: shim,
                  instanceOf: getShim,
                  node: shim,
                  objectOf: getShim,
                  oneOf: getShim,
                  oneOfType: getShim,
                  shape: getShim
                };
                ReactPropTypes.checkPropTypes = emptyFunction;
                ReactPropTypes.PropTypes = ReactPropTypes;
                return ReactPropTypes;
              };
              /***/

            },
            /* 6 */

            /***/
            function (module, exports, __webpack_require__) {
              /**
               * Copyright 2013-present, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               */
              if (false) {
                var throwOnDirectAccess, isValidElement, REACT_ELEMENT_TYPE;
              } else {
                // By explicitly using `prop-types` you are opting into new production behavior.
                // http://fb.me/prop-types-in-prod
                module.exports = __webpack_require__(5)();
              }
              /***/

            },
            /* 7 */

            /***/
            function (module, exports) {
              /**
               * Copyright 2013-present, Facebook, Inc.
               * All rights reserved.
               *
               * This source code is licensed under the BSD-style license found in the
               * LICENSE file in the root directory of this source tree. An additional grant
               * of patent rights can be found in the PATENTS file in the same directory.
               */
              'use strict';

              var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
              module.exports = ReactPropTypesSecret;
              /***/
            },
            /* 8 */

            /***/
            function (module, exports) {
              module.exports = __WEBPACK_EXTERNAL_MODULE_8__;
              /***/
            }])
          );
        });

        ;
        /***/
      },

      /***/
      "./src/a11y/index.js":
      /*!***************************!*\
        !*** ./src/a11y/index.js ***!
        \***************************/

      /*! exports provided: getAriaLabel */

      /***/
      function srcA11yIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getAriaLabel", function () {
          return getAriaLabel;
        });

        function getAriaLabel(label, additionalLabelledBy) {
          var attributes = getAriaAttributeForLabel(label);

          if (additionalLabelledBy) {
            attributes['aria-labelledby'] = ((attributes['aria-labelledby'] || '') + ' ' + additionalLabelledBy).trim();
          }

          return attributes;
        }

        function getAriaAttributeForLabel(label) {
          if (!label) return {};
          /* See readme for label. When label starts with # it references ids of dom nodes instead.
            When used on aria-labelledby, they should be referenced without a starting hash/# */

          if (label[0] === '#') {
            return {
              'aria-labelledby': label.substring(1).replace(/ #/g, ' ')
            };
          }

          return {
            'aria-label': label
          };
        }
        /***/

      },

      /***/
      "./src/checkbox/index.js":
      /*!*******************************!*\
        !*** ./src/checkbox/index.js ***!
        \*******************************/

      /*! exports provided: refUpdater, default */

      /***/
      function srcCheckboxIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "refUpdater", function () {
          return refUpdater;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _objectWithoutProperties(obj, keys) {
          var target = {};

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }

          return target;
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var refUpdater = function refUpdater(_ref) {
          var checked = _ref.checked,
              indeterminate = _ref.indeterminate;
          return function (input) {
            if (input) {
              input.checked = checked;
              input.indeterminate = indeterminate;
            }
          };
        };

        var Checkbox = function (_PureComponent) {
          _inherits(Checkbox, _PureComponent);

          function Checkbox() {
            _classCallCheck(this, Checkbox);

            return _possibleConstructorReturn(this, (Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).apply(this, arguments));
          }

          _createClass(Checkbox, [{
            key: 'render',
            value: function render() {
              var _props = this.props,
                  checked = _props.checked,
                  _props$indeterminate = _props.indeterminate,
                  indeterminate = _props$indeterminate === undefined ? false : _props$indeterminate,
                  onChange = _props.onChange,
                  disabled = _props.disabled,
                  readOnly = _props.readOnly,
                  rest = _objectWithoutProperties(_props, ['checked', 'indeterminate', 'onChange', 'disabled', 'readOnly']);

              var isDisabled = disabled || readOnly;
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('input', _extends({
                type: 'checkbox',
                ref: refUpdater({
                  checked: checked,
                  indeterminate: indeterminate
                }),
                onChange: onChange,
                disabled: isDisabled
              }, rest));
            }
          }]);

          return Checkbox;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);

        Checkbox.propTypes = {
          checked: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          indeterminate: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
        };
        /* harmony default export */

        __webpack_exports__["default"] = Checkbox;
        /***/
      },

      /***/
      "./src/index.css":
      /*!***********************!*\
        !*** ./src/index.css ***!
        \***********************/

      /*! no static exports found */

      /***/
      function srcIndexCss(module, exports, __webpack_require__) {// extracted by mini-css-extract-plugin

        /***/
      },

      /***/
      "./src/index.js":
      /*!**********************!*\
        !*** ./src/index.js ***!
        \**********************/

      /*! exports provided: default */

      /***/
      function srcIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! classnames/bind */
        "./node_modules/classnames/bind.js");
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./utils */
        "./src/utils/index.js");
        /* harmony import */


        var _input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./input */
        "./src/input/index.js");
        /* harmony import */


        var _trigger__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./trigger */
        "./src/trigger/index.js");
        /* harmony import */


        var _tree__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./tree */
        "./src/tree/index.js");
        /* harmony import */


        var _tree_manager__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./tree-manager */
        "./src/tree-manager/index.js");
        /* harmony import */


        var _tree_manager_keyboardNavigation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(
        /*! ./tree-manager/keyboardNavigation */
        "./src/tree-manager/keyboardNavigation.js");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(
        /*! ./index.css */
        "./src/index.css");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_9___default =
        /*#__PURE__*/
        __webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_9__);
        /* harmony import */


        var _a11y__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(
        /*! ./a11y */
        "./src/a11y/index.js");
        /* harmony import */


        var react_dom__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(
        /*! react-dom */
        "./node_modules/react-dom/index.js");
        /* harmony import */


        var react_dom__WEBPACK_IMPORTED_MODULE_11___default =
        /*#__PURE__*/
        __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_11__);
        /* harmony import */


        var memoize_one__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(
        /*! memoize-one */
        "./node_modules/memoize-one/dist/memoize-one.esm.js");

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }
        /*!
         * React Dropdown Tree Select
         * A lightweight, fast and highly customizable tree select component.
         * Hrusikesh Panda <hrusikesh.panda@dowjones.com>
         * Copyright (c) 2017 Dow Jones, Inc. <support@dowjones.com> (http://dowjones.com)
         * license MIT
         * see https://github.com/dowjones/react-dropdown-tree-select
         */


        var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default.a.bind(_index_css__WEBPACK_IMPORTED_MODULE_9___default.a);
        var initialState = {
          searchInput: '',
          searchModeOn: false,
          currentFocus: undefined,
          dropUp: false
        };
        var WINDOW_OFFSET = 43;
        var DETERMINE_DROPUP_DEVOUNCE_TIME = 250;

        var DropdownTreeSelect = function (_Component) {
          _inherits(DropdownTreeSelect, _Component);

          function DropdownTreeSelect(props) {
            _classCallCheck(this, DropdownTreeSelect);

            var _this = _possibleConstructorReturn(this, (DropdownTreeSelect.__proto__ || Object.getPrototypeOf(DropdownTreeSelect)).call(this, props));

            _this.initNewProps = function (_ref) {
              var data = _ref.data,
                  mode = _ref.mode,
                  showDropdown = _ref.showDropdown,
                  showPartiallySelected = _ref.showPartiallySelected,
                  searchPredicate = _ref.searchPredicate;
              _this.treeManager = new _tree_manager__WEBPACK_IMPORTED_MODULE_7__["default"]({
                data: data !== null && data !== undefined ? data : [],
                mode: mode,
                showPartiallySelected: showPartiallySelected,
                rootPrefixId: _this.clientId,
                searchPredicate: searchPredicate,
                enforceSingleSelection: _this.props.enforceSingleSelection
              }); // Restore focus-state

              var currentFocusNode = _this.state.currentFocus && _this.treeManager.getNodeById(_this.state.currentFocus);

              if (currentFocusNode) {
                currentFocusNode._focused = true;
              }

              _this.setState(function (prevState) {
                return _extends({
                  showDropdown: /initial|always/.test(showDropdown) || prevState.showDropdown === true
                }, _this.treeManager.getTreeAndTags());
              });

              _this.determineDropUp();
            };

            _this.resetSearchState = function () {
              // clear the search criteria and avoid react controlled/uncontrolled warning
              _this.searchInput.current.value = '';
              return {
                tree: _this.treeManager.restoreNodes(),
                // restore the tree to its pre-search state
                searchModeOn: false,
                allNodesHidden: false
              };
            };

            _this.memoizedInitNewProps = Object(memoize_one__WEBPACK_IMPORTED_MODULE_12__["default"])(function (nextProps) {
              return _this.initNewProps(nextProps);
            });

            _this.handleClick = function (e, callback) {
              _this.setState(function (prevState) {
                // keep dropdown active when typing in search box
                var showDropdown = _this.props.showDropdown === 'always' || _this.keepDropdownActive || !prevState.showDropdown; // register event listeners only if there is a state change

                if (showDropdown !== prevState.showDropdown) {
                  if (showDropdown) {
                    document.addEventListener('click', _this.handleOutsideClick, false);
                  } else {
                    document.removeEventListener('click', _this.handleOutsideClick, false);
                  }
                }

                if (showDropdown) _this.props.onFocus();else _this.props.onBlur();
                return !showDropdown ? _extends({
                  showDropdown: showDropdown
                }, _this.resetSearchState()) : {
                  showDropdown: showDropdown
                };
              }, callback);
            };

            _this.handleOutsideClick = function (e) {
              if (_this.props.showDropdown === 'always' || !Object(_utils__WEBPACK_IMPORTED_MODULE_3__["isOutsideClick"])(e, _this.node)) {
                return;
              }

              _this.handleClick();
            };

            _this.resetComponent = function () {
              var initialPropsWithData = _extends({}, _this.initialProps, {
                data: _this.initialData
              });

              _this.setState(initialState, function () {
                return _this.memoizedInitNewProps(initialPropsWithData);
              });
            };

            _this.onInputChange = function (value) {
              if (value !== null && value !== undefined && value !== _this.props.value) {
                var _this$treeManager$fil = _this.treeManager.filterTree(value, _this.props.keepTreeOnSearch, _this.props.keepChildrenOnSearch),
                    allNodesHidden = _this$treeManager$fil.allNodesHidden,
                    tree = _this$treeManager$fil.tree;

                var searchModeOn = value.length > 0;
                if (_this.props.onInputChange) _this.props.onInputChange(value);

                if (!value) {
                  return _this.resetComponent();
                }

                _this.setState({
                  searchInput: value,
                  tree: tree,
                  searchModeOn: searchModeOn,
                  allNodesHidden: allNodesHidden
                });
              }
            };

            _this.setFocusedNode = function (nodeId) {
              _this.setState({
                currentFocus: nodeId
              });
            };

            _this.getNodeBySearchTerm = function (value) {
              var _this$treeManager$fil2 = _this.treeManager.filterTree(value, _this.props.keepTreeOnSearch, _this.props.keepChildrenOnSearch),
                  tree = _this$treeManager$fil2.tree;

              return tree;
            };

            _this.onTagRemove = function (id, isKeyboardEvent) {
              var prevTags = _this.state.tags;

              _this.onCheckboxChange(id, false, function (tags) {
                if (!isKeyboardEvent) return;

                _tree_manager_keyboardNavigation__WEBPACK_IMPORTED_MODULE_8__["default"].getNextFocusAfterTagDelete(id, prevTags, tags, _this.searchInput.current).focus();
              });
            };

            _this.onNodeToggle = function (id) {
              _this.treeManager.toggleNodeExpandState(id);

              var tree = _this.state.searchModeOn ? _this.treeManager.matchTree : _this.treeManager.tree;

              _this.setState({
                tree: tree
              });

              typeof _this.props.onNodeToggle === 'function' && _this.props.onNodeToggle(_this.treeManager.getNodeById(id));
            };

            _this.onCheckboxChange = function (id, checked, callback) {
              var _this$props = _this.props,
                  mode = _this$props.mode,
                  keepOpenOnSelect = _this$props.keepOpenOnSelect;

              _this.treeManager.setNodeCheckedState(id, checked);

              var tags = _this.treeManager.tags;
              var isSingleSelect = ['simpleSelect', 'radioSelect'].indexOf(mode) > -1;
              var showDropdown = isSingleSelect && !keepOpenOnSelect ? false : _this.state.showDropdown;

              if (!tags.length) {
                _this.treeManager.restoreDefaultValues();

                tags = _this.treeManager.tags;
              } else {
                if (_this.props.enforceSingleSelection) tags = [_this.treeManager.tags[_this.treeManager.tags.length - 1]];
              }

              var tree = _this.state.searchModeOn ? _this.treeManager.matchTree : _this.treeManager.tree;
              var nextState = {
                tree: tree,
                tags: tags,
                showDropdown: showDropdown
              };

              if (isSingleSelect && !showDropdown || _this.props.clearSearchOnChange) {
                Object.assign(nextState, _this.resetSearchState());
              }

              if (isSingleSelect && !showDropdown) {
                document.removeEventListener('click', _this.handleOutsideClick, false);
              }

              _this.setState(nextState, function () {
                callback && callback(tags);
              });

              _this.props.onChange(_this.treeManager.getNodeById(id), tags);

              if (!(mode === 'simpleSelect' && tree.has(_this.state.currentFocus))) {
                // Triggers close
                _this.keepDropdownActive = false;

                _this.handleClick();
              }
            };

            _this.onAction = function (nodeId, action) {
              _this.props.onAction(_this.treeManager.getNodeById(nodeId), action);
            };

            _this.onInputFocus = function () {
              _this.keepDropdownActive = true;
            };

            _this.onInputBlur = function () {
              _this.keepDropdownActive = false;

              if (_this.props.showDropdownChanged) {
                _this.props.showDropdownChanged(false);
              }
            };

            _this.onTrigger = function (e) {
              _this.handleClick(e, function () {
                // If the dropdown is shown after key press, focus the input
                if (_this.state.showDropdown && _this.searchInput.current) {
                  _this.searchInput.current.focus();
                }
              });
            };

            _this.onKeyboardKeyDown = function (e) {
              var _this$props2 = _this.props,
                  readOnly = _this$props2.readOnly,
                  mode = _this$props2.mode;
              var _this$state = _this.state,
                  showDropdown = _this$state.showDropdown,
                  tags = _this$state.tags,
                  searchModeOn = _this$state.searchModeOn,
                  currentFocus = _this$state.currentFocus;
              var tm = _this.treeManager;
              var tree = searchModeOn ? tm.matchTree : tm.tree;

              if (!showDropdown && (_tree_manager_keyboardNavigation__WEBPACK_IMPORTED_MODULE_8__["default"].isValidKey(e.key, false) || /^\w$/i.test(e.key))) {
                // Triggers open of dropdown and retriggers event
                e.persist();

                _this.handleClick(null, function () {
                  return _this.onKeyboardKeyDown(e);
                });

                if (/\w/i.test(e.key)) return;
              } else if (showDropdown && _tree_manager_keyboardNavigation__WEBPACK_IMPORTED_MODULE_8__["default"].isValidKey(e.key, true)) {
                var newFocus = tm.handleNavigationKey(currentFocus, tree, e.key, readOnly, !searchModeOn, _this.onCheckboxChange, _this.onNodeToggle);

                if (newFocus !== currentFocus) {
                  var newFocusData = _this.treeManager.getNodeById(newFocus);

                  _this.props.onNodeNavigate(newFocusData);

                  _this.setState({
                    currentFocus: newFocus
                  });
                }
              } else if (showDropdown && ['Escape', 'Tab'].indexOf(e.key) > -1) {
                if (mode === 'simpleSelect' && tree.has(currentFocus)) {
                  _this.onCheckboxChange(currentFocus, true);
                } else {
                  // Triggers close
                  _this.keepDropdownActive = false;

                  _this.handleClick();
                }

                return;
              } else if (e.key === 'Backspace' && tags.length && _this.searchInput.current.value.length === 0) {// const lastTag = tags.pop()
                // this.onCheckboxChange(lastTag._id, false)
              } else {
                return;
              }

              e.preventDefault();
            };

            _this.getAriaAttributes = function () {
              var _this$props3 = _this.props,
                  mode = _this$props3.mode,
                  texts = _this$props3.texts;
              if (mode !== 'radioSelect') return {};
              return _extends({
                role: 'radiogroup'
              }, Object(_a11y__WEBPACK_IMPORTED_MODULE_10__["getAriaLabel"])(texts.label));
            };

            _this.determineDropUp = _this.debounce(function () {
              var contentBox = Object(react_dom__WEBPACK_IMPORTED_MODULE_11__["findDOMNode"])(this.selectInst);
              var inputBox = Object(react_dom__WEBPACK_IMPORTED_MODULE_11__["findDOMNode"])(this.searchInput.current);

              if (this.props.autoDetermineDropUp !== null && this.props.autoDetermineDropUp !== undefined && this.props.autoDetermineDropUp === false && !contentBox && !inputBox) {
                return;
              }

              if (contentBox) {
                var nodeBoundingRect = contentBox.getBoundingClientRect();
                var inputBoxRect = inputBox.getBoundingClientRect();
                var windowHeight = window.innerHeight - WINDOW_OFFSET;
                var dropUp = false;

                if (inputBoxRect.bottom + nodeBoundingRect.height > windowHeight) {
                  dropUp = inputBoxRect.top - nodeBoundingRect.height > WINDOW_OFFSET;
                }

                if (this.props.onDropUpPositionChanged && this.state.dropUp !== dropUp) {
                  this.props.onDropUpPositionChanged(dropUp ? 'up' : 'down');
                }

                this.setState({
                  dropUp: dropUp
                });
              }
            }, DETERMINE_DROPUP_DEVOUNCE_TIME);
            _this.initialProps = props;
            _this.state = initialState;
            _this.clientId = props.id || _utils__WEBPACK_IMPORTED_MODULE_3__["clientIdGenerator"].get(_this);
            _this.determineDropUp = _this.determineDropUp.bind(_this);
            _this.searchInput = Object(react__WEBPACK_IMPORTED_MODULE_2__["createRef"])();
            return _this;
          }

          _createClass(DropdownTreeSelect, [{
            key: 'componentWillMount',
            value: function componentWillMount() {
              this.initNewProps(this.props);
              this.determineDropUp();
            }
          }, {
            key: 'componentDidMount',
            value: function componentDidMount() {
              this.searchInput.current.focus();
              this.determineDropUp();
              window.addEventListener('resize', this.determineDropUp);
              window.addEventListener('scroll', this.determineDropUp);
            }
          }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
              document.removeEventListener('click', this.handleOutsideClick, false);
              window.removeEventListener('resize', this.determineDropUp);
              window.removeEventListener('scroll', this.determineDropUp);
            }
          }, {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
              if (this.props.data !== nextProps.data || this.props.mode !== nextProps.mode || this.props.showDropdown !== nextProps.showDropdown || this.props.showPartiallySelected !== nextProps.showPartiallySelected || this.props.searchPredicate !== nextProps.searchPredicate) {
                this.memoizedInitNewProps(nextProps);
              }

              if (nextProps.data === null || nextProps.data === undefined) {
                this.initialData = [];
              }

              if (nextProps.data.length > 0) {
                this.initialData = nextProps.data;

                if (nextProps.value !== null && nextProps.value !== undefined) {
                  var matchedElements = this.getNodeBySearchTerm(nextProps.value);

                  if (matchedElements && matchedElements.size > 0) {
                    var domElement = Array.from(matchedElements.values()).pop();
                    this.setFocusedNode(domElement._id);
                    this.setState({
                      scrollToElement: domElement
                    });
                  }
                }
              }
            }
          }, {
            key: 'debounce',
            // Added this this debounce function as the one in utils seems broken.
            value: function debounce(func, wait, immediate) {
              var timeout = void 0;
              return function () {
                var context = this,
                    args = arguments;

                var later = function later() {
                  timeout = null;

                  if (!immediate) {
                    func.apply(context, args);
                  }
                };

                var callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);

                if (callNow) {
                  func.apply(context, args);
                }
              };
            }
          }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
              if (this.state.showDropdown !== prevState.showDropdown) {
                if (this.props.showDropdownChanged) {
                  this.props.showDropdownChanged(this.state.showDropdown);
                }
              }
            }
          }, {
            key: 'render',
            value: function render() {
              var _this2 = this;

              var _props = this.props,
                  disabled = _props.disabled,
                  readOnly = _props.readOnly,
                  mode = _props.mode,
                  texts = _props.texts;
              var _state = this.state,
                  showDropdown = _state.showDropdown,
                  currentFocus = _state.currentFocus,
                  tags = _state.tags;
              var activeDescendant = currentFocus ? currentFocus + '_li' : undefined;
              var commonProps = {
                disabled: disabled,
                readOnly: readOnly,
                activeDescendant: activeDescendant,
                texts: texts,
                mode: mode,
                clientId: this.clientId
              };
              return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
                id: this.clientId,
                className: cx(this.props.className, 'react-dropdown-tree-select'),
                ref: function ref(node) {
                  _this2.node = node;
                }
              }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', {
                className: cx('dropdown', {
                  'simple-select': mode === 'simpleSelect'
                }, {
                  'radio-select': mode === 'radioSelect'
                })
              }, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_trigger__WEBPACK_IMPORTED_MODULE_5__["default"], _extends({
                onTrigger: this.onTrigger,
                showDropdown: showDropdown
              }, commonProps, {
                tags: tags
              }), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_input__WEBPACK_IMPORTED_MODULE_4__["default"], _extends({
                inputRef: this.searchInput,
                tags: tags,
                onInputChange: this.onInputChange,
                onFocus: this.onInputFocus,
                onBlur: this.onInputBlur,
                onTagRemove: this.onTagRemove,
                onKeyDown: this.onKeyboardKeyDown,
                enforceSingleSelection: this.props.enforceSingleSelection,
                value: this.props.value
              }, commonProps))), showDropdown && react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('div', _extends({
                className: cx('dropdown-content', this.state.dropUp ? 'drop-up' : '')
              }, this.getAriaAttributes(), {
                ref: function ref(inst) {
                  return _this2.selectInst = inst;
                }
              }), this.state.allNodesHidden ? react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('span', {
                className: 'no-matches'
              }, texts.noMatches || 'No matches found') : react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_tree__WEBPACK_IMPORTED_MODULE_6__["default"], _extends({
                data: this.state.tree,
                keepTreeOnSearch: this.props.keepTreeOnSearch,
                keepChildrenOnSearch: this.props.keepChildrenOnSearch,
                searchModeOn: this.state.searchModeOn,
                onAction: this.onAction,
                onCheckboxChange: this.onCheckboxChange,
                onNodeToggle: this.onNodeToggle,
                mode: mode,
                showPartiallySelected: this.props.showPartiallySelected,
                searchInput: this.state.searchInput,
                prependElement: this.props.prependElement,
                highlightSearch: this.props.highlightSearch,
                onChange: this.props.onChange,
                onNodeHover: this.props.onNodeHover,
                onNodeNavigate: this.props.onNodeNavigate,
                scrollHeight: this.props.scrollHeight,
                scrollToElement: this.state.scrollToElement,
                onBlur: this.props.onBlur
              }, commonProps)))));
            }
          }]);

          return DropdownTreeSelect;
        }(react__WEBPACK_IMPORTED_MODULE_2__["Component"]);

        DropdownTreeSelect.propTypes = {
          data: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array]).isRequired,
          clearSearchOnChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          keepTreeOnSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          keepChildrenOnSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          keepOpenOnSelect: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          texts: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.shape({
            placeholder: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            noMatches: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
            labelRemove: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
          }),
          showDropdown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['default', 'initial', 'always']),
          className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onAction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onNodeToggle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          mode: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['multiSelect', 'simpleSelect', 'radioSelect', 'hierarchical']),
          showPartiallySelected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          searchPredicate: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          prependElement: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
          highlightSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onNodeHover: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          scrollHeight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
          enforceSingleSelection: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          onInputChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          autoDetermineDropUp: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onDropUpPositionChanged: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          showDropdownChanged: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
        };
        DropdownTreeSelect.defaultProps = {
          onFocus: function onFocus() {},
          onBlur: function onBlur() {},
          onChange: function onChange() {},
          texts: {},
          showDropdown: 'default'
        };
        var DropdownTreeSelectMemoized = Object(react__WEBPACK_IMPORTED_MODULE_2__["memo"])(DropdownTreeSelect);
        /* harmony default export */

        __webpack_exports__["default"] = DropdownTreeSelectMemoized;
        /***/
      },

      /***/
      "./src/input/index.css":
      /*!*****************************!*\
        !*** ./src/input/index.css ***!
        \*****************************/

      /*! no static exports found */

      /***/
      function srcInputIndexCss(module, exports, __webpack_require__) {// extracted by mini-css-extract-plugin

        /***/
      },

      /***/
      "./src/input/index.js":
      /*!****************************!*\
        !*** ./src/input/index.js ***!
        \****************************/

      /*! exports provided: default */

      /***/
      function srcInputIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! classnames/bind */
        "./node_modules/classnames/bind.js");
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _tag__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../tag */
        "./src/tag/index.js");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./index.css */
        "./src/input/index.css");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_4___default =
        /*#__PURE__*/
        __webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_4__);
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../utils */
        "./src/utils/index.js");
        /* harmony import */


        var _a11y__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ../a11y */
        "./src/a11y/index.js");

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default.a.bind(_index_css__WEBPACK_IMPORTED_MODULE_4___default.a);

        var getTags = function getTags() {
          var tags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
          var onDelete = arguments[1];
          var readOnly = arguments[2];
          var disabled = arguments[3];
          var labelRemove = arguments[4];
          return tags.map(function (tag) {
            var _id = tag._id,
                label = tag.label,
                tagClassName = tag.tagClassName,
                dataset = tag.dataset;
            return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('li', _extends({
              className: cx('tag-item', tagClassName),
              key: 'tag-item-' + _id
            }, Object(_utils__WEBPACK_IMPORTED_MODULE_5__["getDataset"])(dataset)), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_tag__WEBPACK_IMPORTED_MODULE_3__["default"], {
              label: label,
              id: _id,
              onDelete: onDelete,
              readOnly: readOnly,
              disabled: disabled,
              labelRemove: labelRemove
            }));
          });
        };

        var Input = function (_Component) {
          _inherits(Input, _Component);

          function Input(props) {
            _classCallCheck(this, Input);

            var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

            _this.handleInputChange = function (e) {
              e.persist();

              if (_this._mounting) {
                return;
              }

              if (_this.state.value !== e.target.value) {
                _this.setState({
                  value: e.target.value
                });
              }
            };

            _this.onPaste = function (e) {
              e.persist();
              var scope = _this;
              setTimeout(function () {
                scope.props.onInputChange(e.target.value);
              }, 100);
            };

            _this.delayedCallback = Object(_utils__WEBPACK_IMPORTED_MODULE_5__["debounce"])(function (value) {
              return _this.props.onInputChange(value);
            }, 10);
            _this._handleInputChangeBinding = _this.handleInputChange.bind(_this);
            _this.state = {
              value: ''
            };
            _this._mounting = true;
            return _this;
          }

          _createClass(Input, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
              this._mounting = false;

              if (this.props.value) {
                this.setState({
                  value: this.props.value
                });
              }
            }
          }, {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(prevProps, prevState) {
              if (this.props.value !== prevProps.value) {
                this.setState({
                  value: this.props.value
                });
              }

              if (this.state.value !== prevState.value && prevState.value !== '') {
                if (this._mounting) {
                  return;
                }

                if (this.state.value !== this.props.value) {
                  this.delayedCallback(this.state.value);
                }
              }
            }
          }, {
            key: 'render',
            value: function render() {
              var _props = this.props,
                  tags = _props.tags,
                  onTagRemove = _props.onTagRemove,
                  inputRef = _props.inputRef,
                  _props$texts = _props.texts,
                  texts = _props$texts === undefined ? {} : _props$texts,
                  onFocus = _props.onFocus,
                  onBlur = _props.onBlur,
                  disabled = _props.disabled,
                  readOnly = _props.readOnly,
                  onKeyDown = _props.onKeyDown,
                  activeDescendant = _props.activeDescendant;
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('ul', {
                className: cx('tag-list')
              }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('li', {
                className: cx('tag-item', 'tag-input')
              }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('input', _extends({
                type: 'text',
                disabled: disabled,
                ref: inputRef,
                className: cx('search'),
                placeholder: texts.placeholder || '',
                onKeyDown: onKeyDown,
                onChange: this._handleInputChangeBinding,
                onFocus: onFocus,
                onBlur: onBlur,
                readOnly: readOnly,
                'aria-activedescendant': activeDescendant,
                'aria-autocomplete': onKeyDown ? 'list' : undefined
              }, Object(_a11y__WEBPACK_IMPORTED_MODULE_6__["getAriaLabel"])(texts.label), {
                value: this.state.value,
                onPaste: this.onPaste
              }))));
            }
          }]);

          return Input;
        }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);

        Input.propTypes = {
          tags: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array,
          texts: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
          onInputChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onFocus: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onTagRemove: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onKeyDown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          inputRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          activeDescendant: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
        };
        /* harmony default export */

        __webpack_exports__["default"] = Input;
        /***/
      },

      /***/
      "./src/radio/index.js":
      /*!****************************!*\
        !*** ./src/radio/index.js ***!
        \****************************/

      /*! exports provided: refUpdater, default */

      /***/
      function srcRadioIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "refUpdater", function () {
          return refUpdater;
        });
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _objectWithoutProperties(obj, keys) {
          var target = {};

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }

          return target;
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var refUpdater = function refUpdater(_ref) {
          var checked = _ref.checked;
          return function (input) {
            if (input) {
              input.checked = checked;
            }
          };
        };

        var RadioButton = function (_PureComponent) {
          _inherits(RadioButton, _PureComponent);

          function RadioButton() {
            _classCallCheck(this, RadioButton);

            return _possibleConstructorReturn(this, (RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).apply(this, arguments));
          }

          _createClass(RadioButton, [{
            key: 'render',
            value: function render() {
              var _props = this.props,
                  name = _props.name,
                  checked = _props.checked,
                  onChange = _props.onChange,
                  disabled = _props.disabled,
                  readOnly = _props.readOnly,
                  rest = _objectWithoutProperties(_props, ['name', 'checked', 'onChange', 'disabled', 'readOnly']);

              var isDisabled = disabled || readOnly;
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('input', _extends({
                type: 'radio',
                name: name,
                ref: refUpdater({
                  checked: checked
                }),
                onChange: onChange,
                disabled: isDisabled
              }, rest));
            }
          }]);

          return RadioButton;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);

        RadioButton.propTypes = {
          name: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          checked: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
        };
        /* harmony default export */

        __webpack_exports__["default"] = RadioButton;
        /***/
      },

      /***/
      "./src/tag/index.css":
      /*!***************************!*\
        !*** ./src/tag/index.css ***!
        \***************************/

      /*! no static exports found */

      /***/
      function srcTagIndexCss(module, exports, __webpack_require__) {// extracted by mini-css-extract-plugin

        /***/
      },

      /***/
      "./src/tag/index.js":
      /*!**************************!*\
        !*** ./src/tag/index.js ***!
        \**************************/

      /*! exports provided: getTagId, default */

      /***/
      function srcTagIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "getTagId", function () {
          return getTagId;
        });
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! classnames/bind */
        "./node_modules/classnames/bind.js");
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./index.css */
        "./src/tag/index.css");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_3__);

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default.a.bind(_index_css__WEBPACK_IMPORTED_MODULE_3___default.a);

        var getTagId = function getTagId(id) {
          return id + '_tag';
        };

        var Tag = function (_PureComponent) {
          _inherits(Tag, _PureComponent);

          function Tag() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, Tag);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Tag.__proto__ || Object.getPrototypeOf(Tag)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function (e) {
              var _this$props = _this.props,
                  id = _this$props.id,
                  onDelete = _this$props.onDelete;
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
              onDelete(id, (e.key || e.keyCode) !== undefined);
            }, _this.onKeyDown = function (e) {
              if (e.key === 'Backspace') {
                _this.handleClick(e);

                e.preventDefault();
              }
            }, _this.onKeyUp = function (e) {
              if (e.keyCode === 32 || ['Delete', 'Enter'].indexOf(e.key) > -1) {
                _this.handleClick(e);

                e.preventDefault();
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }

          _createClass(Tag, [{
            key: 'render',
            value: function render() {
              var _props = this.props,
                  id = _props.id,
                  label = _props.label,
                  _props$labelRemove = _props.labelRemove,
                  labelRemove = _props$labelRemove === undefined ? 'Remove' : _props$labelRemove,
                  readOnly = _props.readOnly,
                  disabled = _props.disabled;
              var tagId = getTagId(id);
              var buttonId = id + '_button';
              var className = cx('tag-remove', {
                readOnly: readOnly
              }, {
                disabled: disabled
              });
              var isDisabled = readOnly || disabled;
              return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('span', {
                className: cx('tag'),
                id: tagId,
                'aria-label': label
              }, label, react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('button', {
                id: buttonId,
                onClick: !isDisabled ? this.handleClick : undefined,
                onKeyDown: !isDisabled ? this.onKeyDown : undefined,
                onKeyUp: !isDisabled ? this.onKeyUp : undefined,
                className: className,
                type: 'button',
                'aria-label': labelRemove,
                'aria-labelledby': buttonId + ' ' + tagId,
                'aria-disabled': isDisabled
              }, 'x'));
            }
          }]);

          return Tag;
        }(react__WEBPACK_IMPORTED_MODULE_2__["PureComponent"]);

        Tag.propTypes = {
          id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          onDelete: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          labelRemove: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
        };
        /* harmony default export */

        __webpack_exports__["default"] = Tag;
        /***/
      },

      /***/
      "./src/tree-manager/flatten-tree.js":
      /*!******************************************!*\
        !*** ./src/tree-manager/flatten-tree.js ***!
        \******************************************/

      /*! exports provided: default */

      /***/
      function srcTreeManagerFlattenTreeJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _getPartialState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./getPartialState */
        "./src/tree-manager/getPartialState.js");
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../utils */
        "./src/utils/index.js");
        /**
         * Converts a nested node into an associative array with pointers to child and parent nodes
         * Given:
        ```
        const tree = [
          {
            label: 'item1',
            value: 'value1',
            children: [
              {
                label: 'item1-1',
                value: 'value1-1',
                children: [
                  {
                    label: 'item1-1-1',
                    value: 'value1-1-1'
                  },
                  {
                    label: 'item1-1-2',
                    value: 'value1-1-2'
                  }
                ]
              },
              {
                label: 'item1-2',
                value: 'value1-2'
              }
            ]
          },
          {
            label: 'item2',
            value: 'value2',
            children: [
              {
                label: 'item2-1',
                value: 'value2-1',
                children: [
                  {
                    label: 'item2-1-1',
                    value: 'value2-1-1'
                  },
                  {
                    label: 'item2-1-2',
                    value: 'value2-1-2'
                  },
                  {
                    label: 'item2-1-3',
                    value: 'item2-1-3',
                    children: [
                      {
                        label: 'item2-1-3-1',
                        value: 'value2-1-3-1'
                      }
                    ]
                  }
                ]
              },
              {
                label: 'item2-2',
                value: 'value2-2'
              }
            ]
          }
        ]
        ```
         * results in
        ```
        {
          "0": {
            _id: "0",
            _parent: null,
            _children: [
              "0-0",
              "0-1"
            ],
            label: "item1",
            value: "value1"
          },
          "1": {
            _id: "1",
            _parent: null,
            _children: [
              "1-0",
              "1-1"
            ],
            label: "item2",
            value: "value2"
          },
          "0-0": {
            _id: "0-0",
            _parent: "0",
            _children: [
              "0-0-0",
              "0-0-1"
            ],
            label: "item1-1",
            value: "value1-1"
          },
          "0-1": {
            _id: "0-1",
            _parent: "0",
            label: "item1-2",
            value: "value1-2"
          },
          "0-0-0": {
            _id: "0-0-0",
            _parent: "0-0",
            label: "item1-1-1",
            value: "value1-1-1"
          },
          "0-0-1": {
            _id: "0-0-1",
            _parent: "0-0",
            label: "item1-1-2",
            value: "value1-1-2"
          },
          "1-0": {
            _id: "1-0",
            _parent: "1",
            _children: [
              "1-0-0",
              "1-0-1",
              "1-0-2"
            ],
            label: "item2-1",
            value: "value2-1"
          },
          "1-1": {
            _id: "1-1",
            _parent: "1",
            label: "item2-2",
            value: "value2-2"
          },
          "1-0-0": {
            _id: "1-0-0",
            _parent: "1-0",
            label: "item2-1-1",
            value: "value2-1-1"
          },
          "1-0-1": {
            _id: "1-0-1",
            _parent: "1-0",
            label: "item2-1-2",
            value: "value2-1-2"
          },
          "1-0-2": {
            _id: "1-0-2",
            _parent: "1-0",
            _children: [
              "1-0-2-0"
            ],
            label: "item2-1-3",
            value: "value2-1-3"
          },
          "1-0-2-0": {
            _id: "1-0-2-0",
            _parent: "1-0-2",
            label: "item2-1-3-1",
            value: "value2-1-3-1"
          }
        }
        ```
         * @param  {[type]} tree              The incoming tree object
         * @param  {[bool]} simple            Whether its in Single select mode (simple dropdown)
         * @param  {[bool]} radio             Whether its in Radio select mode (radio dropdown)
         * @param  {[bool]} showPartialState  Whether to show partially checked state
         * @param  {[string]} rootPrefixId    The prefix to use when setting root node ids
         * @return {object}                   The flattened list
         */


        function flattenTree(_ref) {
          var tree = _ref.tree,
              simple = _ref.simple,
              radio = _ref.radio,
              showPartialState = _ref.showPartialState,
              hierarchical = _ref.hierarchical,
              rootPrefixId = _ref.rootPrefixId;
          var forest = Array.isArray(tree) ? tree : [tree]; // eslint-disable-next-line no-use-before-define

          return walkNodes({
            nodes: forest,
            simple: simple,
            radio: radio,
            showPartialState: showPartialState,
            hierarchical: hierarchical,
            rootPrefixId: rootPrefixId
          });
        }
        /**
         * If the node didn't specify anything on its own
         * figure out the initial state based on parent
         * @param {object} node           [current node]
         * @param {object} parent         [node's immediate parent]
         * @param {bool}   inheritChecked [if checked should be inherited]
         */


        function setInitialStateProps(node) {
          var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
          var inheritChecked = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
          var stateProps = inheritChecked ? ['checked', 'disabled'] : ['disabled'];

          for (var index = 0; index < stateProps.length; index++) {
            var prop = stateProps[index]; // if and only if, node doesn't explicitly define a prop, grab it from parent

            if (node[prop] === undefined && parent[prop] !== undefined) {
              node[prop] = parent[prop];
            }
          }
        }

        function walkNodes(_ref2) {
          var nodes = _ref2.nodes,
              parent = _ref2.parent,
              _ref2$depth = _ref2.depth,
              depth = _ref2$depth === undefined ? 0 : _ref2$depth,
              simple = _ref2.simple,
              radio = _ref2.radio,
              showPartialState = _ref2.showPartialState,
              hierarchical = _ref2.hierarchical,
              rootPrefixId = _ref2.rootPrefixId,
              _ref2$_rv = _ref2._rv,
              _rv = _ref2$_rv === undefined ? {
            list: new Map(),
            defaultValues: [],
            singleSelectedNode: null
          } : _ref2$_rv;

          var single = simple || radio;
          nodes.forEach(function (node, i) {
            node._depth = depth;

            if (parent) {
              node._id = node.id || parent._id + '-' + i;
              node._parent = parent._id;

              parent._children.push(node._id);
            } else {
              node._id = node.id || '' + (rootPrefixId ? rootPrefixId + '-' + i : i);
            }

            if (single && node.checked) {
              if (_rv.singleSelectedNode) {
                node.checked = false;
              } else {
                _rv.singleSelectedNode = node;
              }
            }

            if (single && node.isDefaultValue && _rv.singleSelectedNode && !_rv.singleSelectedNode.isDefaultValue) {
              // Default value has precedence, uncheck previous value
              _rv.singleSelectedNode.checked = false;
              _rv.singleSelectedNode = null;
            }

            if (node.isDefaultValue && (!single || _rv.defaultValues.length === 0)) {
              _rv.defaultValues.push(node._id);

              node.checked = true;

              if (single) {
                _rv.singleSelectedNode = node;
              }
            }

            if (!hierarchical || radio) setInitialStateProps(node, parent, !radio);

            _rv.list.set(node._id, node);

            if (!simple && node.children) {
              node._children = [];
              walkNodes({
                nodes: node.children,
                parent: node,
                depth: depth + 1,
                radio: radio,
                showPartialState: showPartialState,
                hierarchical: hierarchical,
                _rv: _rv
              });

              if (showPartialState && !node.checked) {
                node.partial = Object(_getPartialState__WEBPACK_IMPORTED_MODULE_0__["default"])(node); // re-check if all children are checked. if so, check thyself

                if (!single && !Object(_utils__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(node.children) && node.children.every(function (c) {
                  return c.checked;
                })) {
                  node.checked = true;
                }
              }

              node.children = undefined;
            }
          });
          return _rv;
        }
        /* harmony default export */


        __webpack_exports__["default"] = flattenTree;
        /***/
      },

      /***/
      "./src/tree-manager/getPartialState.js":
      /*!*********************************************!*\
        !*** ./src/tree-manager/getPartialState.js ***!
        \*********************************************/

      /*! exports provided: default */

      /***/
      function srcTreeManagerGetPartialStateJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var array_partial__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! array.partial */
        "./node_modules/array.partial/index.js");
        /* harmony import */


        var array_partial__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(array_partial__WEBPACK_IMPORTED_MODULE_0__);

        var identity = function identity(c) {
          return c;
        };
        /* harmony default export */


        __webpack_exports__["default"] = function (node) {
          var childProp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
          var childSelector = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
          return array_partial__WEBPACK_IMPORTED_MODULE_0___default()(node[childProp], function (c) {
            return childSelector(c).checked;
          }) || node[childProp].some(function (c) {
            return childSelector(c).partial;
          });
        };
        /***/

      },

      /***/
      "./src/tree-manager/index.js":
      /*!***********************************!*\
        !*** ./src/tree-manager/index.js ***!
        \***********************************/

      /*! exports provided: default */

      /***/
      function srcTreeManagerIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _getPartialState__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./getPartialState */
        "./src/tree-manager/getPartialState.js");
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../utils */
        "./src/utils/index.js");
        /* harmony import */


        var _flatten_tree__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./flatten-tree */
        "./src/tree-manager/flatten-tree.js");
        /* harmony import */


        var _nodeVisitor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./nodeVisitor */
        "./src/tree-manager/nodeVisitor.js");
        /* harmony import */


        var _keyboardNavigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./keyboardNavigation */
        "./src/tree-manager/keyboardNavigation.js");

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        var TreeManager = function () {
          function TreeManager(_ref) {
            var data = _ref.data,
                mode = _ref.mode,
                showPartiallySelected = _ref.showPartiallySelected,
                rootPrefixId = _ref.rootPrefixId,
                searchPredicate = _ref.searchPredicate,
                enforceSingleSelection = _ref.enforceSingleSelection;

            _classCallCheck(this, TreeManager);

            this._src = data;
            this.simpleSelect = mode === 'simpleSelect';
            this.radioSelect = mode === 'radioSelect';
            this.hierarchical = mode === 'hierarchical';
            this.searchPredicate = searchPredicate;

            var _flattenTree = Object(_flatten_tree__WEBPACK_IMPORTED_MODULE_2__["default"])({
              tree: JSON.parse(JSON.stringify(data)),
              simple: this.simpleSelect,
              radio: this.radioSelect,
              showPartialState: showPartiallySelected,
              hierarchical: this.hierarchical,
              rootPrefixId: rootPrefixId
            }),
                list = _flattenTree.list,
                defaultValues = _flattenTree.defaultValues,
                singleSelectedNode = _flattenTree.singleSelectedNode;

            this.tree = list;
            this.defaultValues = defaultValues;
            this.showPartialState = !this.hierarchical && showPartiallySelected;
            this.searchMaps = new Map();

            if ((this.simpleSelect || this.radioSelect) && singleSelectedNode) {
              // Remembers initial check on single select dropdowns
              this.currentChecked = singleSelectedNode._id;
            }

            this.enforceSingleSelection = enforceSingleSelection;
          }

          _createClass(TreeManager, [{
            key: 'getNodeById',
            value: function getNodeById(id) {
              return this.tree.get(id);
            }
          }, {
            key: 'getMatches',
            value: function getMatches(searchTerm) {
              var _this = this;

              if (this.searchMaps.has(searchTerm)) {
                return this.searchMaps.get(searchTerm);
              }

              var proximity = -1;
              var closestMatch = searchTerm;
              this.searchMaps.forEach(function (m, key) {
                if (searchTerm.startsWith(key) && key.length > proximity) {
                  proximity = key.length;
                  closestMatch = key;
                }
              });
              var matches = [];

              var addOnMatch = this._getAddOnMatch(matches, searchTerm);

              if (closestMatch !== searchTerm) {
                var superMatches = this.searchMaps.get(closestMatch);
                superMatches.forEach(function (key) {
                  return addOnMatch(_this.getNodeById(key));
                });
              } else {
                this.tree.forEach(addOnMatch);
              }

              this.searchMaps.set(searchTerm, matches);
              return matches;
            }
          }, {
            key: 'addParentsToTree',
            value: function addParentsToTree(id, tree) {
              if (id !== undefined) {
                var node = this.getNodeById(id);
                this.addParentsToTree(node._parent, tree);
                node.hide = true;
                node.matchInChildren = true;
                tree.set(id, node);
              }
            }
          }, {
            key: 'addChildrenToTree',
            value: function addChildrenToTree(ids, tree, matches) {
              var _this2 = this;

              if (ids !== undefined) {
                ids.forEach(function (id) {
                  if (matches && matches.includes(id)) {
                    // if a child is found by search anyways, don't display it as a child here
                    return;
                  }

                  var node = _this2.getNodeById(id);

                  node.matchInParent = true;
                  tree.set(id, node);

                  _this2.addChildrenToTree(node._children, tree);
                });
              }
            }
          }, {
            key: 'filterTree',
            value: function filterTree(searchTerm, keepTreeOnSearch, keepChildrenOnSearch) {
              var _this3 = this;

              var matches = this.getMatches(searchTerm.toLowerCase());
              var matchTree = new Map();
              matches.forEach(function (m) {
                var node = _this3.getNodeById(m);

                node.hide = false;

                if (keepTreeOnSearch) {
                  // add parent nodes first or else the tree won't be rendered in correct hierarchy
                  _this3.addParentsToTree(node._parent, matchTree);
                }

                matchTree.set(m, node);

                if (keepTreeOnSearch && keepChildrenOnSearch) {
                  // add children nodes after a found match
                  _this3.addChildrenToTree(node._children, matchTree, matches);
                }
              });
              var allNodesHidden = matches.length === 0; // we store a local reference so that components can use it in subsequent renders
              // this is the least intrusive way of fixing #190

              this.matchTree = matchTree;
              return {
                allNodesHidden: allNodesHidden,
                tree: matchTree
              };
            }
          }, {
            key: 'restoreNodes',
            value: function restoreNodes() {
              this.tree.forEach(function (node) {
                node.hide = false;
              });
              return this.tree;
            }
          }, {
            key: 'restoreDefaultValues',
            value: function restoreDefaultValues() {
              var _this4 = this;

              this.defaultValues.forEach(function (id) {
                _this4.setNodeCheckedState(id, true);
              });
              return this.tree;
            }
          }, {
            key: 'togglePreviousChecked',
            value: function togglePreviousChecked(id, checked) {
              var prevChecked = this.currentChecked; // if id is same as previously selected node, then do nothing (since it's state is already set correctly by setNodeCheckedState)
              // but if they ar not same, then toggle the previous one

              if (prevChecked && prevChecked !== id) this.getNodeById(prevChecked).checked = false;
              this.currentChecked = checked ? id : null;
            }
          }, {
            key: 'setNodeCheckedState',
            value: function setNodeCheckedState(id, checked) {
              var node = this.getNodeById(id);
              node.checked = checked; // TODO: this can probably be combined with the same check in the else block. investigate in a separate release.

              if (this.showPartialState) {
                node.partial = false;
              }

              if (this.simpleSelect) {
                this.togglePreviousChecked(id, checked);
              } else if (this.radioSelect) {
                this.togglePreviousChecked(id, checked);

                if (this.showPartialState) {
                  this.partialCheckParents(node);
                }

                if (!checked) {
                  this.unCheckParents(node);
                }
              } else {
                if (!this.hierarchical) this.toggleChildren(id, checked);

                if (this.showPartialState) {
                  this.partialCheckParents(node);
                }

                if (!this.hierarchical && !checked) {
                  this.unCheckParents(node);
                }
              }
            }
            /**
             * Walks up the tree unchecking parent nodes
             * @param  {[type]} node [description]
             * @return {[type]}      [description]
             */

          }, {
            key: 'unCheckParents',
            value: function unCheckParents(node) {
              var parent = node._parent;

              while (parent) {
                var next = this.getNodeById(parent);
                next.checked = false;
                next.partial = Object(_getPartialState__WEBPACK_IMPORTED_MODULE_0__["default"])(next, '_children', this.getNodeById.bind(this));
                parent = next._parent;
              }
            }
            /**
             * Walks up the tree setting partial state on parent nodes
             * @param  {[type]} node [description]
             * @return {[type]}      [description]
             */

          }, {
            key: 'partialCheckParents',
            value: function partialCheckParents(node) {
              var _this5 = this;

              var parent = node._parent;

              while (parent) {
                var next = this.getNodeById(parent);
                next.checked = next._children.every(function (c) {
                  return _this5.getNodeById(c).checked;
                });
                next.partial = Object(_getPartialState__WEBPACK_IMPORTED_MODULE_0__["default"])(next, '_children', this.getNodeById.bind(this));
                parent = next._parent;
              }
            }
          }, {
            key: 'toggleChildren',
            value: function toggleChildren(id, state) {
              var _this6 = this;

              var node = this.getNodeById(id);
              node.checked = state;

              if (this.showPartialState) {
                node.partial = false;
              }

              if (!Object(_utils__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(node._children)) {
                node._children.forEach(function (id) {
                  return _this6.toggleChildren(id, state);
                });
              }
            }
          }, {
            key: 'toggleNodeExpandState',
            value: function toggleNodeExpandState(id) {
              var node = this.getNodeById(id);
              node.expanded = !node.expanded;
              if (!node.expanded) this.collapseChildren(node);
              return this.tree;
            }
          }, {
            key: 'collapseChildren',
            value: function collapseChildren(node) {
              var _this7 = this;

              node.expanded = false;

              if (!Object(_utils__WEBPACK_IMPORTED_MODULE_1__["isEmpty"])(node._children)) {
                node._children.forEach(function (c) {
                  return _this7.collapseChildren(_this7.getNodeById(c));
                });
              }
            }
          }, {
            key: 'getTreeAndTags',
            value: function getTreeAndTags() {
              return {
                tree: this.tree,
                tags: this.tags
              };
            }
          }, {
            key: 'handleNavigationKey',
            value: function handleNavigationKey(currentFocus, tree, key, readOnly, markSubTreeOnNonExpanded, onToggleChecked, onToggleExpanded) {
              var _this8 = this;

              var prevFocus = currentFocus && this.getNodeById(currentFocus);

              var getNodeById = function getNodeById(id) {
                return _this8.getNodeById(id);
              };

              var action = _keyboardNavigation__WEBPACK_IMPORTED_MODULE_4__["default"].getAction(prevFocus, key);

              if (_keyboardNavigation__WEBPACK_IMPORTED_MODULE_4__["FocusActionNames"].has(action)) {
                var newFocus = _keyboardNavigation__WEBPACK_IMPORTED_MODULE_4__["default"].handleFocusNavigationkey(tree, action, prevFocus, getNodeById, markSubTreeOnNonExpanded);

                return newFocus;
              }

              if (!prevFocus || !tree.has(prevFocus._id)) {
                // No current focus or not visible
                return currentFocus;
              }

              return _keyboardNavigation__WEBPACK_IMPORTED_MODULE_4__["default"].handleToggleNavigationkey(action, prevFocus, readOnly, onToggleChecked, onToggleExpanded);
            }
          }, {
            key: '_getAddOnMatch',
            value: function _getAddOnMatch(matches, searchTerm) {
              var isMatch = function isMatch(node, term) {
                return node.label.toLowerCase().indexOf(term) >= 0;
              };

              if (typeof this.searchPredicate === 'function') {
                isMatch = this.searchPredicate;
              }

              return function (node) {
                if (isMatch(node, searchTerm)) {
                  matches.push(node._id);
                }
              };
            }
          }, {
            key: 'tags',
            get: function get() {
              var _this9 = this;

              if (this.radioSelect || this.simpleSelect) {
                if (this.currentChecked) {
                  return [this.getNodeById(this.currentChecked)];
                }

                return [];
              }

              var nodesMatching = _nodeVisitor__WEBPACK_IMPORTED_MODULE_3__["default"].getNodesMatching(this.tree, function (node, key, visited) {
                if (node.checked && !_this9.hierarchical) {
                  // Parent node, so no need to walk children
                  _nodeVisitor__WEBPACK_IMPORTED_MODULE_3__["default"].markSubTreeVisited(node, visited, function (id) {
                    return _this9.getNodeById(id);
                  });
                }

                return node.checked;
              });

              if (this.enforceSingleSelection) nodesMatching = nodesMatching.length ? [nodesMatching[nodesMatching.length - 1]] : [];
              return nodesMatching;
            }
          }]);

          return TreeManager;
        }();
        /* harmony default export */


        __webpack_exports__["default"] = TreeManager;
        /***/
      },

      /***/
      "./src/tree-manager/keyboardNavigation.js":
      /*!************************************************!*\
        !*** ./src/tree-manager/keyboardNavigation.js ***!
        \************************************************/

      /*! exports provided: NavActions, FocusActionNames, default */

      /***/
      function srcTreeManagerKeyboardNavigationJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "NavActions", function () {
          return NavActions;
        });
        /* harmony export (binding) */


        __webpack_require__.d(__webpack_exports__, "FocusActionNames", function () {
          return FocusActionNames;
        });
        /* harmony import */


        var _nodeVisitor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./nodeVisitor */
        "./src/tree-manager/nodeVisitor.js");
        /* harmony import */


        var _tag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ../tag */
        "./src/tag/index.js");

        var _slicedToArray = function () {
          function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;

            try {
              for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);

                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i["return"]) _i["return"]();
              } finally {
                if (_d) throw _e;
              }
            }

            return _arr;
          }

          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr;
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i);
            } else {
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            }
          };
        }();

        var Keys = {
          Up: 'ArrowUp',
          Down: 'ArrowDown',
          Left: 'ArrowLeft',
          Right: 'ArrowRight',
          Enter: 'Enter',
          Home: 'Home',
          PageUp: 'PageUp',
          End: 'End',
          PageDown: 'PageDown'
        };
        var NavActions = {
          None: 'None',
          FocusPrevious: 'FocusPrevious',
          FocusNext: 'FocusNext',
          FocusParent: 'FocusParent',
          FocusFirst: 'FocusFirst',
          FocusLast: 'FocusLast',
          ToggleExpanded: 'ToggleExpanded',
          ToggleChecked: 'ToggleChecked'
        };
        var FocusActionNames = new Set([NavActions.FocusPrevious, NavActions.FocusNext, NavActions.FocusParent, NavActions.FocusFirst, NavActions.FocusLast]);
        var validTriggerOpenKeys = [Keys.Up, Keys.Down, Keys.Home, Keys.PageUp, Keys.End, Keys.PageDown];
        var validKeys = validTriggerOpenKeys.concat([Keys.Left, Keys.Right, Keys.Enter]);

        var isValidKey = function isValidKey(key, isOpen) {
          var keysToCheck = isOpen ? validKeys : validTriggerOpenKeys;
          return keysToCheck.indexOf(key) > -1;
        };

        var isMatchingEvent = function isMatchingEvent(key, keys, currentFocus, nonFocusKey) {
          return keys.indexOf(key) > -1 || !currentFocus && key === nonFocusKey;
        };

        var isFocusFirstEvent = function isFocusFirstEvent(key, currentFocus) {
          return isMatchingEvent(key, [Keys.Home, Keys.PageUp], currentFocus, Keys.Down);
        };

        var isFocusLastEvent = function isFocusLastEvent(key, currentFocus) {
          return isMatchingEvent(key, [Keys.End, Keys.PageDown], currentFocus, Keys.Up);
        };

        var isReverseTraverseAction = function isReverseTraverseAction(action) {
          return isMatchingEvent(action, [NavActions.FocusPrevious, NavActions.FocusLast], true);
        };

        var isEdgeTraverseAction = function isEdgeTraverseAction(action) {
          return isMatchingEvent(action, [NavActions.FocusFirst, NavActions.FocusLast], true);
        };

        var getLeftNavAction = function getLeftNavAction(currentFocus, key) {
          if (!currentFocus || key !== Keys.Left) return NavActions.None;

          if (currentFocus.expanded === true) {
            return NavActions.ToggleExpanded;
          }

          if (currentFocus._parent) {
            return NavActions.FocusParent;
          }

          return NavActions.None;
        };

        var getRightNavAction = function getRightNavAction(currentFocus, key) {
          if (!currentFocus || !currentFocus._children || key !== Keys.Right) {
            return NavActions.None;
          }

          return currentFocus.expanded !== true ? NavActions.ToggleExpanded : NavActions.FocusNext;
        };

        var getRelativeAction = function getRelativeAction(currentFocus, key) {
          if (!currentFocus) return NavActions.None;

          switch (key) {
            case Keys.Up:
              return NavActions.FocusPrevious;

            case Keys.Down:
              return NavActions.FocusNext;

            case Keys.Enter:
              return NavActions.ToggleChecked;

            default:
              return NavActions.None;
          }
        };

        var getAction = function getAction(currentFocus, key) {
          var action = void 0;

          if (key === Keys.Left) {
            action = getLeftNavAction(currentFocus, key);
          } else if (key === Keys.Right) {
            action = getRightNavAction(currentFocus, key);
          } else if (isFocusFirstEvent(key, currentFocus)) {
            action = NavActions.FocusFirst;
          } else if (isFocusLastEvent(key, currentFocus)) {
            action = NavActions.FocusLast;
          } else {
            action = getRelativeAction(currentFocus, key);
          }

          return action;
        };

        var getParentFocus = function getParentFocus(prevFocus, getNodeById) {
          return prevFocus && prevFocus._parent ? getNodeById(prevFocus._parent) : prevFocus;
        };

        var getRelativeNeighborsFocus = function getRelativeNeighborsFocus(sortedNodes, prevFocus) {
          var nextIndex = sortedNodes.indexOf(prevFocus) + 1;

          if (nextIndex % sortedNodes.length === 0) {
            return sortedNodes[0];
          }

          return sortedNodes[nextIndex];
        };

        var getRelativeFocus = function getRelativeFocus(sortedNodes, prevFocus, action) {
          if (!sortedNodes || sortedNodes.length === 0) {
            return prevFocus;
          }

          var focus = prevFocus;

          if (isEdgeTraverseAction(action)) {
            ;

            var _sortedNodes = _slicedToArray(sortedNodes, 1);

            focus = _sortedNodes[0];
          } else if ([NavActions.FocusPrevious, NavActions.FocusNext].indexOf(action) > -1) {
            focus = getRelativeNeighborsFocus(sortedNodes, prevFocus);
          }

          return focus;
        };

        var getNextFocus = function getNextFocus(tree, prevFocus, action, getNodeById, markSubTreeOnNonExpanded) {
          if (action === NavActions.FocusParent) {
            return getParentFocus(prevFocus, getNodeById);
          }

          if (!FocusActionNames.has(action)) {
            return prevFocus;
          }

          var nodes = _nodeVisitor__WEBPACK_IMPORTED_MODULE_0__["default"].getVisibleNodes(tree, getNodeById, markSubTreeOnNonExpanded);

          if (isReverseTraverseAction(action)) {
            nodes = nodes.reverse();
          }

          return getRelativeFocus(nodes, prevFocus, action);
        };

        var getNextFocusAfterTagDelete = function getNextFocusAfterTagDelete(deletedId, prevTags, tags, fallback) {
          // Sets new focus to next tag or returns fallback
          var index = prevTags && prevTags.findIndex(function (t) {
            return t._id === deletedId;
          });
          if (index < 0 || !tags.length) return fallback;
          index = tags.length > index ? index : tags.length - 1;
          var newFocusId = tags[index]._id;
          var focusNode = document.getElementById(Object(_tag__WEBPACK_IMPORTED_MODULE_1__["getTagId"])(newFocusId));

          if (focusNode) {
            return focusNode.firstElementChild || fallback;
          }

          return fallback;
        };

        var handleFocusNavigationkey = function handleFocusNavigationkey(tree, action, prevFocus, getNodeById, markSubTreeOnNonExpanded) {
          var newFocus = keyboardNavigation.getNextFocus(tree, prevFocus, action, getNodeById, markSubTreeOnNonExpanded);

          if (prevFocus && newFocus && prevFocus._id !== newFocus._id) {
            prevFocus._focused = false;
          }

          if (newFocus) {
            newFocus._focused = true;
            return newFocus._id;
          }

          return prevFocus && prevFocus._id;
        };

        var handleToggleNavigationkey = function handleToggleNavigationkey(action, prevFocus, readOnly, onToggleChecked, onToggleExpanded) {
          if (action === NavActions.ToggleChecked && !readOnly && !(prevFocus.readOnly || prevFocus.disabled)) {
            onToggleChecked(prevFocus._id, prevFocus.checked !== true);
          } else if (action === NavActions.ToggleExpanded) {
            onToggleExpanded(prevFocus._id);
          }

          return prevFocus && prevFocus._id;
        };

        var keyboardNavigation = {
          isValidKey: isValidKey,
          getAction: getAction,
          getNextFocus: getNextFocus,
          getNextFocusAfterTagDelete: getNextFocusAfterTagDelete,
          handleFocusNavigationkey: handleFocusNavigationkey,
          handleToggleNavigationkey: handleToggleNavigationkey
        };
        /* harmony default export */

        __webpack_exports__["default"] = keyboardNavigation;
        /***/
      },

      /***/
      "./src/tree-manager/nodeVisitor.js":
      /*!*****************************************!*\
        !*** ./src/tree-manager/nodeVisitor.js ***!
        \*****************************************/

      /*! exports provided: default */

      /***/
      function srcTreeManagerNodeVisitorJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ../utils */
        "./src/utils/index.js");

        var markSubTreeVisited = function markSubTreeVisited(node, visited, getItemById) {
          visited[node._id] = true;

          if (!Object(_utils__WEBPACK_IMPORTED_MODULE_0__["isEmpty"])(node._children)) {
            node._children.forEach(function (c) {
              return markSubTreeVisited(getItemById(c), visited, getItemById);
            });
          }
        };

        var getNodesMatching = function getNodesMatching(tree, nodePredicate) {
          var nodes = [];
          var visited = {};
          tree.forEach(function (node, key) {
            if (visited[key]) return;

            if (nodePredicate(node, key, visited)) {
              nodes.push(node);
            }

            visited[key] = true;
          });
          return nodes;
        };

        var getVisibleNodes = function getVisibleNodes(tree, getItemById, markSubTreeOnNonExpanded) {
          return getNodesMatching(tree, function (node, key, visited) {
            if (markSubTreeOnNonExpanded && node._children && node._children.length && node.expanded !== true) {
              markSubTreeVisited(node, visited, getItemById);
            }

            return !node.hide;
          });
        };

        var nodeVisitor = {
          getNodesMatching: getNodesMatching,
          getVisibleNodes: getVisibleNodes,
          markSubTreeVisited: markSubTreeVisited
        };
        /* harmony default export */

        __webpack_exports__["default"] = nodeVisitor;
        /***/
      },

      /***/
      "./src/tree-node/action.js":
      /*!*********************************!*\
        !*** ./src/tree-node/action.js ***!
        \*********************************/

      /*! exports provided: default */

      /***/
      function srcTreeNodeActionJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var Action = function (_PureComponent) {
          _inherits(Action, _PureComponent);

          function Action() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, Action);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Action.__proto__ || Object.getPrototypeOf(Action)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
              var _this$props = _this.props,
                  onAction = _this$props.onAction,
                  actionData = _this$props.actionData;

              if (onAction) {
                onAction(actionData.nodeId, actionData.action);
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }

          _createClass(Action, [{
            key: 'render',
            value: function render() {
              var _props = this.props,
                  title = _props.title,
                  className = _props.className,
                  text = _props.text,
                  readOnly = _props.readOnly;
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('i', {
                title: title,
                className: className,
                onClick: !readOnly ? this.handleClick : undefined
              }, text);
            }
          }]);

          return Action;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);

        Action.propTypes = {
          title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          text: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          actionData: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
          onAction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
        };
        Action.defaultProps = {
          onAction: function onAction() {}
        };
        /* harmony default export */

        __webpack_exports__["default"] = Action;
        /***/
      },

      /***/
      "./src/tree-node/actions.js":
      /*!**********************************!*\
        !*** ./src/tree-node/actions.js ***!
        \**********************************/

      /*! exports provided: default */

      /***/
      function srcTreeNodeActionsJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var _action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./action */
        "./src/tree-node/action.js");
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../utils */
        "./src/utils/index.js");

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _objectWithoutProperties(obj, keys) {
          var target = {};

          for (var i in obj) {
            if (keys.indexOf(i) >= 0) continue;
            if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
            target[i] = obj[i];
          }

          return target;
        }

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var Actions = function (_PureComponent) {
          _inherits(Actions, _PureComponent);

          function Actions() {
            _classCallCheck(this, Actions);

            return _possibleConstructorReturn(this, (Actions.__proto__ || Object.getPrototypeOf(Actions)).apply(this, arguments));
          }

          _createClass(Actions, [{
            key: 'render',
            value: function render() {
              var _props = this.props,
                  actions = _props.actions,
                  id = _props.id,
                  rest = _objectWithoutProperties(_props, ['actions', 'id']);

              if (Object(_utils__WEBPACK_IMPORTED_MODULE_3__["isEmpty"])(actions)) return null;
              return actions.map(function (a, idx) {
                var actionId = a.id || 'action-' + idx;
                return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_action__WEBPACK_IMPORTED_MODULE_2__["default"], _extends({
                  key: actionId
                }, rest, a, {
                  actionData: {
                    action: _extends({}, a, {
                      id: actionId
                    }),
                    nodeId: id
                  }
                }));
              });
            }
          }]);

          return Actions;
        }(react__WEBPACK_IMPORTED_MODULE_1__["PureComponent"]);

        Actions.propTypes = {
          id: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string.isRequired,
          actions: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.array
        };
        /* harmony default export */

        __webpack_exports__["default"] = Actions;
        /***/
      },

      /***/
      "./src/tree-node/index.css":
      /*!*********************************!*\
        !*** ./src/tree-node/index.css ***!
        \*********************************/

      /*! no static exports found */

      /***/
      function srcTreeNodeIndexCss(module, exports, __webpack_require__) {// extracted by mini-css-extract-plugin

        /***/
      },

      /***/
      "./src/tree-node/index.js":
      /*!********************************!*\
        !*** ./src/tree-node/index.js ***!
        \********************************/

      /*! exports provided: default */

      /***/
      function srcTreeNodeIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! classnames/bind */
        "./node_modules/classnames/bind.js");
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../utils */
        "./src/utils/index.js");
        /* harmony import */


        var _actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./actions */
        "./src/tree-node/actions.js");
        /* harmony import */


        var _node_label__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./node-label */
        "./src/tree-node/node-label.js");
        /* harmony import */


        var _toggle__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(
        /*! ./toggle */
        "./src/tree-node/toggle.js");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(
        /*! ./index.css */
        "./src/tree-node/index.css");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_7___default =
        /*#__PURE__*/
        __webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_7__);

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default.a.bind(_index_css__WEBPACK_IMPORTED_MODULE_7___default.a);

        var isLeaf = function isLeaf(children) {
          return Object(_utils__WEBPACK_IMPORTED_MODULE_3__["isEmpty"])(children);
        };

        var getNodeCx = function getNodeCx(props) {
          var keepTreeOnSearch = props.keepTreeOnSearch,
              keepChildrenOnSearch = props.keepChildrenOnSearch,
              _children = props._children,
              matchInChildren = props.matchInChildren,
              matchInParent = props.matchInParent,
              disabled = props.disabled,
              partial = props.partial,
              hide = props.hide,
              className = props.className,
              showPartiallySelected = props.showPartiallySelected,
              readOnly = props.readOnly,
              checked = props.checked,
              focused = props._focused;
          return cx('node', {
            leaf: isLeaf(_children),
            tree: !isLeaf(_children),
            disabled: disabled,
            hide: hide,
            'match-in-children': keepTreeOnSearch && matchInChildren,
            'match-in-parent': keepTreeOnSearch && keepChildrenOnSearch && matchInParent,
            partial: showPartiallySelected && partial,
            readOnly: readOnly,
            checked: checked,
            focused: focused
          }, className);
        };

        var TreeNode = function (_PureComponent) {
          _inherits(TreeNode, _PureComponent);

          function TreeNode() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, TreeNode);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TreeNode.__proto__ || Object.getPrototypeOf(TreeNode)).call.apply(_ref, [this].concat(args))), _this), _this.getAriaAttributes = function () {
              var _this$props = _this.props,
                  _children = _this$props._children,
                  _depth = _this$props._depth,
                  checked = _this$props.checked,
                  disabled = _this$props.disabled,
                  expanded = _this$props.expanded,
                  readOnly = _this$props.readOnly,
                  mode = _this$props.mode,
                  partial = _this$props.partial;
              var attributes = {};
              attributes.role = mode === 'simpleSelect' ? 'option' : 'treeitem';
              attributes['aria-disabled'] = disabled || readOnly;
              attributes['aria-selected'] = checked;

              if (mode !== 'simpleSelect') {
                attributes['aria-checked'] = partial ? 'mixed' : checked;
                attributes['aria-level'] = (_depth || 0) + 1;
                attributes['aria-expanded'] = _children && (expanded ? 'true' : 'false');
              }

              return attributes;
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }

          _createClass(TreeNode, [{
            key: 'render',
            value: function render() {
              var _this2 = this;

              var _props = this.props,
                  mode = _props.mode,
                  keepTreeOnSearch = _props.keepTreeOnSearch,
                  _id = _props._id,
                  _children = _props._children,
                  dataset = _props.dataset,
                  _depth = _props._depth,
                  expanded = _props.expanded,
                  title = _props.title,
                  label = _props.label,
                  partial = _props.partial,
                  checked = _props.checked,
                  value = _props.value,
                  disabled = _props.disabled,
                  actions = _props.actions,
                  onAction = _props.onAction,
                  searchModeOn = _props.searchModeOn,
                  onNodeToggle = _props.onNodeToggle,
                  onChange = _props.onChange,
                  onCheckboxChange = _props.onCheckboxChange,
                  showPartiallySelected = _props.showPartiallySelected,
                  readOnly = _props.readOnly,
                  clientId = _props.clientId;
              var liCx = getNodeCx(this.props);
              var style = keepTreeOnSearch || !searchModeOn ? {
                paddingLeft: (_depth || 0) * 20 + 'px'
              } : {};
              var liId = _id + '_li';
              var nodeData = {
                title: title,
                label: label,
                checked: checked,
                value: value
              };

              var onNodeHover = function onNodeHover(e, nodeData) {
                if (_this2.props.onNodeHover) _this2.props.onNodeHover(e, nodeData);
              };

              return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('li', _extends({
                className: liCx,
                style: style,
                id: liId
              }, Object(_utils__WEBPACK_IMPORTED_MODULE_3__["getDataset"])(dataset), this.getAriaAttributes(), {
                onMouseEnter: function onMouseEnter(e) {
                  return onNodeHover(e, nodeData);
                },
                onClick: function onClick() {
                  return onChange(nodeData);
                }
              }), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_node_label__WEBPACK_IMPORTED_MODULE_5__["default"], {
                title: title,
                label: label,
                id: _id,
                partial: partial,
                checked: checked,
                value: value,
                disabled: disabled,
                mode: mode,
                onCheckboxChange: onCheckboxChange,
                showPartiallySelected: showPartiallySelected,
                readOnly: readOnly,
                clientId: clientId,
                searchInput: this.props.searchInput,
                highlightSearch: this.props.highlightSearch
              }), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_actions__WEBPACK_IMPORTED_MODULE_4__["default"], {
                actions: actions,
                onAction: onAction,
                id: _id,
                readOnly: readOnly
              }), !this.props.searchInput && react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_toggle__WEBPACK_IMPORTED_MODULE_6__["default"], {
                isLeaf: isLeaf(_children),
                expanded: expanded,
                id: _id,
                onNodeToggle: onNodeToggle
              }));
            }
          }]);

          return TreeNode;
        }(react__WEBPACK_IMPORTED_MODULE_2__["PureComponent"]);

        TreeNode.propTypes = {
          _id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          _depth: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
          _children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array,
          actions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array,
          className: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          checked: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          expanded: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          partial: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          dataset: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
          keepTreeOnSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          keepChildrenOnSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          searchModeOn: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onNodeToggle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onAction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onCheckboxChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          mode: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['multiSelect', 'simpleSelect', 'radioSelect', 'hierarchical']),
          showPartiallySelected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          clientId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          searchInput: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          highlightSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
        };
        /* harmony default export */

        __webpack_exports__["default"] = TreeNode;
        /***/
      },

      /***/
      "./src/tree-node/node-label.js":
      /*!*************************************!*\
        !*** ./src/tree-node/node-label.js ***!
        \*************************************/

      /*! exports provided: default */

      /***/
      function srcTreeNodeNodeLabelJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! classnames/bind */
        "./node_modules/classnames/bind.js");
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../checkbox */
        "./src/checkbox/index.js");
        /* harmony import */


        var _radio__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ../radio */
        "./src/radio/index.js");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./index.css */
        "./src/tree-node/index.css");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_5__);

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default.a.bind(_index_css__WEBPACK_IMPORTED_MODULE_5___default.a);

        var NodeLabel = function (_PureComponent) {
          _inherits(NodeLabel, _PureComponent);

          function NodeLabel() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, NodeLabel);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NodeLabel.__proto__ || Object.getPrototypeOf(NodeLabel)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckboxChange = function (e) {
              var _this$props = _this.props,
                  mode = _this$props.mode,
                  id = _this$props.id,
                  onCheckboxChange = _this$props.onCheckboxChange;

              if (mode === 'simpleSelect' || mode === 'radioSelect') {
                onCheckboxChange(id, true);
              } else {
                var checked = e.target.checked;
                onCheckboxChange(id, checked);
              }

              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }

          _createClass(NodeLabel, [{
            key: 'getHighlightedText',
            value: function getHighlightedText(text, higlight) {
              var escapeRegExp = function escapeRegExp() {
                var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                return str.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
              };

              var parts = text.split(new RegExp('(' + escapeRegExp(higlight) + ')', 'i'));
              return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('span', null, parts.map(function (part, i) {
                return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('span', {
                  key: i,
                  style: part.toLowerCase() === higlight.toLowerCase() ? {
                    fontWeight: 'bold',
                    color: '#eb9110'
                  } : {}
                }, part);
              }));
            }
          }, {
            key: 'render',
            value: function render() {
              var _props = this.props,
                  mode = _props.mode,
                  title = _props.title,
                  label = _props.label,
                  id = _props.id,
                  partial = _props.partial,
                  checked = _props.checked;
              var _props2 = this.props,
                  value = _props2.value,
                  disabled = _props2.disabled,
                  showPartiallySelected = _props2.showPartiallySelected,
                  readOnly = _props2.readOnly,
                  clientId = _props2.clientId;
              var nodeLabelProps = {
                className: 'node-label' // in case of simple select mode, there is no checkbox, so we need to handle the click via the node label
                // but not if the control is in readOnly or disabled state

              };
              var shouldRegisterClickHandler = mode === 'simpleSelect' && !readOnly && !disabled;

              if (shouldRegisterClickHandler) {
                nodeLabelProps.onClick = this.handleCheckboxChange;
              }

              var sharedProps = {
                id: id,
                value: value,
                checked: checked,
                disabled: disabled,
                readOnly: readOnly,
                tabIndex: -1
              };
              return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('label', {
                title: title || label,
                htmlFor: id
              }, mode === 'radioSelect' ? react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_radio__WEBPACK_IMPORTED_MODULE_4__["default"], _extends({
                name: clientId,
                className: 'radio-item',
                onChange: this.handleCheckboxChange
              }, sharedProps)) : react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_checkbox__WEBPACK_IMPORTED_MODULE_3__["default"], _extends({
                name: id,
                className: cx('checkbox-item', {
                  'simple-select': mode === 'simpleSelect'
                }),
                indeterminate: showPartiallySelected && partial,
                onChange: this.handleCheckboxChange
              }, sharedProps)), react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('span', nodeLabelProps, this.props.highlightSearch ? this.getHighlightedText(label, this.props.searchInput) : label));
            }
          }]);

          return NodeLabel;
        }(react__WEBPACK_IMPORTED_MODULE_2__["PureComponent"]);

        NodeLabel.propTypes = {
          id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          actions: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array,
          title: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          value: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string.isRequired,
          checked: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          partial: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          dataset: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
          mode: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['multiSelect', 'simpleSelect', 'radioSelect', 'hierarchical']),
          showPartiallySelected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onCheckboxChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          clientId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          searchInput: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          highlightSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool
        };
        /* harmony default export */

        __webpack_exports__["default"] = NodeLabel;
        /***/
      },

      /***/
      "./src/tree-node/toggle.js":
      /*!*********************************!*\
        !*** ./src/tree-node/toggle.js ***!
        \*********************************/

      /*! exports provided: default */

      /***/
      function srcTreeNodeToggleJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! classnames/bind */
        "./node_modules/classnames/bind.js");
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./index.css */
        "./src/tree-node/index.css");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_3___default =
        /*#__PURE__*/
        __webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_3__);

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_0___default.a.bind(_index_css__WEBPACK_IMPORTED_MODULE_3___default.a);

        var Toggle = function (_PureComponent) {
          _inherits(Toggle, _PureComponent);

          function Toggle() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, Toggle);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Toggle.__proto__ || Object.getPrototypeOf(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.onToggle = function (e) {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();

              _this.props.onNodeToggle(_this.props.id);
            }, _this.onKeyDown = function (e) {
              if (e.key === 'Enter' || e.keyCode === 32) {
                _this.props.onNodeToggle(_this.props.id);

                e.preventDefault();
              }
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }

          _createClass(Toggle, [{
            key: 'render',
            value: function render() {
              var _props = this.props,
                  expanded = _props.expanded,
                  isLeaf = _props.isLeaf;
              if (isLeaf) return null;
              var toggleCx = cx('toggle', {
                expanded: expanded,
                collapsed: !expanded
              });
              return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('i', {
                role: 'button',
                tabIndex: -1,
                className: toggleCx,
                onClick: this.onToggle,
                onKeyDown: this.onKeyDown,
                'aria-hidden': true
              });
            }
          }]);

          return Toggle;
        }(react__WEBPACK_IMPORTED_MODULE_2__["PureComponent"]);

        Toggle.propTypes = {
          expanded: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          isLeaf: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onNodeToggle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          id: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
        };
        /* harmony default export */

        __webpack_exports__["default"] = Toggle;
        /***/
      },

      /***/
      "./src/tree/index.js":
      /*!***************************!*\
        !*** ./src/tree/index.js ***!
        \***************************/

      /*! exports provided: default */

      /***/
      function srcTreeIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react-infinite-scroll-component */
        "./node_modules/react-infinite-scroll-component/lib/index.js");
        /* harmony import */


        var react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _tree_node__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../tree-node */
        "./src/tree-node/index.js");

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var shouldRenderNode = function shouldRenderNode(node, searchModeOn, data) {
          if (searchModeOn || node.expanded) return true;
          var parent = node._parent && data.get(node._parent); // if it has a parent, then check parent's state.
          // otherwise root nodes are always rendered

          return !parent || parent.expanded;
        };

        var Tree = function (_Component) {
          _inherits(Tree, _Component);

          function Tree(props) {
            _classCallCheck(this, Tree);

            var _this = _possibleConstructorReturn(this, (Tree.__proto__ || Object.getPrototypeOf(Tree)).call(this, props));

            _initialiseProps.call(_this);

            _this.currentPage = 1;

            _this.computeInstanceProps(props, true);

            _this.state = {
              items: _this.allVisibleNodes.slice(0, _this.props.pageSize)
            };
            return _this;
          }

          _createClass(Tree, [{
            key: 'render',
            value: function render() {
              var _props = this.props,
                  searchModeOn = _props.searchModeOn,
                  onBlur = _props.onBlur;
              return react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('ul', _extends({
                className: 'root ' + (searchModeOn ? 'searchModeOn' : ''),
                ref: this.setNodeRef
              }, this.getAriaAttributes()), this.props.prependElement && this.props.prependElement, this.state.scrollableTarget && react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(react_infinite_scroll_component__WEBPACK_IMPORTED_MODULE_0___default.a, {
                dataLength: this.state.items.length,
                next: this.loadMore,
                hasMore: this.hasMore(),
                loader: react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement('span', {
                  className: 'searchLoader'
                }, 'Loading...'),
                scrollableTarget: this.state.scrollableTarget,
                height: this.props.scrollHeight,
                onBlur: onBlur
              }, this.state.items));
            }
          }]);

          return Tree;
        }(react__WEBPACK_IMPORTED_MODULE_2__["Component"]);

        Tree.propTypes = {
          data: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
          keepTreeOnSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          keepChildrenOnSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          searchModeOn: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onNodeToggle: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onAction: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          onCheckboxChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          mode: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['multiSelect', 'simpleSelect', 'radioSelect', 'hierarchical']),
          showPartiallySelected: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          pageSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          clientId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          activeDescendant: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          searchInput: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          prependElement: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node,
          highlightSearch: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          onNodeHover: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          scrollHeight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number,
          onBlur: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func
        };
        Tree.defaultProps = {
          pageSize: 100
        };

        var _initialiseProps = function _initialiseProps() {
          var _this2 = this;

          this.componentWillReceiveProps = function (nextProps) {
            var activeDescendant = nextProps.activeDescendant,
                scrollToElement = nextProps.scrollToElement;
            var hasSameActiveDescendant = activeDescendant === _this2.props.activeDescendant;

            _this2.computeInstanceProps(nextProps, !hasSameActiveDescendant);

            _this2.setState({
              items: _this2.allVisibleNodes.slice(0, _this2.currentPage * _this2.props.pageSize)
            }, function () {
              var scrollableTarget = _this2.state.scrollableTarget;

              if (!_this2.props.scrollToElement && scrollToElement && document) {
                var domElement = document.getElementById(scrollToElement._id);

                if (domElement) {
                  scrollableTarget.scrollTop = domElement.parentNode.offsetTop - (scrollableTarget.clientHeight - domElement.parentNode.clientHeight) / 2;
                }
              }

              if (hasSameActiveDescendant) return;
              var activeLi = activeDescendant && document && document.getElementById(activeDescendant);

              if (scrollableTarget && activeLi) {
                scrollableTarget.scrollTop = activeLi.offsetTop - (scrollableTarget.clientHeight - activeLi.clientHeight) / 2;
              }
            });
          };

          this.componentDidMount = function () {
            _this2.setState({
              scrollableTarget: _this2.node.parentNode
            });
          };

          this.computeInstanceProps = function (props, checkActiveDescendant) {
            _this2.allVisibleNodes = _this2.getNodes(props);
            _this2.totalPages = Math.ceil(_this2.allVisibleNodes.length / _this2.props.pageSize);

            if (checkActiveDescendant && props.activeDescendant) {
              var currentId = props.activeDescendant.replace(/_li$/, '');
              var focusIndex = _this2.allVisibleNodes.findIndex(function (n) {
                return n.key === currentId;
              }) + 1;
              _this2.currentPage = focusIndex > 0 ? Math.ceil(focusIndex / _this2.props.pageSize) : 1;
            }
          };

          this.getNodes = function (props) {
            var data = props.data,
                keepTreeOnSearch = props.keepTreeOnSearch,
                keepChildrenOnSearch = props.keepChildrenOnSearch,
                searchModeOn = props.searchModeOn,
                mode = props.mode,
                showPartiallySelected = props.showPartiallySelected,
                readOnly = props.readOnly,
                onAction = props.onAction,
                onChange = props.onChange,
                onCheckboxChange = props.onCheckboxChange,
                onNodeToggle = props.onNodeToggle,
                activeDescendant = props.activeDescendant,
                clientId = props.clientId;
            var items = [];
            data.forEach(function (node) {
              if (shouldRenderNode(node, searchModeOn, data)) {
                items.push(react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement(_tree_node__WEBPACK_IMPORTED_MODULE_3__["default"], _extends({
                  keepTreeOnSearch: keepTreeOnSearch,
                  keepChildrenOnSearch: keepChildrenOnSearch,
                  key: node._id
                }, node, {
                  searchModeOn: searchModeOn,
                  onChange: onChange,
                  onCheckboxChange: onCheckboxChange,
                  onNodeToggle: onNodeToggle,
                  onAction: onAction,
                  mode: mode,
                  showPartiallySelected: showPartiallySelected,
                  readOnly: readOnly,
                  clientId: clientId,
                  activeDescendant: activeDescendant,
                  searchInput: _this2.props.searchInput,
                  highlightSearch: _this2.props.highlightSearch,
                  onNodeHover: _this2.props.onNodeHover
                })));
              }
            });
            return items;
          };

          this.hasMore = function () {
            return _this2.currentPage < _this2.totalPages;
          };

          this.loadMore = function () {
            _this2.currentPage = _this2.currentPage + 1;

            var nextItems = _this2.allVisibleNodes.slice(0, _this2.currentPage * _this2.props.pageSize);

            _this2.setState({
              items: nextItems
            });
          };

          this.setNodeRef = function (node) {
            _this2.node = node;
          };

          this.getAriaAttributes = function () {
            var mode = _this2.props.mode;
            var attributes = {
              /* https://www.w3.org/TR/wai-aria-1.1/#select
               * https://www.w3.org/TR/wai-aria-1.1/#tree */
              role: mode === 'simpleSelect' ? 'listbox' : 'tree',
              'aria-multiselectable': /multiSelect|hierarchical/.test(mode)
            };
            return attributes;
          };
        };
        /* harmony default export */


        __webpack_exports__["default"] = Tree;
        /***/
      },

      /***/
      "./src/trigger/index.js":
      /*!******************************!*\
        !*** ./src/trigger/index.js ***!
        \******************************/

      /*! exports provided: default */

      /***/
      function srcTriggerIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! react */
        "react");
        /* harmony import */


        var react__WEBPACK_IMPORTED_MODULE_0___default =
        /*#__PURE__*/
        __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! prop-types */
        "./node_modules/prop-types/index.js");
        /* harmony import */


        var prop_types__WEBPACK_IMPORTED_MODULE_1___default =
        /*#__PURE__*/
        __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! classnames/bind */
        "./node_modules/classnames/bind.js");
        /* harmony import */


        var classnames_bind__WEBPACK_IMPORTED_MODULE_2___default =
        /*#__PURE__*/
        __webpack_require__.n(classnames_bind__WEBPACK_IMPORTED_MODULE_2__);
        /* harmony import */


        var _a11y__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ../a11y */
        "./src/a11y/index.js");
        /* harmony import */


        var _tag__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ../tag */
        "./src/tag/index.js");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ../index.css */
        "./src/index.css");
        /* harmony import */


        var _index_css__WEBPACK_IMPORTED_MODULE_5___default =
        /*#__PURE__*/
        __webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_5__);

        var _extends = Object.assign || function (target) {
          for (var i = 1; i < arguments.length; i++) {
            var source = arguments[i];

            for (var key in source) {
              if (Object.prototype.hasOwnProperty.call(source, key)) {
                target[key] = source[key];
              }
            }
          }

          return target;
        };

        var _createClass = function () {
          function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
              var descriptor = props[i];
              descriptor.enumerable = descriptor.enumerable || false;
              descriptor.configurable = true;
              if ("value" in descriptor) descriptor.writable = true;
              Object.defineProperty(target, descriptor.key, descriptor);
            }
          }

          return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
          };
        }();

        function _classCallCheck(instance, Constructor) {
          if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
          }
        }

        function _possibleConstructorReturn(self, call) {
          if (!self) {
            throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
          }

          return call && (typeof call === "object" || typeof call === "function") ? call : self;
        }

        function _inherits(subClass, superClass) {
          if (typeof superClass !== "function" && superClass !== null) {
            throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
          }

          subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
              value: subClass,
              enumerable: false,
              writable: true,
              configurable: true
            }
          });
          if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
        }

        var cx = classnames_bind__WEBPACK_IMPORTED_MODULE_2___default.a.bind(_index_css__WEBPACK_IMPORTED_MODULE_5___default.a);

        var Trigger = function (_PureComponent) {
          _inherits(Trigger, _PureComponent);

          function Trigger() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, Trigger);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Trigger.__proto__ || Object.getPrototypeOf(Trigger)).call.apply(_ref, [this].concat(args))), _this), _this.getAriaAttributes = function () {
              var _this$props = _this.props,
                  mode = _this$props.mode,
                  _this$props$texts = _this$props.texts,
                  texts = _this$props$texts === undefined ? {} : _this$props$texts,
                  showDropdown = _this$props.showDropdown,
                  clientId = _this$props.clientId,
                  tags = _this$props.tags;
              var triggerId = clientId + '_trigger';
              var labelledBy = [];
              var labelAttributes = Object(_a11y__WEBPACK_IMPORTED_MODULE_3__["getAriaLabel"])(texts.label);

              if (tags && tags.length) {
                if (labelAttributes['aria-label']) {
                  // Adds reference to self when having aria-label
                  labelledBy.push(triggerId);
                }

                tags.forEach(function (t) {
                  labelledBy.push(Object(_tag__WEBPACK_IMPORTED_MODULE_4__["getTagId"])(t._id));
                });
                labelAttributes = Object(_a11y__WEBPACK_IMPORTED_MODULE_3__["getAriaLabel"])(texts.label, labelledBy.join(' '));
              }

              var attributes = _extends({
                id: triggerId,
                role: 'button',
                tabIndex: 0,
                'aria-haspopup': mode === 'simpleSelect' ? 'listbox' : 'tree',
                'aria-expanded': showDropdown ? 'true' : 'false'
              }, labelAttributes);

              return attributes;
            }, _this.handleTrigger = function (e) {
              // Just return if triggered from keyDown and the key isn't enter, space or arrow down
              if (e.key && e.keyCode !== 13 && e.keyCode !== 32 && e.keyCode !== 40) {
                return;
              } else if (e.key && _this.triggerNode && _this.triggerNode !== document.activeElement) {
                // Do not trigger if not activeElement
                return;
              } else if (!_this.props.showDropdown && e.keyCode === 32) {
                // Avoid adding space to input on open
                e.preventDefault();
              } // Else this is a key press that should trigger the dropdown


              _this.props.onTrigger(e);
            }, _temp), _possibleConstructorReturn(_this, _ret);
          }

          _createClass(Trigger, [{
            key: 'render',
            value: function render() {
              var _this2 = this;

              var _props = this.props,
                  disabled = _props.disabled,
                  readOnly = _props.readOnly,
                  showDropdown = _props.showDropdown;
              var dropdownTriggerClassname = cx({
                'dropdown-trigger': true,
                arrow: true,
                disabled: disabled,
                readOnly: readOnly,
                top: showDropdown,
                bottom: !showDropdown
              });
              return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement('a', _extends({
                ref: function ref(node) {
                  _this2.triggerNode = node;
                },
                className: dropdownTriggerClassname,
                onClick: !disabled ? this.handleTrigger : undefined,
                onKeyDown: !disabled ? this.handleTrigger : undefined
              }, this.getAriaAttributes()), this.props.children);
            }
          }]);

          return Trigger;
        }(react__WEBPACK_IMPORTED_MODULE_0__["PureComponent"]);

        Trigger.propTypes = {
          onTrigger: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
          disabled: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          readOnly: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          showDropdown: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
          mode: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['multiSelect', 'simpleSelect', 'radioSelect', 'hierarchical']),
          texts: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object,
          clientId: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string,
          tags: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.array
        };
        /* harmony default export */

        __webpack_exports__["default"] = Trigger;
        /***/
      },

      /***/
      "./src/utils/dataset.js":
      /*!******************************!*\
        !*** ./src/utils/dataset.js ***!
        \******************************/

      /*! exports provided: default */

      /***/
      function srcUtilsDatasetJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var toKebabCase = function toKebabCase(str) {
          return str.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
        };

        var getDataset = function getDataset() {
          var o = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          return Object.keys(o).reduce(function (acc, cur) {
            acc['data-' + toKebabCase(cur)] = o[cur];
            return acc;
          }, {});
        };
        /* harmony default export */


        __webpack_exports__["default"] = getDataset;
        /***/
      },

      /***/
      "./src/utils/debounce.js":
      /*!*******************************!*\
        !*** ./src/utils/debounce.js ***!
        \*******************************/

      /*! exports provided: default */

      /***/
      function srcUtilsDebounceJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /**
         * Modified debounce that always invokes on leading edge
         * See unmodified: https://gist.github.com/mrchief/a7e8938ee96774f05644905b37f09536
         */

        /* harmony default export */


        __webpack_exports__["default"] = function (func, wait) {
          var timeout = void 0;
          return function () {
            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }

            var later = function later() {
              timeout = null;
              func.apply(undefined, args);
            }; // timeout will be undefined the first time (leading edge)
            // so the callback will get executed once on leading edge


            var callNow = !timeout;
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
            if (callNow) func.apply(undefined, args);
          };
        };
        /***/

      },

      /***/
      "./src/utils/generateUID.js":
      /*!**********************************!*\
        !*** ./src/utils/generateUID.js ***!
        \**********************************/

      /*! exports provided: default */

      /***/
      function srcUtilsGenerateUIDJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var generateUID = function generateUID(prefix) {
          var counter = 1;
          var map = new WeakMap();

          var get = function get(item) {
            if (!map.has(item)) {
              map.set(item, counter++);
            }

            return '' + prefix + map.get(item);
          };

          var reset = function reset() {
            map = new WeakMap();
            counter = 1;
          };

          return {
            get: get,
            reset: reset
          };
        };

        var clientIdGenerator = generateUID('rdts');
        /* harmony default export */

        __webpack_exports__["default"] = clientIdGenerator;
        /***/
      },

      /***/
      "./src/utils/index.js":
      /*!****************************!*\
        !*** ./src/utils/index.js ***!
        \****************************/

      /*! exports provided: getDataset, mapToObject, isEmpty, isOutsideClick, debounce, clientIdGenerator */

      /***/
      function srcUtilsIndexJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /* harmony import */


        var _dataset__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(
        /*! ./dataset */
        "./src/utils/dataset.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "getDataset", function () {
          return _dataset__WEBPACK_IMPORTED_MODULE_0__["default"];
        });
        /* harmony import */


        var _mapToObject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(
        /*! ./mapToObject */
        "./src/utils/mapToObject.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "mapToObject", function () {
          return _mapToObject__WEBPACK_IMPORTED_MODULE_1__["default"];
        });
        /* harmony import */


        var _isEmpty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(
        /*! ./isEmpty */
        "./src/utils/isEmpty.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "isEmpty", function () {
          return _isEmpty__WEBPACK_IMPORTED_MODULE_2__["default"];
        });
        /* harmony import */


        var _isOutsideClick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(
        /*! ./isOutsideClick */
        "./src/utils/isOutsideClick.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "isOutsideClick", function () {
          return _isOutsideClick__WEBPACK_IMPORTED_MODULE_3__["default"];
        });
        /* harmony import */


        var _debounce__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(
        /*! ./debounce */
        "./src/utils/debounce.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "debounce", function () {
          return _debounce__WEBPACK_IMPORTED_MODULE_4__["default"];
        });
        /* harmony import */


        var _generateUID__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(
        /*! ./generateUID */
        "./src/utils/generateUID.js");
        /* harmony reexport (safe) */


        __webpack_require__.d(__webpack_exports__, "clientIdGenerator", function () {
          return _generateUID__WEBPACK_IMPORTED_MODULE_5__["default"];
        });
        /***/

      },

      /***/
      "./src/utils/isEmpty.js":
      /*!******************************!*\
        !*** ./src/utils/isEmpty.js ***!
        \******************************/

      /*! exports provided: default */

      /***/
      function srcUtilsIsEmptyJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);
        /**
         * Simplified implmentation of isEmpty.
         * Note: This is not complete and will return false positives for empty objects and likes.
         * However, it suffices for the limited use-case of this project.
         */


        var isEmpty = function isEmpty(o) {
          return !o || Array.isArray(o) && !o.length;
        };
        /* harmony default export */


        __webpack_exports__["default"] = isEmpty;
        /***/
      },

      /***/
      "./src/utils/isOutsideClick.js":
      /*!*************************************!*\
        !*** ./src/utils/isOutsideClick.js ***!
        \*************************************/

      /*! exports provided: default */

      /***/
      function srcUtilsIsOutsideClickJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var getPath = function getPath(e) {
          if (e.path) return e.path;
          var elem = e.target;
          var path = [elem];

          while (elem.parentElement) {
            elem = elem.parentElement;
            path.unshift(elem);
          }

          return path;
        };
        /* harmony default export */


        __webpack_exports__["default"] = function (e, node) {
          if (!(e instanceof Event)) return false;
          return !getPath(e).some(function (eventNode) {
            return eventNode === node;
          });
        };
        /***/

      },

      /***/
      "./src/utils/mapToObject.js":
      /*!**********************************!*\
        !*** ./src/utils/mapToObject.js ***!
        \**********************************/

      /*! exports provided: default */

      /***/
      function srcUtilsMapToObjectJs(module, __webpack_exports__, __webpack_require__) {
        "use strict";

        __webpack_require__.r(__webpack_exports__);

        var _slicedToArray = function () {
          function sliceIterator(arr, i) {
            var _arr = [];
            var _n = true;
            var _d = false;
            var _e = undefined;

            try {
              for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
                _arr.push(_s.value);

                if (i && _arr.length === i) break;
              }
            } catch (err) {
              _d = true;
              _e = err;
            } finally {
              try {
                if (!_n && _i["return"]) _i["return"]();
              } finally {
                if (_d) throw _e;
              }
            }

            return _arr;
          }

          return function (arr, i) {
            if (Array.isArray(arr)) {
              return arr;
            } else if (Symbol.iterator in Object(arr)) {
              return sliceIterator(arr, i);
            } else {
              throw new TypeError("Invalid attempt to destructure non-iterable instance");
            }
          };
        }();

        var mapToObject = function mapToObject(map) {
          var obj = Object.create(null); // eslint-disable-next-line no-restricted-syntax

          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = map[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var _step$value = _slicedToArray(_step.value, 2),
                  k = _step$value[0],
                  v = _step$value[1]; // We don’t escape the key '__proto__'
              // which can cause problems on older engines


              obj[k] = v;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          return obj;
        };
        /* harmony default export */


        __webpack_exports__["default"] = mapToObject;
        /***/
      },

      /***/
      "react":
      /*!**************************************************************************************!*\
        !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
        \**************************************************************************************/

      /*! no static exports found */

      /***/
      function react(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/
      }
      /******/

    })
  );
});